var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import privacyImage from "./assets/privacy.svg";
var HIGHMARK_COMMON_ASSETS_MAP = {
  HIGHMARK_PRIVACY_IMAGE: privacyImage
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(HIGHMARK_COMMON_ASSETS_MAP);
};

// src/common/asset-config.ts
import GARBAGE_BIN from "./assets/garbage-bin.svg";
import HEADER_BACKGROUND from "./assets/header-background.svg";
var GarbageBin = GARBAGE_BIN;
var JourneyHeaderBackground = HEADER_BACKGROUND;

// src/highmark-common.config.ts
var highmarkCommonConfig = {};
var highmarkCommon = {
  config(config) {
    highmarkCommonConfig = __spreadValues(__spreadValues({}, highmarkCommonConfig), config);
  },
  getConfig() {
    if (!highmarkCommonConfig)
      throw new Error(
        "Highmark Common: Configuration is not defined or initialized."
      );
    return highmarkCommonConfig;
  }
};

// src/common/highmark-live-chat-client.ts
import { v4 as uuidv4 } from "uuid";
import {
  ErrorTypes,
  EventTypes,
  ChatEndedReasonTypes
} from "@leagueplatform/live-chat";

// src/common/constants.ts
var QUERY_KEYS = /* @__PURE__ */ ((QUERY_KEYS2) => {
  QUERY_KEYS2["EBILL_ELIGIBILITY_KEY"] = "GET_EBILL_ELIGIBILITY";
  QUERY_KEYS2["HSA_ELIGIBILITY_KEY"] = "GET_HSA_ELIGIBILITY";
  return QUERY_KEYS2;
})(QUERY_KEYS || {});
var DEFAULT_PARTNER_ID = "highmark";
var AUTH0_CLIENT_CONNECTION = "highmark";
var APP_NAV_DEFAULT_HEIGHT = 8 * 7;
var APP_NAV_MOBILE_HEIGHT = APP_NAV_DEFAULT_HEIGHT * 2;
var SENTRY_CONSTANTS = {
  OWNERSHIP_TEAM: "highmark-solutions"
};
var AUTH0_ERROR_TYPES = {
  LOGIN_REQUIRED: "login_required"
};
var FEATURE_FLAGS = /* @__PURE__ */ ((FEATURE_FLAGS2) => {
  FEATURE_FLAGS2["PLACEHOLDER_FLAG"] = "do_not_use";
  FEATURE_FLAGS2["CLAIMS_SHOULD_SHOW_CLAIM_DETAILS"] = "rel_claims_shouldShowClaimDetails";
  FEATURE_FLAGS2["CLAIMS_SHOULD_SHOW_DOWNLOAD_CLAIMS"] = "rel_claims_shouldShowDownloadClaims";
  FEATURE_FLAGS2["CLAIMS_SHOULD_SHOW_FILTER_CHIPS"] = "rel_claims_shouldShowFilterChips";
  FEATURE_FLAGS2["USER_DROPDOWN_COBROWSE"] = "rel_hmrk_enableGlia";
  FEATURE_FLAGS2["LEGAL_PAGE"] = "rel_hmrk_legalPage";
  FEATURE_FLAGS2["CMS_CODE"] = "bus_hmrk_cmsCode";
  return FEATURE_FLAGS2;
})(FEATURE_FLAGS || {});
var MASONRY = {
  API_VERSION: 2,
  APP_ID_HOME_PAGE: "hm_homepage",
  APP_ID_SUPPORT_PAGE: "hm_support",
  APP_ID_CARE_DISCOVERY_HOME: "hm_care_homepage",
  MODULE_KEY_CUSTOM_WIDGETS: "highmark",
  MODULE_KEY_CLAIMS: "claims",
  MODULE_KEY_HEALTH_JOURNEY: "health_journey",
  CUSTOM_WIDGET_TYPE_EBILL: "hm_ebill",
  CUSTOM_WIDGET_TYPE_HEALTH_JOURNEY: "health_journey",
  CUSTOM_WIDGET_TYPE_PENDING_HSA: "hm_pending_hsa_banner",
  CUSTOM_WIDGET_TYPE_PRE_EFFECTUATED_BANNER: "hm_pre_effectuated_banner",
  CUSTOM_WIDGET_TYPE_PRE_EFFECTIVE_BANNER: "hm_pre_effective_banner",
  CUSTOM_WIDGET_TYPE_CLAIMS: "recent_claims_cards",
  CUSTOM_WIDGET_REWARD_PROGRAM_CAROUSEL: "reward_programs_carousel"
};
var LEGAL_DETAILS_QUERY_PARAM_KEY = "id";

// src/utils/class-identity-token.ts
import { getPartnerAccessToken } from "@leagueplatform/sso-util";
var IdentityToken = class {
  constructor(partnerId) {
    this.token = null;
    this.tokenRefresh = null;
    this.token = null;
    this.partnerId = partnerId;
    this.tokenRefresh = null;
  }
  fetchToken() {
    return __async(this, null, function* () {
      try {
        const newToken = yield getPartnerAccessToken(this.partnerId);
        if (newToken) {
          this.token = newToken;
        }
      } catch (err) {
        throw new Error(err);
      }
    });
  }
  keepTokenFresh() {
    return __async(this, null, function* () {
      yield this.fetchToken();
      if (this.tokenRefresh) {
        clearTimeout(this.tokenRefresh);
      }
      this.tokenRefresh = setTimeout(this.keepTokenFresh.bind(this), 27e5);
    });
  }
  getToken() {
    return __async(this, null, function* () {
      if (this.token) {
        return this.token;
      }
      yield this.keepTokenFresh();
      return this.token;
    });
  }
};

// engen-chat-sdk/internal/chat-instance/chat-instance.js
import { Subject } from "rxjs";
var ChatInstance = class {
  constructor() {
    this.currentMsgId = 0;
    this.sentMessages = [];
    this.onChatStart$ = new Subject();
    this.onChatEnd$ = new Subject();
    this.onStatusChange$ = new Subject();
    this.onTransferRequest$ = new Subject();
    this.onParticipantJoin$ = new Subject();
    this.onParticipantLeave$ = new Subject();
    this.onIsTyping$ = new Subject();
    this.onNewMessage$ = new Subject();
    this.onMessageAcknowledgement$ = new Subject();
    this.onError$ = new Subject();
    this.onProviderTransfer$ = new Subject();
    this.transferInProgress = false;
  }
  observableEvents() {
    return {
      onChatStart$: this.onChatStart$.asObservable(),
      onChatEnd$: this.onChatEnd$.asObservable(),
      onStatusChange$: this.onStatusChange$.asObservable(),
      onTransferRequest$: this.onTransferRequest$.asObservable(),
      onParticipantJoin$: this.onParticipantJoin$.asObservable(),
      onParticipantLeave$: this.onParticipantLeave$.asObservable(),
      onIsTyping$: this.onIsTyping$.asObservable(),
      onNewMessage$: this.onNewMessage$.asObservable(),
      onMessageAcknowledgement$: this.onMessageAcknowledgement$.asObservable(),
      onError$: this.onError$.asObservable()
    };
  }
  emitError(code, message, endChat = false, error) {
    this.onError$.next({
      code,
      message,
      endChat,
      error
    });
  }
  emitStatusChange(provider, connectionStatus) {
    this.currentState = connectionStatus;
    this.onStatusChange$.next({
      provider,
      connectionStatus,
      timestamp: /* @__PURE__ */ new Date()
    });
  }
  emitParticipantJoin(provider, participant) {
    this.onParticipantJoin$.next({
      participant,
      provider,
      timestamp: /* @__PURE__ */ new Date()
    });
  }
  emitIsTyping(participant) {
    this.onIsTyping$.next({
      participant,
      isTyping: true,
      timestamp: /* @__PURE__ */ new Date()
    });
  }
  emitMessageAcknowledge(id, status) {
    this.onMessageAcknowledgement$.next({ id: id.toString(), status });
    this.sentMessages[id].ackInfo = status;
  }
  emitNewMessage(provider, participant, messages) {
    const timestamp = /* @__PURE__ */ new Date();
    this.onNewMessage$.next({
      messages,
      provider,
      participant,
      timestamp
    });
  }
  emitParticipantLeave(provider, participant) {
    this.onParticipantLeave$.next({
      participant,
      provider,
      timestamp: /* @__PURE__ */ new Date()
    });
  }
  emitTransferRequestInternal(transferTo) {
    this.onTransferRequest$.next({
      type: "INTERNAL",
      transferTo,
      timestamp: /* @__PURE__ */ new Date()
    });
  }
  emitTransferRequestProvider(transferData) {
    this.transferInProgress = true;
    this.onTransferRequest$.next({
      type: "PROVIDER",
      transferTo: transferData.transferToProviderId,
      timestamp: /* @__PURE__ */ new Date()
    });
    this.onProviderTransfer$.next(transferData);
  }
  emitChatStart() {
    if (!this.transferInProgress) {
      this.onChatStart$.next(/* @__PURE__ */ new Date());
    } else {
      this.transferInProgress = false;
    }
  }
  emitChatEnd(origin) {
    this.onChatEnd$.next({
      origin,
      timestamp: /* @__PURE__ */ new Date()
    });
  }
  getCurrentChatState() {
    return this.currentState;
  }
  getCurrentMessageId() {
    return this.currentMsgId;
  }
  incrementMessageId() {
    this.currentMsgId++;
  }
  addToSentMessages(data) {
    this.sentMessages.push({
      data,
      ackInfo: "NOT DELIVERED",
      resent: false
    });
  }
  getTransferInProgress() {
    return this.transferInProgress;
  }
  transferCanceled() {
    this.transferInProgress = false;
  }
  getSentMessages() {
    return this.sentMessages;
  }
  getProviderTransferEvent() {
    return this.onProviderTransfer$.asObservable();
  }
};

// engen-chat-sdk/internal/user-info/user-info.js
var UserInfo = class {
};

// engen-chat-sdk/internal/rest/rest.js
function restRequest(url, method, body, token) {
  return __async(this, null, function* () {
    const rawResponse = yield fetch(url, {
      headers: Object.assign(
        { Accept: "application/json", "Content-Type": "application/json" },
        token && { Authorization: "Bearer " + token }
      ),
      method,
      body: JSON.stringify(body)
    });
    if (!rawResponse.ok) {
      throw Error("bad response");
    }
    const response = yield rawResponse.json();
    return response;
  });
}

// engen-chat-sdk/providers/avaya/models/requests-model.js
function requestChatMessage(member, contextId, reqForm, avayaTeam, avayaReason) {
  return {
    method: "requestChat",
    deviceType: navigator.userAgent,
    routePointIdentifier: "Default",
    workFlowType: "",
    requestTranscript: false,
    workRequestId: contextId,
    calledParty: window.location.href,
    leaseTime: 1,
    intrinsics: {
      channelAttribute: "Chat",
      textDirection: document.dir.toUpperCase(),
      attributes: [avayaTeam, avayaReason],
      email: reqForm.emailAddress,
      name: member.firstName,
      lastName: member.lastName,
      phoneNumber: member.phoneNumber,
      customFields: []
    },
    priority: 1,
    customData: {}
  };
}

// engen-chat-sdk/core/models/events-models.js
var StatusTypes;
(function(StatusTypes2) {
  StatusTypes2["UNAVAILABLE"] = "UNAVAILABLE";
  StatusTypes2["READY"] = "READY";
  StatusTypes2["CONNECTING"] = "CONNECTING";
  StatusTypes2["QUEUED"] = "QUEUED";
  StatusTypes2["CONNECTED"] = "CONNECTED";
  StatusTypes2["DISCONNECTED"] = "DISCONNECTED";
  StatusTypes2["ERROR"] = "ERROR";
  StatusTypes2["RECONNECTING"] = "RECONNECTING";
})(StatusTypes || (StatusTypes = {}));

// engen-chat-sdk/providers/provider-abstract.js
var Provider = class {
  constructor(session) {
    this.providerIdentifier = {
      providerId: "",
      providerName: ""
    };
    this.providerConfig = void 0;
    this.ws = null;
    this.purposefulClose = false;
    this.creatingNewSocket = false;
    this.missedPongs = 0;
    this.userMsg = false;
    this.waitingOnMsgForAck = -1;
    this.msgQueue = [];
    this.isTyping = false;
    this.session = session;
  }
  startChat(token) {
    if (this.getConnectionStatus() !== WebSocket.CLOSED) {
      this.session.chatInstance.emitError(
        "CONNECTION_FAILURE",
        "Connection already exists."
      );
      return;
    } else if (this.providerConfig === void 0) {
      this.session.chatInstance.emitError(
        "PROVIDER_UNAVAILABLE",
        "Availability did not succeed."
      );
      return;
    }
    this.latestToken = token;
    this.session.chatInstance.emitStatusChange(
      this.providerIdentifier,
      StatusTypes.CONNECTING
    );
    this.establishConnection();
  }
  checkAvailability(token, providerId, request) {
    return __async(this, null, function* () {
      var _a;
      this.latestToken = token;
      this.providerIdentifier.providerId = providerId;
      let data;
      try {
        data = yield restRequest(
          `https://${this.session.config.environment}/digital/v1/chat/setup/${providerId}?version=${this.session.config.version}`,
          "POST",
          request,
          token
        );
      } catch (e) {
      }
      if (data === null || data === void 0 ? void 0 : data.isAvailable) {
        this.providerConfig = data.config;
        this.providerIdentifier = data.provider;
        this.providerGatewayData = data.data;
        return {
          isAvailable: data.isAvailable,
          unavailableReason: data.unavailableReason
        };
      }
      return {
        isAvailable: false,
        unavailableReason: (_a = data === null || data === void 0 ? void 0 : data.unavailableReason) !== null && _a !== void 0 ? _a : "BAD AVAILABILITY DATA"
      };
    });
  }
  closeChat() {
    this.purposefulClose = true;
    if (this.getConnectionStatus() !== WebSocket.CLOSED) {
      this.onChatClose();
      this.session.chatInstance.emitStatusChange(
        this.providerIdentifier,
        StatusTypes.DISCONNECTED
      );
      this.ws.close();
    } else if (this.session.chatInstance.getCurrentChatState() === StatusTypes.RECONNECTING) {
      this.endReconnect();
      this.session.chatInstance.emitStatusChange(
        this.providerIdentifier,
        StatusTypes.DISCONNECTED
      );
    }
  }
  sendIsTyping() {
    if (this.getConnectionStatus() === WebSocket.CLOSED) {
      this.session.chatInstance.emitError(
        "MESSAGE_SEND_FAILURE",
        "Web Socket is in closed state."
      );
      return;
    } else if (!this.isTyping) {
      this.sendIsTypingHandler();
      this.isTyping = true;
      setTimeout(
        () => this.isTyping = false,
        this.providerConfig.isTypingInterval
      );
    }
  }
  sendEvent(token, event) {
    this.latestToken = token;
    if (!event || !event.name) {
      this.session.chatInstance.emitError(
        "EVENT_SEND_FAILURE",
        "Invalid event."
      );
      return;
    }
    this.userMsg = true;
    this.sendEventHandler(event, token);
    this.session.chatInstance.incrementMessageId();
    return (this.session.chatInstance.getCurrentMessageId() - 1).toString();
  }
  sendMessage(token, text) {
    this.latestToken = token;
    if (!text) {
      this.session.chatInstance.emitError(
        "MESSAGE_SEND_FAILURE",
        "Invalid message."
      );
      return;
    } else if (text.length > this.providerConfig.messageCharacterLimit) {
      this.session.chatInstance.emitError(
        "MESSAGE_SEND_MAX_LENGTH",
        "Max message character length exceeded."
      );
      return;
    }
    this.userMsg = true;
    this.sendMessageHandler(text, token);
    this.session.chatInstance.incrementMessageId();
    return (this.session.chatInstance.getCurrentMessageId() - 1).toString();
  }
  getConnectionStatus() {
    if (!this.ws) {
      return WebSocket.CLOSED;
    }
    return this.ws.readyState;
  }
  establishConnection() {
    try {
      this.pongReceived = true;
      this.ws = new WebSocket(this.providerConfig.chatURL, this.latestToken);
      this.ws.onerror = (_error) => {
        this.ws.close();
      };
      this.ws.onopen = () => {
        this.setPingInterval();
        if (this.session.chatInstance.getCurrentChatState() !== StatusTypes.RECONNECTING) {
          this.session.chatInstance.emitChatStart();
          this.onInitiateChat();
          return;
        }
        this.endReconnect();
        this.onReconnectChat();
      };
      this.ws.onclose = () => {
        this.ws = null;
        window.clearInterval(this.pingInterval);
        if (this.purposefulClose || this.session.chatInstance.getCurrentChatState() === StatusTypes.DISCONNECTED || this.session.chatInstance.getCurrentChatState() === StatusTypes.ERROR) {
          this.endReconnect();
          return;
        } else if (this.session.chatInstance.getCurrentChatState() === StatusTypes.CONNECTING) {
          this.session.chatInstance.emitStatusChange(
            this.providerIdentifier,
            StatusTypes.DISCONNECTED
          );
          if (this.session.chatInstance.getTransferInProgress()) {
            this.session.chatInstance.emitError(
              "TRANSFER_PROVIDER_FAILURE",
              "Something went wrong transferring the chat.",
              true
            );
            this.session.chatInstance.transferCanceled();
          } else {
            this.session.chatInstance.emitError(
              "CONNECTION_FAILURE",
              "Something went wrong establishing the connection with the provider.",
              true
            );
          }
          this.session.chatInstance.emitChatEnd("ERROR");
          return;
        } else if (this.session.chatInstance.getCurrentChatState() !== StatusTypes.RECONNECTING && !this.creatingNewSocket) {
          this.session.chatInstance.emitError(
            "CONNECTION_LOST",
            "Websocket was closed abnormally."
          );
          this.setReconnectionTimeout();
        }
        this.creatingNewSocket = true;
      };
      this.ws.onmessage = (json) => {
        if (this.session.chatInstance.getCurrentChatState() === StatusTypes.RECONNECTING && this.reconnectInterval) {
          this.session.chatInstance.emitStatusChange(
            this.providerIdentifier,
            StatusTypes.CONNECTED
          );
          this.endReconnect();
          this.setPingInterval();
        }
        try {
          this.webSocketMessageHandler(json);
        } catch (e) {
          this.session.chatInstance.emitError(
            "GENERAL_ERROR",
            "BAD WEBSOCKET DATA",
            false,
            e
          );
        }
      };
    } catch (e) {
      this.session.chatInstance.emitError("CONNECTION_FAILURE", `${e}`);
      this.session.chatInstance.emitStatusChange(
        this.providerIdentifier,
        StatusTypes.DISCONNECTED
      );
    }
  }
  setPingInterval() {
    if (!this.providerConfig.supportsPingPong) {
      return;
    }
    this.pingInterval = window.setInterval(() => {
      this.sendPing();
      if (!this.pongReceived) {
        if (this.missedPongs < this.providerConfig.pingRetryLimit) {
          this.missedPongs++;
          return;
        }
        this.setReconnectionTimeout();
        this.session.chatInstance.emitError(
          "CONNECTION_LOST",
          "Ping retry limit exceeded."
        );
        window.clearInterval(this.pingInterval);
        return;
      }
      this.missedPongs = 0;
      this.pongReceived = false;
    }, this.providerConfig.pingInterval);
  }
  signalPongReceived() {
    this.pongReceived = true;
  }
  setReconnectionTimeout() {
    this.session.chatInstance.emitStatusChange(
      this.providerIdentifier,
      StatusTypes.RECONNECTING
    );
    this.reconnectTimeout = window.setTimeout(() => {
      var _a;
      this.session.chatInstance.emitStatusChange(
        this.providerIdentifier,
        StatusTypes.DISCONNECTED
      );
      this.session.chatInstance.emitError(
        "CONNECTION_FAILURE",
        "Could not reconnect"
      );
      window.clearInterval(this.reconnectInterval);
      (_a = this.ws) === null || _a === void 0 ? void 0 : _a.close();
      this.session.chatInstance.emitChatEnd("ERROR");
      this.session.chatInstance.emitStatusChange(
        this.providerIdentifier,
        StatusTypes.ERROR
      );
    }, this.providerConfig.reconnectionTimeout);
    this.reconnectInterval = window.setInterval(() => {
      if (this.creatingNewSocket) {
        this.session.chatInstance.emitStatusChange(
          this.providerIdentifier,
          StatusTypes.DISCONNECTED
        );
        this.session.chatInstance.emitError(
          "CONNECTION_FAILURE",
          "Could not reconnect"
        );
        this.endReconnect();
        this.session.chatInstance.emitChatEnd("ERROR");
        this.session.chatInstance.emitStatusChange(
          this.providerIdentifier,
          StatusTypes.ERROR
        );
      } else {
        this.sendPing();
      }
    }, 5e3);
  }
  endReconnect() {
    this.creatingNewSocket = false;
    window.clearTimeout(this.reconnectTimeout);
    window.clearInterval(this.reconnectInterval);
    this.reconnectInterval = null;
    this.reconnectTimeout = null;
  }
  sendToWebSocket(data) {
    if (this.userMsg) {
      this.session.chatInstance.addToSentMessages(data);
      this.sendUserMessage(this.session.chatInstance.getCurrentMessageId());
      this.userMsg = false;
      return;
    }
    if (this.getConnectionStatus() !== WebSocket.OPEN && this.getConnectionStatus() !== WebSocket.CLOSING) {
      this.session.chatInstance.emitError(
        "GENERAL_ERROR",
        "Websocket not in open state."
      );
      return;
    }
    this.ws.send(JSON.stringify(data));
  }
  sendUserMessage(msgId) {
    if (this.getConnectionStatus() !== WebSocket.OPEN) {
      this.session.chatInstance.emitError(
        "GENERAL_ERROR",
        "Websocket not in open state."
      );
      this.session.chatInstance.emitMessageAcknowledge(msgId, "ERROR");
      return;
    }
    const data = this.session.chatInstance.getSentMessages()[msgId].data;
    if (this.providerConfig.supportsProviderAcknowledgementsBySequence && this.providerConfig.supportsProviderMessageDelivered && this.waitingOnMsgForAck > -1) {
      this.msgQueue.push(msgId);
      return;
    }
    this.ws.send(JSON.stringify(data));
    this.waitingOnMsgForAck = msgId;
    if (!this.providerConfig.supportsProviderAcknowledgementsById && !this.providerConfig.supportsProviderAcknowledgementsBySequence && !this.providerConfig.supportsProviderMessageDelivered) {
      this.session.chatInstance.emitMessageAcknowledge(msgId, "UNSUPPORTED");
      return;
    }
    if (!this.providerConfig.providerAcknowledgementTimeout) {
      return;
    }
    setTimeout(() => {
      const msg = this.session.chatInstance.getSentMessages()[msgId];
      if (msg.ackInfo === "DELIVERED" || this.session.chatInstance.getCurrentChatState() === StatusTypes.DISCONNECTED) {
        return;
      } else if (msg.resent) {
        this.session.chatInstance.emitMessageAcknowledge(msgId, "ERROR");
        this.waitingOnMsgForAck = -1;
        return;
      }
      msg.resent = true;
      this.waitingOnMsgForAck = -1;
      this.sendUserMessage(msgId);
    }, this.providerConfig.providerAcknowledgementTimeout);
  }
  messageAcknowledgementReceived(msgId) {
    if (this.providerConfig.supportsProviderAcknowledgementsById && this.providerConfig.supportsProviderMessageDelivered) {
      this.session.chatInstance.emitMessageAcknowledge(msgId, "DELIVERED");
    } else if (this.providerConfig.supportsProviderAcknowledgementsBySequence && this.providerConfig.supportsProviderMessageDelivered && this.waitingOnMsgForAck >= 0) {
      const queuedMsgId = this.msgQueue.shift();
      this.session.chatInstance.emitMessageAcknowledge(
        this.waitingOnMsgForAck,
        "DELIVERED"
      );
      this.waitingOnMsgForAck = -1;
      if (queuedMsgId !== void 0) {
        this.sendUserMessage(queuedMsgId);
      }
    }
  }
};

// engen-chat-sdk/core/models/messages-models.js
var MessageText = class {
  constructor(text) {
    this.messageType = "TEXT";
    this.text = text;
  }
};
var MessageFileLink = class {
  constructor(file, link) {
    this.messageType = "FILE_LINK";
    this.file = file;
    this.link = link;
  }
};
var MessageUrl = class {
  constructor(link) {
    this.messageType = "URL";
    this.link = link;
  }
};

// engen-chat-sdk/providers/avaya/avaya-provider.js
var AvayaProvider = class extends Provider {
  constructor() {
    super(...arguments);
    this.agentNameIdMap = [];
    this.eventMapping = {
      newMessage: this._newMessage,
      isTyping: this._isTyping,
      error: this._error,
      newParticipant: this._newParticipant,
      participantLeave: this._participantLeave,
      requestChat: this._requestChat,
      newPushPageMessage: this._newPushPageMessage,
      newAgentFileTransfer: this._newAgentFileTransfer,
      closeConversation: this._closeConversation,
      routeCancel: this._routeCancel,
      pong: this.signalPongReceived
    };
  }
  onInitiateChat() {
    const message = requestChatMessage(
      {
        firstName: this.providerGatewayData.memberFirstName,
        lastName: this.providerGatewayData.memberLastName,
        phoneNumber: this.providerGatewayData.phoneNumber
      },
      this.providerGatewayData.contextId,
      {
        emailAddress: this.providerGatewayData.emailAddress
      },
      this.providerGatewayData.teamCode,
      this.providerGatewayData.reasonCode
    );
    this.send(message);
  }
  onReconnectChat() {
    this.send({
      method: "renewChat",
      guid: this.session.userInfo.guid,
      authenticationKey: this.session.userInfo.authenticationKey,
      requestFullTranscript: false
    });
  }
  sendMessageHandler(message) {
    this.send({
      method: "newMessage",
      message,
      type: "text",
      data: { message }
    });
  }
  sendIsTypingHandler() {
    this.send({
      method: "isTyping",
      isTyping: true
    });
  }
  sendPing() {
    this.send({ method: "ping" });
  }
  onChatClose() {
    this.send({ method: "closeConversation" });
  }
  sendEventHandler() {
  }
  onTransferResult() {
  }
  webSocketMessageHandler(json) {
    var _a;
    const msg = JSON.parse(json.data.toString());
    const actionName = (_a = msg.body) === null || _a === void 0 ? void 0 : _a.method;
    const eventHandler = this.eventMapping[actionName];
    if (!eventHandler) {
      this.session.chatInstance.emitError(
        "MESSAGE_RECEIVE_FAILURE",
        "Bad avaya message! Unsupported action!!"
      );
      return;
    }
    eventHandler.bind(this)(msg);
  }
  buildAvayaAvatar(name) {
    const avatarUrl = "https://cdn.highmark.com/content/chat/live-agent.png";
    const avatarLabel = `Customer Service Advocate Avatar: ${name}`;
    const urlContent = {
      source: "HREF",
      linkType: "EXTERNAL",
      value: avatarUrl
    };
    const image = { imageType: "URL", url: urlContent };
    return { icon: image, iconAltText: avatarLabel };
  }
  send(body) {
    this.sendToWebSocket({
      authToken: "",
      apiVersion: "1.0",
      type: "request",
      body
    });
  }
  _newParticipant({ body }) {
    const newParticipant = body;
    if (newParticipant.role !== "active_participant" && newParticipant.role !== "supervisor_barge") {
      return;
    }
    if (this.session.chatInstance.getCurrentChatState() === "QUEUED") {
      this.session.chatInstance.emitStatusChange(
        this.providerIdentifier,
        StatusTypes.CONNECTED
      );
      const message = [
        `Email: ${this.providerGatewayData.emailAddress}`,
        `UMI of member signed in: ${this.providerGatewayData.umi}`,
        `DOB of member signed in: ${this.providerGatewayData.birthDate}`,
        `Person chatting about: ${this.providerGatewayData.memberFirstName} ${this.providerGatewayData.memberLastName} `,
        `Reason for chat: ${this.providerGatewayData.reasonCode}`
      ].join("\n");
      const transcripts = this.providerGatewayData.chatTranscript;
      transcripts === null || transcripts === void 0 ? void 0 : transcripts.forEach((transcript) => {
        this.sendMessageHandler(transcript);
      });
      this.sendMessageHandler(message);
    }
    this.session.chatInstance.emitParticipantJoin(
      this.providerIdentifier,
      Object.assign(
        {
          firstName: newParticipant.displayName,
          displayName: newParticipant.displayName,
          id: newParticipant.agentId,
          title: "",
          lastName: ""
        },
        this.buildAvayaAvatar(newParticipant.displayName)
      )
    );
    this.agentNameIdMap.push({
      name: newParticipant.displayName,
      id: newParticipant.agentId
    });
  }
  _participantLeave({ body }) {
    const leaveParticipant = body;
    let agentName = void 0;
    this.agentNameIdMap.forEach((agent, index) => {
      if (agent.id === leaveParticipant.agentId) {
        agentName = agent.name;
        this.agentNameIdMap.splice(index, 1);
        return;
      }
    });
    if (!agentName) {
      return;
    }
    this.session.chatInstance.emitParticipantLeave(
      this.providerIdentifier,
      Object.assign(
        {
          firstName: agentName,
          displayName: agentName,
          id: leaveParticipant.agentId,
          title: "",
          lastName: ""
        },
        this.buildAvayaAvatar(agentName)
      )
    );
    if (leaveParticipant.endChatFlag) {
      this.closeChat();
      this.session.chatInstance.emitChatEnd("PROVIDER");
    } else if (/^(transfer|transfer_to_(agent|user))$/i.test(
      leaveParticipant.leaveReason
    ) && leaveParticipant.numberOfParticipants === 0) {
      this.session.chatInstance.emitTransferRequestInternal("new agent");
      this.session.chatInstance.emitStatusChange(
        this.providerIdentifier,
        StatusTypes.QUEUED
      );
    }
  }
  _isTyping({ body }) {
    const isTyping = body;
    this.session.chatInstance.emitIsTyping(
      Object.assign(
        {
          firstName: isTyping.displayName,
          displayName: isTyping.displayName,
          id: isTyping.agentId,
          title: "",
          lastName: ""
        },
        this.buildAvayaAvatar(isTyping.displayName)
      )
    );
  }
  _newMessage({ body }) {
    if (body.accepted) {
      this.messageAcknowledgementReceived();
      return;
    }
    const newMessage = body;
    const agentId = this.agentNameIdMap.find(
      (agent) => agent.name === newMessage.displayName
    ).id;
    this.session.chatInstance.emitNewMessage(
      this.providerIdentifier,
      Object.assign(
        {
          firstName: newMessage.displayName,
          displayName: newMessage.displayName,
          id: agentId,
          title: "",
          lastName: ""
        },
        this.buildAvayaAvatar(newMessage.displayName)
      ),
      [new MessageText(newMessage.message)]
    );
  }
  _newPushPageMessage({ body }) {
    const pushPage = body;
    const agentId = this.agentNameIdMap.find(
      (agent) => agent.name === pushPage.displayName
    ).id;
    this.session.chatInstance.emitNewMessage(
      this.providerIdentifier,
      Object.assign(
        {
          firstName: pushPage.displayName,
          displayName: pushPage.displayName,
          id: agentId,
          title: "",
          lastName: ""
        },
        this.buildAvayaAvatar(pushPage.displayName)
      ),
      [
        new MessageUrl({
          source: "HREF",
          linkType: "EXTERNAL",
          value: pushPage.pagePushURL
        })
      ]
    );
  }
  _newAgentFileTransfer({ body }) {
    const fileInfo = body;
    const fileDownloadLink = "https://" + this.providerConfig.baseURL + "/services/customer/rest/attachment/" + fileInfo.uuid + "?workRequestId=" + fileInfo.workRequestId;
    this.session.chatInstance.emitNewMessage(
      this.providerIdentifier,
      Object.assign(
        {
          firstName: this.agentNameIdMap[0].name,
          displayName: this.agentNameIdMap[0].name,
          id: this.agentNameIdMap[0].id,
          title: "",
          lastName: ""
        },
        this.buildAvayaAvatar(this.agentNameIdMap[0].name)
      ),
      [
        new MessageFileLink(
          {
            name: fileInfo.name,
            mimeType: fileInfo.mimeType,
            size: fileInfo.size
          },
          {
            source: "HREF",
            linkType: "EXTERNAL",
            value: fileDownloadLink
          }
        )
      ]
    );
  }
  _routeCancel() {
    this._closeConversation();
  }
  _requestChat({ body }) {
    const msg = body;
    this.session.userInfo.guid = msg.guid;
    this.session.userInfo.authenticationKey = msg.authenticationKey;
    this.session.userInfo.workRequestId = msg.workRequestId;
    if (this.session.chatInstance.getCurrentChatState() === StatusTypes.RECONNECTING) {
      this.session.chatInstance.emitStatusChange(
        this.providerIdentifier,
        StatusTypes.CONNECTED
      );
    } else {
      this.session.chatInstance.emitStatusChange(
        this.providerIdentifier,
        StatusTypes.QUEUED
      );
    }
  }
  _closeConversation() {
    this.closeChat();
    this.session.chatInstance.emitChatEnd("PROVIDER");
  }
  _error({ body }) {
    var _a;
    const errorMsg = body;
    const errorMap = {
      "invalid message": "MESSAGE_SEND_INVALID",
      "session has expired": "PROVIDER_ERROR",
      "invalid request": "REQUEST_CHAT_INVALID",
      "unable to communicate": "PROVIDER_UNAVAILABLE"
    };
    const errorCode = (_a = errorMap[errorMsg.errorMessage.toLowerCase()]) !== null && _a !== void 0 ? _a : "GENERAL_ERROR";
    this.session.chatInstance.emitError(
      errorCode,
      errorMsg.errorMessage,
      errorMsg.needToClose
    );
    if (errorMsg.needToClose) {
      this.closeChat();
      this.session.chatInstance.emitChatEnd("ERROR");
    }
  }
};

// engen-chat-sdk/providers/gateway/gateway-provider.js
var GatewayProvider = class extends Provider {
  constructor() {
    super(...arguments);
    this.eventMapping = {
      newMessage: this._newMessage,
      participantJoin: this._participantJoin,
      transferChat: this._transferChat,
      acknowledgement: this._acknowledgement,
      isTyping: this._isTyping,
      pong: this.signalPongReceived,
      endChat: this._endChat,
      error: this._error
    };
  }
  onInitiateChat() {
    this.session.chatInstance.emitStatusChange(
      this.providerIdentifier,
      StatusTypes.CONNECTED
    );
  }
  onReconnectChat() {
    this.session.chatInstance.emitStatusChange(
      this.providerIdentifier,
      StatusTypes.CONNECTED
    );
  }
  sendMessageHandler(data, token) {
    this.send({
      event: "newMessage",
      data: {
        access_token: token,
        messageText: data,
        messageId: this.session.chatInstance.getCurrentMessageId().toString()
      }
    });
  }
  sendEventHandler(action, token) {
    this.send({
      event: "newEvent",
      data: {
        access_token: token,
        eventName: action.name,
        parameters: action.parameters,
        messageId: this.session.chatInstance.getCurrentMessageId().toString()
      }
    });
  }
  sendIsTypingHandler() {
    this.send({
      event: "isTyping"
    });
  }
  sendPing() {
    this.send({
      event: "ping"
    });
  }
  onChatClose() {
    if (!this.session.chatInstance.getTransferInProgress()) {
      this.send({
        event: "endChat",
        data: void 0
      });
    }
    this.session.chatInstance.emitParticipantLeave(
      this.providerIdentifier,
      this.participantInfo
    );
  }
  onTransferResult(newProviderId, isAvailable) {
    if (!isAvailable) {
      this.session.chatInstance.transferCanceled();
    }
    this.send({
      event: "transferInitiated",
      data: {
        newProviderId,
        isAvailable
      }
    });
  }
  webSocketMessageHandler(json) {
    const msg = JSON.parse(json.data);
    const eventName = msg === null || msg === void 0 ? void 0 : msg.event;
    const eventHandler = this.eventMapping[eventName];
    if (!eventHandler) {
      this.session.chatInstance.emitError(
        "MESSAGE_RECEIVE_FAILURE",
        "Bad message! Unsupported action!!"
      );
      return;
    }
    eventHandler.bind(this)(msg.data);
  }
  send(body) {
    this.sendToWebSocket({
      event: body.event,
      data: body.data
    });
  }
  _newMessage(data) {
    const msg = data;
    if (this.providerConfig.supportsUserMessageAcknowledgements) {
      this.send({
        event: "acknowledgement",
        data: {
          messageId: msg.messageId,
          timestamp: /* @__PURE__ */ new Date()
        }
      });
    }
    this.session.chatInstance.emitNewMessage(
      this.providerIdentifier,
      this.participantInfo,
      msg.messages
    );
  }
  _participantJoin(data) {
    this.participantInfo = data.participant;
    this.session.chatInstance.emitParticipantJoin(
      this.providerIdentifier,
      this.participantInfo
    );
  }
  _acknowledgement(data) {
    this.messageAcknowledgementReceived(+data.messageId);
  }
  _isTyping() {
    this.session.chatInstance.emitIsTyping(this.participantInfo);
  }
  _transferChat(data) {
    this.session.chatInstance.emitTransferRequestProvider(data);
  }
  _endChat(data) {
    const end = data;
    if (end.error) {
      this.session.chatInstance.emitError(
        "PROVIDER_ERROR",
        end.reasonCode,
        true
      );
    }
    this.closeChat();
    this.session.chatInstance.emitChatEnd("PROVIDER");
  }
  _error(data) {
    const error = data;
    this.session.chatInstance.emitError(
      error.errorCode,
      error.errorMessage,
      error.endChat
    );
    if (error.endChat) {
      this.closeChat();
      this.session.chatInstance.emitChatEnd("ERROR");
    }
  }
};

// engen-chat-sdk/internal/get-provider/get-provider.js
function getProvider(id) {
  switch (id) {
    case "avaya":
      return AvayaProvider;
    default:
      return GatewayProvider;
  }
}

// engen-chat-sdk/core/chat.js
var EnGenChat = class {
  constructor(config) {
    this.session = {
      chatInstance: new ChatInstance(),
      userInfo: new UserInfo(),
      config
    };
    this.onChatStart = this.session.chatInstance.observableEvents().onChatStart$;
    this.onChatEnd = this.session.chatInstance.observableEvents().onChatEnd$;
    this.onStatusChange = this.session.chatInstance.observableEvents().onStatusChange$;
    this.onTransferRequest = this.session.chatInstance.observableEvents().onTransferRequest$;
    this.onParticipantJoin = this.session.chatInstance.observableEvents().onParticipantJoin$;
    this.onParticipantLeave = this.session.chatInstance.observableEvents().onParticipantLeave$;
    this.onIsTyping = this.session.chatInstance.observableEvents().onIsTyping$;
    this.onNewMessage = this.session.chatInstance.observableEvents().onNewMessage$;
    this.onMessageAcknowledgement = this.session.chatInstance.observableEvents().onMessageAcknowledgement$;
    this.onError = this.session.chatInstance.observableEvents().onError$;
    this.transferProviders();
  }
  startChat(token, providerId, newChatRequest) {
    if (this.session.chatInstance.getCurrentChatState() !== StatusTypes.READY) {
      this.session.chatInstance.emitError(
        "START_CHAT_NOT_READY",
        "Not in a ready state."
      );
      return;
    }
    this.chatProvider = new (getProvider(providerId))(this.session);
    this.chatProvider.checkAvailability(token, providerId, newChatRequest).then((availResult) => {
      if (availResult.isAvailable) {
        this.chatProvider.startChat(token);
      } else {
        this.session.chatInstance.emitError(
          "PROVIDER_UNAVAILABLE",
          availResult.unavailableReason,
          true
        );
        this.session.chatInstance.emitStatusChange(
          this.chatProvider.providerIdentifier,
          StatusTypes.UNAVAILABLE
        );
      }
    });
  }
  closeChat() {
    const state = this.session.chatInstance.getCurrentChatState();
    if (state === StatusTypes.CONNECTING || state === StatusTypes.QUEUED || state === StatusTypes.CONNECTED || state === StatusTypes.RECONNECTING) {
      this.chatProvider.closeChat();
      this.session.chatInstance.emitChatEnd("CLIENT");
    } else {
      this.session.chatInstance.emitError(
        "CLOSE_CHAT_FAILURE",
        "Not in a connected state."
      );
    }
  }
  sendMessage(token, text) {
    const state = this.session.chatInstance.getCurrentChatState();
    if (state === StatusTypes.QUEUED || state === StatusTypes.CONNECTED) {
      return this.chatProvider.sendMessage(token, text);
    } else {
      this.session.chatInstance.emitError(
        "MESSAGE_SEND_FAILURE",
        "Not in connected state"
      );
    }
  }
  sendEvent(token, event) {
    const state = this.session.chatInstance.getCurrentChatState();
    if (state === StatusTypes.QUEUED || state === StatusTypes.CONNECTED) {
      return this.chatProvider.sendEvent(token, event);
    } else {
      this.session.chatInstance.emitError(
        "EVENT_SEND_FAILURE",
        "Not in connected state"
      );
    }
  }
  sendIsTyping() {
    const state = this.session.chatInstance.getCurrentChatState();
    if (state === StatusTypes.QUEUED || state === StatusTypes.CONNECTED) {
      this.chatProvider.sendIsTyping();
    } else {
      this.session.chatInstance.emitError(
        "MESSAGE_SEND_FAILURE",
        "Not in connected state"
      );
    }
  }
  checkAvailability(token) {
    return __async(this, null, function* () {
      const state = this.session.chatInstance.getCurrentChatState();
      const invalidStates = [
        StatusTypes.ERROR,
        StatusTypes.CONNECTED,
        StatusTypes.CONNECTING,
        StatusTypes.RECONNECTING,
        StatusTypes.QUEUED
      ];
      if (invalidStates.includes(state)) {
        throw Error("CHECK_AVAILABILITY_ERROR");
      }
      try {
        const providers = yield restRequest(
          `https://${this.session.config.environment}/digital/v1/chat/availability?version=${this.session.config.version}`,
          "GET",
          void 0,
          token
        );
        if (providers.some((provider) => provider.isAvailable)) {
          this.session.chatInstance.emitStatusChange(
            {
              providerId: "",
              providerName: ""
            },
            StatusTypes.READY
          );
        } else {
          this.session.chatInstance.emitStatusChange(
            {
              providerId: "",
              providerName: ""
            },
            StatusTypes.UNAVAILABLE
          );
        }
        return providers;
      } catch (e) {
        throw Error("CHECK_AVAILABILITY_ERROR");
      }
    });
  }
  transferProviders() {
    this.session.chatInstance.getProviderTransferEvent().subscribe((transferData) => __async(this, null, function* () {
      const newProvider = new (getProvider(
        transferData.transferToProviderId
      ))(this.session);
      const availResult = yield newProvider.checkAvailability(
        transferData.access_token,
        transferData.transferToProviderId,
        Object.assign(
          { sessionId: transferData.sessionId },
          transferData.requestData
        )
      );
      if (this.session.chatInstance.getCurrentChatState() !== StatusTypes.CONNECTED) {
        this.session.chatInstance.transferCanceled();
        return;
      } else if (!availResult.isAvailable) {
        this.chatProvider.onTransferResult(
          transferData.transferToProviderId,
          false
        );
        return;
      }
      this.chatProvider.onTransferResult(
        transferData.transferToProviderId,
        true
      );
      this.chatProvider.closeChat();
      this.chatProvider = newProvider;
      this.chatProvider.startChat(transferData.access_token);
    }));
  }
};

// engen-chat-sdk/core/models/version.js
var CHAT_VERSION = "1.0.4";

// engen-chat-sdk/core/models/chat-config.js
var Environments;
(function(Environments2) {
  Environments2["DEV"] = "api-dev.highmark.com";
  Environments2["TEST"] = "api-qa.highmark.com";
  Environments2["UAT"] = "api-test.highmark.com";
  Environments2["PROD"] = "api.highmark.com";
})(Environments || (Environments = {}));
var ChatConfig = class {
  constructor(env) {
    this.version = CHAT_VERSION;
    this.environment = env;
  }
};

// src/common/highmark-live-chat-client.ts
var ChatInstance2 = class {
  constructor() {
    this.getLinkValue = (link) => {
      var _a, _b, _c, _d, _e, _f;
      if (((_b = (_a = link == null ? void 0 : link.action) == null ? void 0 : _a.link) == null ? void 0 : _b.linkType) === "INTERNAL" && ((_d = (_c = link == null ? void 0 : link.action) == null ? void 0 : _c.link) == null ? void 0 : _d.source) === "CONFIG") {
        const linkValue = this.getConfigValue(link.action.link.value);
        if (linkValue) {
          return linkValue;
        }
        const defaultLink = this.getConfigValue("DEFAULT_DEEPLINK");
        if (defaultLink) {
          return `${window.location.origin}${defaultLink}`;
        }
        return `${window.location.origin}/`;
      }
      return (_f = (_e = link.action.link) == null ? void 0 : _e.value) != null ? _f : null;
    };
    // Gets links for messages with a type of Card
    this.getMessageLinks = (links) => links.map((link) => {
      var _a;
      const linkValue = this.getLinkValue(link);
      return {
        value: linkValue,
        label: (_a = link.text) != null ? _a : null
      };
    });
    this.status = StatusTypes.READY;
    this.unacknowledgedMessages = [];
    this.config = {};
  }
  setStatus(newStatus) {
    if (newStatus === StatusTypes.READY && this.status === StatusTypes.CONNECTING) {
      return;
    }
    this.status = newStatus;
  }
  getStatus() {
    return this.status;
  }
  addUnacknowledgedMessage(messageId, eventId) {
    this.unacknowledgedMessages.push({ messageId, eventId });
  }
  acknowledgeMessage(messageId) {
    const index = this.unacknowledgedMessages.findIndex(
      (message) => message.messageId === messageId
    );
    if (index > -1) {
      const acknowledgeMessage = this.unacknowledgedMessages.splice(index, 1);
      return acknowledgeMessage[0].eventId;
    }
    return null;
  }
  setConfig(newConfig) {
    this.config = newConfig;
  }
  getConfigValue(key) {
    return this.config[key] || null;
  }
};
var isStage = (env) => env === "staging";
var createLiveChatClient = ({
  env,
  partnerId
}) => {
  const chatEnvironment = isStage(env) ? Environments.TEST : Environments.PROD;
  const chatConfig = new ChatConfig(chatEnvironment);
  const chatSDK = new EnGenChat(chatConfig);
  const identityToken = new IdentityToken(partnerId != null ? partnerId : DEFAULT_PARTNER_ID);
  const chatInstance = new ChatInstance2();
  const getMessageSender = (participant) => {
    var _a, _b, _c;
    return {
      id: `${(_a = participant == null ? void 0 : participant.id) != null ? _a : uuidv4()}`,
      name: participant == null ? void 0 : participant.displayName,
      avatarUrl: (_c = (_b = participant == null ? void 0 : participant.icon) == null ? void 0 : _b.url) == null ? void 0 : _c.value
    };
  };
  const getMessageChips = (suggestions) => suggestions.map((suggestion) => {
    var _a, _b, _c;
    return {
      label: suggestion.text,
      value: ((_a = suggestion.action.event) == null ? void 0 : _a.name) || suggestion.text,
      link: suggestion.action.link,
      metadata: (_c = (_b = suggestion.action.event) == null ? void 0 : _b.parameters) != null ? _c : {}
    };
  });
  const getMessageCard = (card) => {
    const buttons = chatInstance.getMessageLinks(card.buttons);
    return {
      title: card.title,
      subtitle: card == null ? void 0 : card.subtitle,
      buttons
    };
  };
  const checkAvailability = (defaultProvider) => __async(void 0, null, function* () {
    const freshIdentityToken = yield identityToken.getToken();
    if (freshIdentityToken) {
      try {
        const allProviders = yield chatSDK.checkAvailability(
          freshIdentityToken
        );
        const availableProvider = allProviders.filter(
          (providerAvailability) => providerAvailability.provider.providerId === defaultProvider && providerAvailability.isAvailable
        );
        if (availableProvider.length > 0) {
          return availableProvider[0].provider.providerId;
        }
        return null;
      } catch (err) {
        return null;
      }
    }
    return null;
  });
  const startChat = (providerId) => __async(void 0, null, function* () {
    const freshIdentityToken = yield identityToken.getToken();
    if (freshIdentityToken) {
      chatSDK.startChat(freshIdentityToken, providerId, {});
    }
  });
  const sendMessage = (message) => __async(void 0, null, function* () {
    const freshIdentityToken = yield identityToken.getToken();
    if (freshIdentityToken) {
      const messageId = yield chatSDK.sendMessage(freshIdentityToken, message);
      return messageId;
    }
    return null;
  });
  const sendChip = (chip) => __async(void 0, null, function* () {
    const freshIdentityToken = yield identityToken.getToken();
    if (freshIdentityToken) {
      const messageId = yield chatSDK.sendEvent(freshIdentityToken, {
        name: chip.value,
        params: chip.metadata || {}
      });
      return messageId;
    }
    return null;
  });
  const getChatEndedReason = (status) => {
    const reasons = {
      PROVIDER: { type: ChatEndedReasonTypes.AGENT_DISCONNECTED },
      CLIENT: { type: ChatEndedReasonTypes.USER_DISCONNECTED },
      ERROR: { type: ChatEndedReasonTypes.CONNECTION_LOST }
    };
    return reasons[status.origin] || reasons.ERROR;
  };
  return {
    subscribeToAgentChatEvents: (handler) => {
      let isTypingTimeout;
      const clearIsTyping = () => {
        handler({
          eventType: EventTypes.PARTICIPANT_TYPING,
          eventId: uuidv4(),
          isTyping: false
        });
      };
      chatSDK.onStatusChange.subscribe((statusChange) => {
        chatInstance.setStatus(statusChange.connectionStatus);
      });
      chatSDK.onChatStart.subscribe(() => {
        handler({ eventType: EventTypes.CHAT_STARTED, eventId: uuidv4() });
      });
      chatSDK.onParticipantJoin.subscribe(
        (participant) => handler({
          eventType: EventTypes.PARTICIPANT_JOINED,
          eventId: uuidv4(),
          participant: {
            id: `${participant.participant.id}`,
            name: participant.participant.displayName
          }
        })
      );
      chatSDK.onParticipantLeave.subscribe(
        (participant) => handler({
          eventType: EventTypes.PARTICIPANT_LEFT,
          eventId: uuidv4(),
          participant: {
            id: `${participant.participant.id}`,
            name: participant.participant.displayName
          }
        })
      );
      chatSDK.onIsTyping.subscribe(() => {
        if (isTypingTimeout) {
          clearTimeout(isTypingTimeout);
        }
        isTypingTimeout = setTimeout(clearIsTyping, 5e3);
        handler({
          eventType: EventTypes.PARTICIPANT_TYPING,
          eventId: uuidv4(),
          isTyping: true
        });
      });
      chatSDK.onChatEnd.subscribe((status) => {
        const reason = getChatEndedReason(status);
        handler({
          eventType: EventTypes.CHAT_ENDED,
          eventId: uuidv4(),
          reason
        });
      });
      chatSDK.onNewMessage.subscribe(
        (participantMessage) => {
          const { messages, participant } = participantMessage;
          if (isTypingTimeout) {
            clearIsTyping();
          }
          const sender = getMessageSender(participant);
          if (messages.length > 0) {
            messages.forEach((message) => {
              if (message.messageType === "TEXT") {
                handler({
                  eventType: EventTypes.MESSAGE,
                  eventId: uuidv4(),
                  message: message.text,
                  sender,
                  timestamp: /* @__PURE__ */ new Date()
                });
                return;
              }
              if (message.messageType === "URL" || message.messageType === "FILE_LINK") {
                handler({
                  eventType: EventTypes.MESSAGE,
                  eventId: uuidv4(),
                  // Passing in the link value
                  // The FE will manage parsing it
                  message: message.link.value,
                  sender,
                  timestamp: /* @__PURE__ */ new Date()
                });
                return;
              }
              if (message.messageType === "SUGGESTIONS") {
                const chips = getMessageChips(message.suggestions);
                handler({
                  eventType: EventTypes.MESSAGE,
                  eventId: uuidv4(),
                  chips,
                  sender,
                  timestamp: /* @__PURE__ */ new Date()
                });
                return;
              }
              if (message.messageType === "CARD") {
                const card = getMessageCard(message.card);
                handler({
                  eventType: EventTypes.MESSAGE,
                  eventId: uuidv4(),
                  card,
                  sender,
                  timestamp: /* @__PURE__ */ new Date()
                });
              }
            });
          }
        }
      );
      chatSDK.onMessageAcknowledgement.subscribe(
        (acknowledgment) => {
          const acknowledgedMessageEventId = chatInstance.acknowledgeMessage(
            acknowledgment.id
          );
          if (!acknowledgedMessageEventId) {
            return;
          }
          if (acknowledgment.status === "DELIVERED") {
            if (acknowledgedMessageEventId) {
              handler({
                eventId: uuidv4(),
                eventType: EventTypes.EVENT_ACKNOWLEDGED,
                messageId: acknowledgedMessageEventId
              });
            }
            return;
          }
          if (acknowledgment.status === "ERROR") {
            handler({
              eventId: uuidv4(),
              eventType: EventTypes.ERROR_RECEIVED,
              errorType: {
                type: ErrorTypes.MESSAGE_FAILED,
                eventOriginId: acknowledgedMessageEventId
              }
            });
            return;
          }
          if (acknowledgment.status === "UNSUPPORTED") {
            handler({
              eventId: uuidv4(),
              eventType: EventTypes.ERROR_RECEIVED,
              errorType: {
                type: ErrorTypes.DEFAULT
              }
            });
          }
        }
      );
      chatSDK.onError.subscribe((error) => {
        if (error.endChat) {
          return handler({
            eventId: uuidv4(),
            eventType: EventTypes.CHAT_ENDED,
            reason: {
              type: ChatEndedReasonTypes.CONNECTION_LOST
            }
          });
        }
        return handler({
          eventId: uuidv4(),
          eventType: EventTypes.ERROR_RECEIVED,
          errorType: __spreadValues({
            type: ErrorTypes.DEFAULT
          }, (error == null ? void 0 : error.message) && { message: error.message })
        });
      });
      chatSDK.onTransferRequest.subscribe(() => {
        handler({
          eventId: uuidv4(),
          eventType: EventTypes.TRANSFER_REQUESTED
        });
      });
      return null;
    },
    // User Chat Events
    handleUserChatEvents: (event) => __async(void 0, null, function* () {
      let providerId;
      let chatStatus;
      let defaultProvider;
      switch (event.eventType) {
        case EventTypes.START_CHAT:
          chatInstance.setConfig(event.config);
          defaultProvider = chatInstance.getConfigValue("provider");
          providerId = yield checkAvailability(defaultProvider);
          chatStatus = chatInstance.getStatus();
          if (providerId && chatStatus === "READY") {
            yield startChat(providerId);
          }
          break;
        case EventTypes.MESSAGE:
          if (event == null ? void 0 : event.message) {
            const messageId = yield sendMessage(event.message);
            if (messageId == null ? void 0 : messageId.toString()) {
              chatInstance.addUnacknowledgedMessage(
                messageId.toString(),
                event.eventId
              );
            }
          }
          if ((event == null ? void 0 : event.chips) && event.chips.length > 0) {
            yield Promise.all(
              event.chips.map((chip) => __async(void 0, null, function* () {
                const messageId = yield sendChip(chip);
                if (messageId == null ? void 0 : messageId.toString()) {
                  chatInstance.addUnacknowledgedMessage(
                    messageId.toString(),
                    event.eventId
                  );
                }
              }))
            );
          }
          break;
        case EventTypes.PARTICIPANT_TYPING:
          if (event.isTyping) {
            chatSDK.sendIsTyping();
          }
          break;
        case EventTypes.END_CHAT:
          chatSDK.closeChat();
          break;
        default:
      }
    })
  };
};

// src/common/sso-constants.ts
var QUERY_PARAM_KEYS = {
  modal: "modal",
  linkType: "linkType",
  partnerId: "partnerId",
  ssoDeeplink: "sso-deeplink"
};
var WEBVIEW_MODAL_QUERY_PARAM_VALUE = "webview-modal";
var LINK_TYPES = /* @__PURE__ */ ((LINK_TYPES2) => {
  LINK_TYPES2["AUTHED_WEBVIEW"] = "authedwebview";
  LINK_TYPES2["SSO"] = "sso";
  return LINK_TYPES2;
})(LINK_TYPES || {});
var SSO_READY_LISTENER_TIMEOUT = 2e4;
var SSO_URL_NAMES = /* @__PURE__ */ ((SSO_URL_NAMES3) => {
  SSO_URL_NAMES3["COB"] = "COB";
  SSO_URL_NAMES3["E_BILL"] = "E_BILL";
  SSO_URL_NAMES3["PRIVACY"] = "PRIVACY";
  SSO_URL_NAMES3["TERMS_OF_USE"] = "TERMS_OF_USE";
  return SSO_URL_NAMES3;
})(SSO_URL_NAMES || {});
var AUTHED_WEBVIEW_URL_NAMES = /* @__PURE__ */ ((AUTHED_WEBVIEW_URL_NAMES3) => {
  AUTHED_WEBVIEW_URL_NAMES3["ACCOUNT_MANAGEMENT"] = "ACCOUNT_MANAGEMENT";
  AUTHED_WEBVIEW_URL_NAMES3["CONTACT_INFO"] = "CONTACT_INFO";
  AUTHED_WEBVIEW_URL_NAMES3["LEGAL"] = "LEGAL";
  AUTHED_WEBVIEW_URL_NAMES3["PRIVACY_POLICY"] = "PRIVACY_POLICY";
  AUTHED_WEBVIEW_URL_NAMES3["TERMS"] = "TERMS";
  AUTHED_WEBVIEW_URL_NAMES3["MFA_ENROLLMENT"] = "MFA_ENROLLMENT";
  return AUTHED_WEBVIEW_URL_NAMES3;
})(AUTHED_WEBVIEW_URL_NAMES || {});
var SSO_URLS_MAP = {
  ["COB" /* COB */]: {
    path: "link/cob",
    linkType: "sso" /* SSO */,
    baseUrlType: "highmarkMemberPortalUrl" /* MEMBER_PORTAL_URL */
  },
  ["E_BILL" /* E_BILL */]: {
    path: "partner/ebill",
    linkType: "sso" /* SSO */,
    baseUrlType: "highmarkSsoAppUrl" /* SSO_APP_URL */
  },
  ["TERMS_OF_USE" /* TERMS_OF_USE */]: {
    path: "/legal/terms-of-use",
    linkType: "sso" /* SSO */,
    baseUrlType: "highmarkMemberPortalUrl" /* MEMBER_PORTAL_URL */
  },
  ["PRIVACY" /* PRIVACY */]: {
    path: "/legal/privacy",
    linkType: "sso" /* SSO */,
    baseUrlType: "highmarkMemberPortalUrl" /* MEMBER_PORTAL_URL */
  },
  ["ACCOUNT_MANAGEMENT" /* ACCOUNT_MANAGEMENT */]: {
    path: "account-management",
    linkType: "authedwebview" /* AUTHED_WEBVIEW */,
    baseUrlType: "highmarkSsoAppUrl" /* SSO_APP_URL */
  },
  ["CONTACT_INFO" /* CONTACT_INFO */]: {
    path: "contact-info",
    linkType: "authedwebview" /* AUTHED_WEBVIEW */,
    baseUrlType: "highmarkSsoAppUrl" /* SSO_APP_URL */
  },
  ["PRIVACY_POLICY" /* PRIVACY_POLICY */]: {
    path: "legal/privacy-policy",
    linkType: "authedwebview" /* AUTHED_WEBVIEW */,
    baseUrlType: "highmarkSsoAppUrl" /* SSO_APP_URL */
  },
  ["TERMS" /* TERMS */]: {
    path: "legal/terms-of-use",
    linkType: "authedwebview" /* AUTHED_WEBVIEW */,
    baseUrlType: "highmarkSsoAppUrl" /* SSO_APP_URL */
  },
  ["LEGAL" /* LEGAL */]: {
    path: "legal",
    linkType: "authedwebview" /* AUTHED_WEBVIEW */,
    baseUrlType: "highmarkSsoAppUrl" /* SSO_APP_URL */
  },
  ["MFA_ENROLLMENT" /* MFA_ENROLLMENT */]: {
    path: "mfa-management",
    linkType: "authedwebview" /* AUTHED_WEBVIEW */,
    baseUrlType: "highmarkSsoAppUrl" /* SSO_APP_URL */
  }
};

// src/common/customer-support-constants.ts
var CS_AUTH0_CLIENT_CONNECTION = "highmark-internal-enterprise-saml";

// src/common/app-managed-routes.ts
var APP_MANAGED_ROUTES = {
  ABOUT: "/about",
  ABOUT_BENEFICITY: "/about-beneficity",
  CARE_REDIRECT: "/get-care",
  FORMS_LIBRARY: "/forms-library",
  HOME: "/home",
  HSA_ENROLLMENT: "/hsaEnrollment",
  MEMBER_REDIRECT: "/member",
  PRIVACY: "/privacy",
  LEGAL: "/legal",
  LEGAL_DETAILS_SUBPATH: "/legal-details",
  LIVE_CHAT: "/live-chat",
  SIGN_IN: "/sign-in",
  SIGN_OUT: "/sign-out",
  SUPPORT: "/support",
  TECHNICAL_ASSISTANCE_AND_ALL_LANGUAGES: "/technical-assistance-and-all-languages",
  WALLET_REDIRECT: "/wallet"
};

// src/hooks/use-authed-webview-modal/use-authed-webview-modal.hook.ts
import { useEffect, useState } from "react";
import { useUrlParam } from "@leagueplatform/web-common";

// src/utils/post-message-auth-helpers.ts
import { getPartnerAccessToken as getPartnerAccessToken2 } from "@leagueplatform/sso-util";

// src/utils/logger.ts
import { isProduction } from "@leagueplatform/core";
import log from "loglevel";
var originalFactory = log.methodFactory;
log.methodFactory = (methodName, logLevel, loggerName) => {
  const rawMethod = originalFactory(methodName, logLevel, loggerName);
  return (message) => {
    if (!isProduction() || methodName === "error") {
      rawMethod(message);
    }
  };
};
log.setLevel(log.getLevel());
var logger = log;

// src/utils/sso-url-helpers.ts
import { isProduction as isProduction2 } from "@leagueplatform/core";
import { captureAppError } from "@leagueplatform/observability";
var buildSsoUrl = (options) => {
  const { path, linkType, baseUrlType } = options;
  const baseUrl = highmarkCommon.getConfig()[baseUrlType];
  if (!baseUrl) {
    captureAppError(new Error("SSO URL Error - Base Url not set."), {
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
      tags: {
        ssoPath: path
      },
      context: {
        Context: __spreadValues({}, options)
      }
    });
    return "";
  }
  const urlParams = new URLSearchParams({
    [QUERY_PARAM_KEYS.linkType]: linkType
  });
  const urlObj = new URL(baseUrl);
  urlObj.pathname = path;
  urlObj.search = urlParams.toString();
  return urlObj.toString();
};
var getSsoUrl = (urlName) => buildSsoUrl(SSO_URLS_MAP[urlName]);
var getAuthedWebviewUrl = (urlName) => buildSsoUrl(SSO_URLS_MAP[urlName]);
var HIGHMARK_SSO_DEV_URL = "https://iel-dev.member.highmark.com";
var getTrustedTargetSsoOrigins = () => {
  const { highmarkMemberPortalUrl, highmarkSsoAppUrl } = highmarkCommon.getConfig();
  const trustedOrigins = [
    highmarkMemberPortalUrl,
    highmarkSsoAppUrl,
    !isProduction2() ? HIGHMARK_SSO_DEV_URL : null
  ].filter((url) => !!url);
  return trustedOrigins;
};

// src/utils/post-message-auth-helpers.ts
var sendPartnerAuthToken = (partnerId, targetWindow, targetOrigin) => __async(void 0, null, function* () {
  if (!getTrustedTargetSsoOrigins().includes(targetOrigin)) {
    throw new Error(
      `Token is not allowed to be sent to target origin: ${targetOrigin}`
    );
  }
  const token = yield getPartnerAccessToken2(partnerId);
  targetWindow.postMessage(
    {
      accessToken: token
    },
    targetOrigin
  );
});
var sendAuthTokenIfReady = (event, origin, window2, partnerId) => __async(void 0, null, function* () {
  var _a;
  if (event.origin === origin && ((_a = event.data) == null ? void 0 : _a.ready) === true) {
    if (!window2) {
      throw Error("Could not send auth token, target window does not exist.");
    }
    yield sendPartnerAuthToken(partnerId || DEFAULT_PARTNER_ID, window2, origin);
    logger.log("Sent auth token to: ", origin);
    return true;
  }
  return false;
});

// src/utils/sentry-helpers.ts
import {
  captureAppError as captureAppError2,
  captureAppMessage,
  captureError,
  captureMessage
} from "@leagueplatform/observability";
var captureUserIneligibleEvent = (data) => {
  var _a;
  if (!((_a = data == null ? void 0 : data.eligibilityInfo) == null ? void 0 : _a.eligible)) {
    captureMessage("User Not Eligible to access application.", {
      context: {
        Context: {
          info: "User successfully logged in but is not eligible for this application."
        }
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
      severityLevel: "info"
    });
  }
};
var captureSsoError = (error, ssoUrl) => {
  captureError(error, {
    errorName: `SSO External Link Error - ${error.message}`,
    context: {
      Context: {
        ssoUrl
      }
    },
    ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
    tags: {
      sso: ssoUrl
    }
  });
};
var captureAuthedWebviewError = (error, webviewUrl) => {
  captureError(error, {
    errorName: `Authed Webview Error - ${error.message}`,
    context: {
      Context: {
        webviewUrl
      }
    },
    ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
    tags: {
      webview: webviewUrl
    }
  });
};
var captureAuthenticationError = (error) => {
  if (error.type && error.type.toLowerCase().includes(AUTH0_ERROR_TYPES.LOGIN_REQUIRED)) {
    captureAppMessage(`Auth0 Error - ${error.type}`, {
      context: {
        Context: {
          info: `User has been logged out due to inactivity, a new login is required - type: ${error.type}, description: ${error.description}`
        }
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
      severityLevel: "warning"
    });
  } else {
    captureAppError2(new Error(error.type), {
      errorName: `Auth0 Error - ${error.type}`,
      context: {
        Context: {
          info: `an authentication error has occurred - type: ${error.type}, description: ${error.description}`
        }
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM
    });
  }
};

// src/hooks/use-authed-webview-modal/use-authed-webview-modal.hook.ts
var useAuthedWebviewModal = (iframeRef, linkHandler) => {
  const [url, setUrl] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { removeParam, urlParam } = useUrlParam(QUERY_PARAM_KEYS.modal);
  const onError = (caughtError) => {
    setError(caughtError);
    captureAuthedWebviewError(caughtError, url);
  };
  const closeModal = () => {
    removeParam();
    setUrl("");
    setError(null);
  };
  useEffect(() => {
    if (urlParam === WEBVIEW_MODAL_QUERY_PARAM_VALUE) {
      const newUrl = linkHandler.lastPassedUrl;
      if (!newUrl) {
        removeParam();
      } else {
        setUrl(newUrl);
      }
    }
  }, [urlParam, removeParam, linkHandler]);
  useEffect(() => {
    if (url && (iframeRef == null ? void 0 : iframeRef.current)) {
      const targetOrigin = new URL(url).origin;
      const messageHandler = (event) => __async(void 0, null, function* () {
        var _a, _b;
        logger.log("Received message", event);
        try {
          const isAuthenticated = yield sendAuthTokenIfReady(
            event,
            targetOrigin,
            (_a = iframeRef == null ? void 0 : iframeRef.current) == null ? void 0 : _a.contentWindow
          );
          if (isAuthenticated) {
            setLoading(false);
          }
        } catch (err) {
          setLoading(false);
          onError(err instanceof Error ? err : new Error(err));
        }
        const action = (_b = event == null ? void 0 : event.data) == null ? void 0 : _b.action;
        if ((event == null ? void 0 : event.origin) !== targetOrigin || !action) {
          return;
        }
        switch (action) {
          case "close":
            closeModal();
            break;
          default:
            captureAuthedWebviewError(
              new Error(
                `Unknown action received: ${action}: ${JSON.stringify(
                  event.data
                )}`
              ),
              url
            );
        }
      });
      window.addEventListener("message", messageHandler);
      const timeout = setTimeout(() => {
        setLoading((loading) => {
          if (loading) {
            onError(
              new Error(
                "Could not send auth token, ready message not received from iframe."
              )
            );
          }
          return false;
        });
      }, SSO_READY_LISTENER_TIMEOUT);
      return () => {
        clearTimeout(timeout);
        window.removeEventListener("message", messageHandler);
      };
    }
    setLoading(true);
    return () => {
    };
  }, [iframeRef, urlParam, url]);
  return {
    isOpen: Boolean(urlParam && url),
    url,
    closeModal,
    isLoading,
    error
  };
};

// src/hooks/use-sso-deep-link.ts
import { useEffect as useEffect2 } from "react";
import { useUrlParam as useUrlParam2 } from "@leagueplatform/web-common";
var useSsoDeepLink = (linkHandler) => {
  const { removeParam, urlParam } = useUrlParam2(QUERY_PARAM_KEYS.ssoDeeplink);
  useEffect2(() => {
    if (urlParam) {
      const targetUrl = urlParam;
      removeParam();
      linkHandler.handleLink(targetUrl);
    }
  }, [urlParam, linkHandler, removeParam]);
};

// src/hooks/use-error-message/use-error-message.ts
import { useHistory } from "@leagueplatform/routing";
var ERROR_TYPES = /* @__PURE__ */ ((ERROR_TYPES3) => {
  ERROR_TYPES3["API_ERROR"] = "api_error";
  ERROR_TYPES3["NO_CONNECTION"] = "no_connection";
  ERROR_TYPES3["NOT_ELIGIBLE"] = "not_eligible";
  ERROR_TYPES3["OVER_365_DAYS"] = "over_365_days";
  return ERROR_TYPES3;
})(ERROR_TYPES || {});
var useErrorMessage = ({
  errorType = "api_error" /* API_ERROR */,
  buttonId,
  headingString,
  bodyString,
  buttonAction
}) => {
  const history2 = useHistory();
  const ErrorMessages = {
    ["api_error" /* API_ERROR */]: {
      headingId: "ERROR_HEADING_GENERIC",
      bodyId: "ERROR_CAPTION_BACKEND",
      buttonId: "RELOAD",
      buttonAction: () => window.location.reload()
    },
    ["no_connection" /* NO_CONNECTION */]: {
      headingId: "ERROR_HEADING_NO_CONNECTION",
      bodyId: "ERROR_CAPTION_NO_CONNECTION"
    },
    ["not_eligible" /* NOT_ELIGIBLE */]: {
      headingId: "ERROR_HEADING_NOT_ELIGIBLE",
      bodyId: "ERROR_CAPTION_NOT_ELIGIBLE",
      buttonId: "CLOSE",
      buttonAction: () => history2.push("/sign-out")
    },
    ["over_365_days" /* OVER_365_DAYS */]: {
      headingId: "ERROR_HEADING_OVER_365_DAYS",
      bodyId: "ERROR_CAPTION_OVER_365_DAYS",
      buttonId: "CLOSE",
      buttonAction: () => history2.push("/sign-out")
    }
  };
  let errorContentData = {
    headingString,
    headingId: ErrorMessages[errorType].headingId,
    bodyString,
    bodyId: ErrorMessages[errorType].bodyId
  };
  if (ErrorMessages[errorType].buttonId && ErrorMessages[errorType].buttonAction) {
    errorContentData = __spreadProps(__spreadValues({}, errorContentData), {
      buttonId: buttonId || ErrorMessages[errorType].buttonId,
      onButtonClick: buttonAction || ErrorMessages[errorType].buttonAction
    });
  }
  return errorContentData;
};

// src/hooks/use-get-app-init-details.ts
import { useQuery } from "react-query";

// src/utils/socket-as-fetch.ts
import {
  SocketAsFetch as LeagueSocketAsFetch
} from "@leagueplatform/socket-as-fetch";
import { combineErrorContexts } from "@leagueplatform/observability";
var socketAsFetch = (message, options) => LeagueSocketAsFetch.fetch(message, {
  errorContext: combineErrorContexts([
    {
      errorName: `Highmark Socket Fetch Response Error - ${message.message_type}`,
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM
    },
    (options == null ? void 0 : options.errorContext) || {}
  ])
});

// src/api/get-app-init-details.ts
import camelcaseKeys from "camelcase-keys";
var GET_APP_INIT_DETAILS_MESSAGE_TYPE = "get_app_init_details";
var INELIGIBLE_CODES = /* @__PURE__ */ ((INELIGIBLE_CODES2) => {
  INELIGIBLE_CODES2[INELIGIBLE_CODES2["OVER_365_DAYS"] = 11] = "OVER_365_DAYS";
  return INELIGIBLE_CODES2;
})(INELIGIBLE_CODES || {});
var CONTENT_ROUTES = /* @__PURE__ */ ((CONTENT_ROUTES3) => {
  CONTENT_ROUTES3["HOME"] = "home";
  CONTENT_ROUTES3["BENEFITS"] = "benefits";
  CONTENT_ROUTES3["CARE"] = "getCare";
  CONTENT_ROUTES3["JOURNEY"] = "journey";
  CONTENT_ROUTES3["SUPPORT"] = "support";
  return CONTENT_ROUTES3;
})(CONTENT_ROUTES || {});
var getAppInitDetails = () => socketAsFetch({
  message_type: GET_APP_INIT_DETAILS_MESSAGE_TYPE,
  // eligibility to access the app may differ between mobile and web, for the same user, due to age restrictions
  info: {
    platform: "web"
  }
}).then((data) => camelcaseKeys(data, { deep: true }));

// src/hooks/use-get-app-init-details.ts
var QUERY_CACHE_AND_STALE_TIME = 15 * 1e3 * 60;
var useGetAppInitDetails = (options) => {
  const _a = useQuery(
    [GET_APP_INIT_DETAILS_MESSAGE_TYPE],
    getAppInitDetails,
    __spreadValues({
      staleTime: QUERY_CACHE_AND_STALE_TIME,
      cacheTime: QUERY_CACHE_AND_STALE_TIME
    }, options)
  ), { data } = _a, query = __objRest(_a, ["data"]);
  return __spreadValues(__spreadValues({}, data), query);
};

// src/hooks/use-get-identity-partner-token.ts
import { useQuery as useQuery2 } from "react-query";
import { getPartnerAccessToken as getPartnerAccessToken3 } from "@leagueplatform/sso-util";
var useGetIdentityPartnerToken = (partnerId) => useQuery2(
  ["GET_IDENTITY_PARTNER_TOKEN"],
  () => getPartnerAccessToken3(partnerId),
  {
    cacheTime: 27e5
    // Setting cache timer for 45 minutes to fetch new identity token
  }
);

// src/hooks/use-get-ebill-eligibility.hook.ts
import { useQuery as useQuery3 } from "react-query";

// src/utils/highmark-fetch.ts
import {
  captureError as captureError2,
  combineErrorContexts as combineErrorContexts2
} from "@leagueplatform/observability";
var highmarkFetch = (_0, _1, ..._2) => __async(void 0, [_0, _1, ..._2], function* (path, token, options = {}, errorContext = {}) {
  const url = `${highmarkCommon.getConfig().highmarkRestApiUrl}${path.replace(
    /^\/?/,
    "/"
  )}`;
  const requestOptions = __spreadProps(__spreadValues({
    method: "GET"
  }, options), {
    headers: new Headers(__spreadValues({
      Accept: "application/json",
      Authorization: `Bearer ${token}`
    }, options.headers || {}))
  });
  const promise = fetch(url, requestOptions);
  const response = yield promise;
  if (!response.ok) {
    const body = yield response.clone().text();
    captureError2(
      new Error(body),
      combineErrorContexts2([
        {
          errorName: `Highmark Fetch Api Response Error - ${path}`,
          context: {
            "Response Info": {
              ok: response.ok,
              redirected: response.redirected,
              response: body,
              status: response.status,
              type: response.type,
              url: response.url
            }
          },
          ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
          tags: { requestUrl: response.url }
        },
        errorContext
      ])
    );
  }
  return promise;
});

// src/api/get-health-services.ts
var HEALTH_SERVICES_URL = "/v1/members/health/services";
var getHealthServices = (partnerAccessToken) => __async(void 0, null, function* () {
  const response = yield highmarkFetch(HEALTH_SERVICES_URL, partnerAccessToken);
  return response.json();
});

// src/hooks/use-get-ebill-eligibility.hook.ts
var QUERY_CACHE_AND_STALE_TIME2 = 5 * 1e3 * 60;
var useGetEBillEligibility = () => {
  const { data: identityTokenData } = useGetIdentityPartnerToken(DEFAULT_PARTNER_ID);
  return useQuery3(
    ["GET_EBILL_ELIGIBILITY" /* EBILL_ELIGIBILITY_KEY */],
    () => getHealthServices(identityTokenData),
    {
      enabled: !!identityTokenData,
      staleTime: QUERY_CACHE_AND_STALE_TIME2,
      cacheTime: QUERY_CACHE_AND_STALE_TIME2
    }
  );
};

// src/hooks/use-get-feature-flag.hook.ts
import { getBoolean, getValue } from "firebase/remote-config";

// src/hooks/use-fetch-and-activate.hook.ts
import { fetchAndActivate } from "firebase/remote-config";
import { useQuery as useQuery4 } from "react-query";
import { captureMessage as captureMessage2 } from "@leagueplatform/observability";
var useFetchAndActivate = ({
  remoteConfig,
  staleTimeOverride,
  cacheTimeOverride,
  defaultValues
}) => (
  /* In production by default Firebase throttles fetch requests to once per 12 hours (per session)
   * We also want to use the same flag values throughout a session to ensure a consistent user experience
   * Setting query cache/stale time to infinite ensures only one call to the server per session
   * For development/debugging these values can be overridden to a lower threshold
   * Additionally `remoteConfig.settings.minimumFetchIntervalMillis` should be set - see utils/init-frebase-remote-config.ts
   */
  useQuery4("REMOTE_CONFIG", () => fetchAndActivate(remoteConfig), {
    staleTime: staleTimeOverride != null ? staleTimeOverride : Infinity,
    cacheTime: cacheTimeOverride != null ? cacheTimeOverride : Infinity,
    onError(error) {
      captureMessage2(
        "Fetch firebase remote config failed, use default values instead",
        {
          severityLevel: "warning",
          errorName: (error == null ? void 0 : error.message) || "error fetching remote config",
          context: {
            Context: { errorInfo: error != null ? error : "no info available", defaultValues }
          }
        }
      );
    }
  })
);

// src/hooks/use-get-feature-flag.hook.ts
var useGetFeatureFlag = ({
  flagName,
  defaultValues,
  remoteConfig,
  staleTimeOverride,
  cacheTimeOverride
}) => {
  const { isLoading, isError } = useFetchAndActivate({
    remoteConfig,
    staleTimeOverride,
    cacheTimeOverride,
    defaultValues
  });
  const isDefault = isLoading || isError;
  return {
    isEnabled: getBoolean(remoteConfig, flagName),
    value: getValue(remoteConfig, flagName),
    isLoading,
    isDefault
  };
};

// src/hooks/use-get-user-profile.tsx
import { useGetUserProfile } from "@leagueplatform/web-common";
var QUERY_CACHE_AND_STALE_TIME3 = 15 * 1e3 * 60;
var useGetHighmarkUserProfile = () => useGetUserProfile({
  staleTime: QUERY_CACHE_AND_STALE_TIME3,
  cacheTime: QUERY_CACHE_AND_STALE_TIME3
});

// src/hooks/use-analytics-identify.hook.ts
import { useMemo } from "react";
import { useAnalyticsIdentify } from "@leagueplatform/web-common";
var useHighmarkAnalyticsIdentify = (tenantId) => {
  const identifyOptions = useMemo(
    () => ({
      employer_group_id: "",
      tenant_id: tenantId
    }),
    [tenantId]
  );
  return useAnalyticsIdentify(identifyOptions, useGetHighmarkUserProfile);
};

// src/hooks/use-inject-cobrowse-script.hook.ts
import { useEffect as useEffect3 } from "react";
var GLIA_VISITOR_URL = "https://api.glia.com/salemove_integration.js";
var useInjectCobrowseScript = (isCobrowseEnabled) => {
  useEffect3(() => {
    if (isCobrowseEnabled) {
      const gliaScript = document.createElement("script");
      gliaScript.async = true;
      gliaScript.src = GLIA_VISITOR_URL;
      document.head.appendChild(gliaScript);
    }
  }, [isCobrowseEnabled]);
};

// src/hooks/use-is-authenticated.ts
import { StandaloneAuth } from "@leagueplatform/auth-standalone";
import { useEffect as useEffect4, useState as useState2 } from "react";
var useIsAuthenticated = () => {
  const [isAuthenticated, setAuthenticated] = useState2(
    void 0
  );
  useEffect4(() => {
    let isMounted = true;
    StandaloneAuth.client.isAuthenticated().then((authenticated) => {
      if (isMounted) {
        setAuthenticated(authenticated);
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);
  return { isAuthenticated };
};

// src/hooks/use-mobile-app-download-links.hook.ts
import { useIntl } from "@leagueplatform/locales";
import AppStoreTransparent from "./assets/mobile-app-icons/app-store-transparent.svg";
import PlayStoreTransparent from "./assets/mobile-app-icons/play-store-transparent.svg";
var useMobileAppDownloadLinks = (appStoreUrl, playStoreUrl) => {
  const { formatMessage } = useIntl();
  const mobileAppDownloadLinks = [
    {
      src: AppStoreTransparent,
      alt: formatMessage({ id: "DISCLAIMER_CTA_APPSTORE" }),
      url: appStoreUrl
    },
    {
      src: PlayStoreTransparent,
      alt: formatMessage({ id: "DISCLAIMER_CTA_PLAYSTORE" }),
      url: playStoreUrl
    }
  ];
  return { mobileAppDownloadLinks };
};

// src/hooks/use-named-greeting.tsx
import { useIntl as useIntl2 } from "@leagueplatform/locales";

// src/hooks/use-preferred-first-name.tsx
var usePreferredFirstName = () => {
  var _a, _b, _c, _d, _e;
  const { data, isLoading, error } = useGetHighmarkUserProfile();
  const preferredFirstName = (_e = (_d = (_c = (_a = data == null ? void 0 : data.userProfile) == null ? void 0 : _a.preferredFirstName) != null ? _c : (_b = data == null ? void 0 : data.userProfile) == null ? void 0 : _b.firstName) != null ? _d : data == null ? void 0 : data.email) != null ? _e : "";
  return { data: { preferredFirstName }, isLoading, error };
};

// src/hooks/use-named-greeting.tsx
var greetingIDs = {
  morning: "GOOD_MORNING",
  afternoon: "GOOD_AFTERNOON",
  evening: "GOOD_EVENING",
  morning_name: "GOOD_MORNING_WITH_NAME",
  afternoon_name: "GOOD_AFTERNOON_WITH_NAME",
  evening_name: "GOOD_EVENING_WITH_NAME"
};
var getGreeting = () => {
  const hours = new Date(Date.now()).getHours();
  const MORNING = 12;
  const AFTERNOON = 18;
  if (hours < MORNING)
    return "morning";
  if (hours < AFTERNOON)
    return "afternoon";
  return "evening";
};
var useNamedGreeting = () => {
  const { formatMessage } = useIntl2();
  const { data } = usePreferredFirstName();
  const greeting = getGreeting();
  const greetingSuffix = data.preferredFirstName ? "_name" : "";
  const namedGreeting = formatMessage(
    { id: greetingIDs[greeting + greetingSuffix] },
    { name: data.preferredFirstName }
  );
  return { namedGreeting };
};

// src/hooks/use-nav-links-list.hook.tsx
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import HomeIcon from "./assets/nav/home.svg";
import BenefitsIcon from "./assets/nav/wallet.svg";
import GetCareIcon from "./assets/nav/get-care.svg";
import SupportIcon from "./assets/nav/support.svg";
import JourneyIcon from "./assets/nav/journey.svg";
import HomeSelectedIcon from "./assets/nav/home-selected.svg";
import BenefitsSelectedIcon from "./assets/nav/wallet-selected.svg";
import GetCareSelectedIcon from "./assets/nav/get-care-selected.svg";
import JourneySelectedIcon from "./assets/nav/journey-selected.svg";
import SupportSelectedIcon from "./assets/nav/support-selected.svg";
var NavIds = /* @__PURE__ */ ((NavIds2) => {
  NavIds2["HOME"] = "HOME";
  NavIds2["BENEFITS"] = "BENEFITS";
  NavIds2["CARE"] = "GET_CARE";
  NavIds2["JOURNEY"] = "JOURNEY";
  NavIds2["SUPPORT"] = "SUPPORT";
  return NavIds2;
})(NavIds || {});
var LinkType = /* @__PURE__ */ ((LinkType2) => {
  LinkType2["NAV"] = "navLink";
  LinkType2["LINK"] = "link";
  return LinkType2;
})(LinkType || {});
var useNavLinksList = () => {
  const NavLinksList = [
    {
      to: "/home",
      message_id: "HOME" /* HOME */,
      type: "navLink" /* NAV */,
      icon: HomeIcon,
      iconSelected: HomeSelectedIcon
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.wallet),
      message_id: "BENEFITS" /* BENEFITS */,
      type: "navLink" /* NAV */,
      icon: BenefitsIcon,
      iconSelected: BenefitsSelectedIcon
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.careDiscovery),
      message_id: "GET_CARE" /* CARE */,
      type: "navLink" /* NAV */,
      icon: GetCareIcon,
      iconSelected: GetCareSelectedIcon
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
      message_id: "JOURNEY" /* JOURNEY */,
      type: "navLink" /* NAV */,
      icon: JourneyIcon,
      iconSelected: JourneySelectedIcon
    },
    {
      to: APP_MANAGED_ROUTES.SUPPORT,
      message_id: "SUPPORT" /* SUPPORT */,
      type: "navLink" /* NAV */,
      icon: SupportIcon,
      iconSelected: SupportSelectedIcon
    }
  ];
  return {
    navLinks: NavLinksList
  };
};

// src/hooks/use-private-routes-container/use-private-routes-container.ts
import { useState as useState4 } from "react";

// src/hooks/use-get-test-config-flags.hook.ts
import { useState as useState3, useEffect as useEffect5 } from "react";

// src/types/highmark-common.types.ts
var TEST_CONFIG_FLAGS = /* @__PURE__ */ ((TEST_CONFIG_FLAGS2) => {
  TEST_CONFIG_FLAGS2["forceAppWalkthrough"] = "force_app_walkthrough";
  TEST_CONFIG_FLAGS2["testSsoLink"] = "test_sso_link";
  TEST_CONFIG_FLAGS2["enableClaims"] = "enable_claims";
  return TEST_CONFIG_FLAGS2;
})(TEST_CONFIG_FLAGS || {});

// src/utils/get-test-config-flags.util.ts
import { AppEnvironment, ENVIRONMENT } from "@leagueplatform/core";
var getTestConfigFlags = (configFlag) => {
  const newConfig = {};
  if (AppEnvironment.environment !== ENVIRONMENT.PRODUCTION) {
    Object.entries(TEST_CONFIG_FLAGS).forEach(([key, value]) => {
      newConfig[key] = localStorage.getItem(value);
    });
  }
  if (configFlag) {
    return newConfig[configFlag];
  }
  return newConfig;
};

// src/hooks/use-get-test-config-flags.hook.ts
var useTestConfigFlags = () => {
  const [flags, setFlags] = useState3({});
  useEffect5(() => {
    const configFlags = getTestConfigFlags();
    setFlags(configFlags);
  }, []);
  return __spreadValues({}, flags);
};

// src/hooks/use-private-routes-container/use-private-routes-container.ts
var usePrivateRoutesContainer = () => {
  var _a, _b;
  const [walkthroughCompleted, setWalkthroughCompleted] = useState4(false);
  const [mfaCompleted, setMfaCompleted] = useState4(false);
  const { forceAppWalkthrough } = useTestConfigFlags();
  const {
    eligibilityInfo,
    mfaEnrolled,
    contentConfig,
    isLoading: isLoadingAppInitdetails,
    isError: isErrorAppInitDetails
  } = useGetAppInitDetails({
    onSuccess: captureUserIneligibleEvent
  });
  const {
    data: userData,
    isLoading: isLoadingUserProfile,
    isError: isErrorUserProfile
  } = useGetHighmarkUserProfile();
  const hasUserAcceptedTerms = ((_b = (_a = userData == null ? void 0 : userData.userProfile) == null ? void 0 : _a.memberTermsAndConditions) == null ? void 0 : _b.dateAccepted) || false;
  const showWalkthrough = (forceAppWalkthrough === "true" || !hasUserAcceptedTerms) && !walkthroughCompleted;
  const showMfa = !mfaEnrolled && !mfaCompleted;
  return {
    contentConfig,
    eligibilityInfo,
    showWalkthrough,
    onCompleteWalkthrough: () => setWalkthroughCompleted(true),
    showMfa,
    onCompleteMfa: () => setMfaCompleted(true),
    isLoading: isLoadingAppInitdetails || isLoadingUserProfile,
    isErrorAppInitDetails,
    isErrorUserProfile
  };
};

// src/utils/link-handler.ts
import { toastActions, TOAST_STATUS } from "@leagueplatform/toast-messages";
import { isAbsoluteUrl } from "@leagueplatform/web-common";
import { history } from "@leagueplatform/routing";
var _lastPassedUrl, _history;
var LinkHandlerClass = class {
  constructor(historyFromClass) {
    __privateAdd(this, _lastPassedUrl, "");
    __privateAdd(this, _history, void 0);
    this.handleLink = (urlString, target) => __async(this, null, function* () {
      if (!isAbsoluteUrl(urlString)) {
        toastActions.add({
          type: TOAST_STATUS.ERROR,
          textId: "EXTERNAL_URL_REDIRECT_FAILED"
        });
        captureSsoError(new Error("Target URL is not absolute url."), urlString);
        return;
      }
      const url = new URL(urlString);
      const linkType = (url.searchParams.get(QUERY_PARAM_KEYS.linkType) || "").toLowerCase();
      url.searchParams.delete(QUERY_PARAM_KEYS.linkType);
      const partnerId = url.searchParams.get(QUERY_PARAM_KEYS.partnerId) || DEFAULT_PARTNER_ID;
      url.searchParams.delete(QUERY_PARAM_KEYS.partnerId);
      switch (linkType) {
        case "authedwebview" /* AUTHED_WEBVIEW */: {
          __privateSet(this, _lastPassedUrl, url.toString());
          const params = new URLSearchParams(window.location.search);
          params.set(QUERY_PARAM_KEYS.modal, WEBVIEW_MODAL_QUERY_PARAM_VALUE);
          __privateGet(this, _history).push({
            search: params.toString()
          });
          break;
        }
        case "sso" /* SSO */: {
          const newWindow = window.open(url, "_blank");
          if (!newWindow) {
            toastActions.add({
              type: TOAST_STATUS.ERROR,
              textId: "EXTERNAL_URL_REDIRECT_FAILED"
            });
            captureSsoError(
              new Error("Target SSO new window does not exist."),
              urlString
            );
          }
          let isAuthSuccessful = false;
          const messageHandler = (event) => __async(this, null, function* () {
            logger.log("Received message", event);
            try {
              const isAuthenticated = yield sendAuthTokenIfReady(
                event,
                url.origin,
                newWindow,
                partnerId
              );
              if (isAuthenticated) {
                isAuthSuccessful = true;
                window.removeEventListener("message", messageHandler);
              }
            } catch (e) {
              toastActions.add({
                type: TOAST_STATUS.ERROR,
                textId: "EXTERNAL_URL_REDIRECT_FAILED"
              });
              captureSsoError(e instanceof Error ? e : new Error(e), urlString);
            }
          });
          window.addEventListener("message", messageHandler);
          setTimeout(() => {
            if (!isAuthSuccessful) {
              window.removeEventListener("message", messageHandler);
              captureSsoError(
                new Error(
                  `Could not send auth token, ready message not received within ${SSO_READY_LISTENER_TIMEOUT}ms from new window.`
                ),
                urlString
              );
              toastActions.add({
                type: TOAST_STATUS.ERROR,
                textId: "EXTERNAL_URL_REDIRECT_FAILED"
              });
            }
          }, SSO_READY_LISTENER_TIMEOUT);
          break;
        }
        default:
          window.open(url, target || "_blank", "noopener,noreferrer");
      }
    });
    __privateSet(this, _history, historyFromClass);
  }
  get lastPassedUrl() {
    return __privateGet(this, _lastPassedUrl);
  }
};
_lastPassedUrl = new WeakMap();
_history = new WeakMap();
var LinkHandler = new LinkHandlerClass(history);

// src/hooks/use-user-dropdown.hook.tsx
var useUserDropdown = (userDropdownConfig) => {
  const { data, isLoading, error } = usePreferredFirstName();
  let userDropdownConfigResult = userDropdownConfig;
  const { testSsoLink } = useTestConfigFlags();
  if (testSsoLink) {
    const testLinks = [
      {
        text: `SSO Link: ${testSsoLink}`,
        onClick: () => {
          LinkHandler.handleLink(
            buildSsoUrl({
              path: testSsoLink,
              linkType: "sso" /* SSO */,
              baseUrlType: "highmarkSsoAppUrl" /* SSO_APP_URL */
            })
          );
        }
      }
    ];
    userDropdownConfigResult = [testLinks, ...userDropdownConfig];
  }
  const dropdownMenuItemProps = {
    preferredFirstName: data.preferredFirstName,
    menuItemsConfig: userDropdownConfigResult
  };
  return { data: dropdownMenuItemProps, isLoading, error };
};

// src/components/webview-modal/authed-webview-modal.component.tsx
import React5, { useRef } from "react";
import { useIntl as useIntl4 } from "@leagueplatform/locales";

// src/components/error/error-state.component.tsx
import React2 from "react";
import { Flex } from "@leagueplatform/genesis-commons";

// src/components/full-screen-container.component.tsx
import React from "react";
import {
  Box
} from "@leagueplatform/genesis-commons";
var FullScreenContainer = ({
  backgroundColor,
  children
}) => /* @__PURE__ */ React.createElement(
  Box,
  {
    role: "dialog",
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "100",
    backgroundColor
  },
  children
);

// src/components/error/error-state.component.tsx
import { ErrorState as WebCommonErrorState } from "@leagueplatform/web-common-components";
var ErrorState = (_a) => {
  var _b = _a, {
    styleProps,
    isFullPage = false,
    hideButton = false
  } = _b, errorData = __objRest(_b, [
    "styleProps",
    "isFullPage",
    "hideButton"
  ]);
  const errorContent = useErrorMessage(errorData);
  if (isFullPage) {
    return /* @__PURE__ */ React2.createElement(FullScreenContainer, { backgroundColor: "surface.background.primary" }, /* @__PURE__ */ React2.createElement(
      Flex,
      __spreadValues({
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        maxWidth: "350px"
      }, styleProps),
      /* @__PURE__ */ React2.createElement(WebCommonErrorState, __spreadValues({ hideButton }, errorContent))
    ));
  }
  return /* @__PURE__ */ React2.createElement(
    Flex,
    __spreadValues({
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center"
    }, styleProps),
    /* @__PURE__ */ React2.createElement(WebCommonErrorState, __spreadValues({ hideButton }, errorContent))
  );
};

// src/components/iframe-modal/iframe-modal.component.tsx
import React3 from "react";
import {
  Box as Box2,
  QuietButton,
  VisuallyHidden,
  Flex as Flex2,
  SubtitleOne,
  Image
} from "@leagueplatform/genesis-commons";
import { Modal, useModalA11yProps } from "@leagueplatform/ui-kit";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import CLOSE_ICON from "./assets/close.svg";
var DEFAULT_HEADER_HEIGHT = "50px";
var modalTitleId = "iframe-modal-title";
var IframeModal = ({
  onClose,
  children,
  headerHeight = DEFAULT_HEADER_HEIGHT,
  title
}) => {
  const { formatMessage } = useIntl3();
  const {
    "aria-label": ariaLabel,
    "aria-modal": ariaModal,
    role
  } = useModalA11yProps(title);
  return /* @__PURE__ */ React3.createElement(Modal.Wrapper, { options: {}, onClose }, /* @__PURE__ */ React3.createElement(
    Box2,
    {
      position: "relative",
      width: "85vw",
      borderRadius: "medium",
      overflow: "hidden",
      height: "calc(100vh - 96px)",
      "aria-labelledby": modalTitleId
    },
    /* @__PURE__ */ React3.createElement(
      Flex2,
      {
        height: headerHeight,
        justifyContent: "flex-end",
        backgroundColor: "surface.background.primary"
      },
      title && /* @__PURE__ */ React3.createElement(SubtitleOne, { id: modalTitleId, margin: "auto" }, title),
      onClose && /* @__PURE__ */ React3.createElement(
        QuietButton,
        {
          lineHeight: "caption",
          top: "half",
          right: "one",
          paddingX: "half",
          paddingY: "half",
          onClick: onClose,
          position: "absolute"
        },
        /* @__PURE__ */ React3.createElement(VisuallyHidden, null, formatMessage({ id: "CLOSE" })),
        /* @__PURE__ */ React3.createElement(
          Image,
          {
            src: CLOSE_ICON,
            role: "presentation",
            type: "button",
            "aria-hidden": "true",
            stroke: "interactive.action.primary"
          }
        )
      )
    ),
    /* @__PURE__ */ React3.createElement(
      Box2,
      {
        tabIndex: "0",
        height: `calc(100% - ${headerHeight})`,
        width: "100%",
        backgroundColor: "surface.background.primary",
        "aria-label": ariaLabel,
        "aria-modal": ariaModal,
        role
      },
      children
    )
  ));
};

// src/components/spinner/loading-spinner.component.tsx
import * as React4 from "react";
import {
  Box as Box3,
  css,
  Flex as Flex3,
  genesisStyled,
  useTheme,
  VisuallyHidden as VisuallyHidden2
} from "@leagueplatform/genesis-commons";
import spinner from "./assets/loading.png";
var AnimatedSpinner = genesisStyled(Box3)(
  css({
    height: "48px",
    width: "48px",
    backgroundImage: `url(${spinner})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "36px 22px",
    animation: "rotate 1s linear infinite forwards",
    "@keyframes rotate": {
      to: {
        transform: "rotate(360deg)"
      }
    }
  })
);
var SpinnerPositioner = genesisStyled(Flex3)(
  css({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  })
);
var CircleOutline = genesisStyled(SpinnerPositioner)(
  css({
    borderWidth: "6px",
    borderStyle: "solid",
    borderRadius: "100px",
    height: "48px",
    width: "48px"
  })
);
var LoadingContainer = genesisStyled(Box3)(
  css({
    width: "50px",
    height: "50px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  })
);
var LoadingSpinner = (_a) => {
  var props = __objRest(_a, []);
  const { colors } = useTheme();
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ React4.createElement(LoadingContainer, __spreadValues({}, props), /* @__PURE__ */ React4.createElement(
      CircleOutline,
      {
        "aria-hidden": "true",
        borderColor: colors.decorative.brand.primary.pastel
      }
    ), /* @__PURE__ */ React4.createElement(SpinnerPositioner, { "aria-hidden": "true" }, /* @__PURE__ */ React4.createElement(AnimatedSpinner, null)), /* @__PURE__ */ React4.createElement(VisuallyHidden2, null, "Loading."))
  );
};
LoadingSpinner.displayName = "LoadingSpinner";

// src/components/webview-modal/authed-webview-modal.component.tsx
var AuthedWebviewModal = React5.memo(
  ({ linkHandler }) => {
    const iframeRef = useRef(null);
    const { closeModal, isOpen, url, error, isLoading } = useAuthedWebviewModal(
      iframeRef,
      linkHandler
    );
    const { formatMessage } = useIntl4();
    if (!isOpen)
      return null;
    const modalTitle = formatMessage({ id: "AUTHED_WEBVIEW_MODAL_TITLE" });
    return /* @__PURE__ */ React5.createElement(IframeModal, { onClose: closeModal }, error ? /* @__PURE__ */ React5.createElement(
      ErrorState,
      {
        errorType: "api_error" /* API_ERROR */,
        hideButton: true,
        styleProps: { height: "100%" }
      }
    ) : /* @__PURE__ */ React5.createElement(React5.Fragment, null, isLoading && /* @__PURE__ */ React5.createElement(LoadingSpinner, null), /* @__PURE__ */ React5.createElement(
      "iframe",
      {
        id: "authedWebviewModal",
        ref: iframeRef,
        height: "100%",
        width: "100%",
        title: modalTitle,
        src: url
      }
    )));
  }
);

// src/components/base-path-redirect/base-path-redirect.component.tsx
import React6 from "react";
import { useLocation, Redirect } from "@leagueplatform/routing";
var BasePathRedirect = ({
  targetBasePath
}) => {
  const location = useLocation();
  return /* @__PURE__ */ React6.createElement(
    Redirect,
    {
      to: __spreadProps(__spreadValues({}, location), {
        // Replaces first path string before non character value (/, ?, etc) with new path, e.g. /old-path/same -> /new-path/same
        pathname: location.pathname.replace(/^\/[\w-]+/, targetBasePath)
      })
    }
  );
};

// src/components/page-blocker/page-blocker-container.component.tsx
import React9, { useContext } from "react";

// src/pages/page-blocker/plan-ended-blocker.page.tsx
import {
  Box as Box4,
  HeadingText,
  ParagraphText,
  StackLayout,
  styled,
  TextAction
} from "@leagueplatform/genesis-core";
import React7 from "react";
import { PageHeaderBackground } from "@leagueplatform/web-common-components";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import planEndedIcon from "./assets/plan-period-ended.svg";
import { Image as Image2 } from "@leagueplatform/genesis-commons";
import { useHistory as useHistory2 } from "@leagueplatform/routing";
import {
  EVENT_NAME,
  PRODUCT_AREA,
  trackAnalyticsEvent
} from "@leagueplatform/analytics";
var maximumWidth = 1280;
var Wrapper = styled(Box4, {
  "@desktop": {
    marginLeft: "calc(100vw - 100%)",
    marginRight: 0
  }
});
var PlanEndedBlockerPage = ({
  contentRoute
}) => {
  const { formatMessage } = useIntl5();
  const history2 = useHistory2();
  const handleClick = (screenName) => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      screen_name: screenName,
      product_area: screenName,
      detail: "Get support",
      sub_detail: "Plan period has ended",
      sub_product_area: screenName
    });
    history2.push(APP_MANAGED_ROUTES.SUPPORT);
  };
  return /* @__PURE__ */ React7.createElement(Wrapper, { css: { padding: "$none $two" } }, /* @__PURE__ */ React7.createElement(PageHeaderBackground, null, /* @__PURE__ */ React7.createElement(
    Box4,
    {
      css: {
        display: "flex",
        width: "100%",
        maxWidth: maximumWidth,
        marginLeft: "auto",
        marginRight: "auto",
        justifyContent: "space-between"
      }
    },
    /* @__PURE__ */ React7.createElement(HeadingText, { size: "xxl", level: "1", css: { marginTop: "$twoAndHalf" } }, formatMessage({
      id: contentRoute === "getCare" /* CARE */ ? "GET_CARE" : "JOURNEY"
    }))
  )), /* @__PURE__ */ React7.createElement(
    Box4,
    {
      css: { paddingTop: "60px", "@mobile": { paddingTop: "$oneAndHalf" } }
    },
    /* @__PURE__ */ React7.createElement(
      StackLayout,
      {
        spacing: "$half",
        horizontalAlignment: "center",
        css: { width: "100%" }
      },
      /* @__PURE__ */ React7.createElement(
        Image2,
        {
          src: planEndedIcon,
          alt: formatMessage({ id: "BLOCKER_ALT_TEXT" }),
          width: "176px",
          height: "176px",
          marginBottom: "one"
        }
      ),
      /* @__PURE__ */ React7.createElement(HeadingText, { size: "lg", level: "2" }, formatMessage({ id: "BLOCKER_TITLE" })),
      /* @__PURE__ */ React7.createElement(ParagraphText, { css: { maxWidth: "380px", textAlign: "center" } }, formatMessage({ id: "BLOCKER_DESCRIPTION" })),
      /* @__PURE__ */ React7.createElement(
        TextAction,
        {
          as: "button",
          onClick: () => handleClick(
            contentRoute === "getCare" /* CARE */ ? PRODUCT_AREA.GET_CARE : PRODUCT_AREA.JOURNEY
          )
        },
        formatMessage({ id: "GET_SUPPORT_SUBTITLE" })
      )
    )
  ));
};

// src/components/page-blocker/page-eligibility-context.tsx
import React8 from "react";
var PageEligibilityContext = React8.createContext({
  home: void 0,
  benefits: void 0,
  getCare: void 0,
  journey: void 0,
  support: void 0
});

// src/components/page-blocker/page-blocker-container.component.tsx
var PageBlockerContainer = ({
  children,
  contentRoute
}) => {
  const { [contentRoute]: targetRoute } = useContext(PageEligibilityContext);
  if (targetRoute === "NO_LONGER_EFFECTIVE" /* NO_LONGER_EFFECTIVE */) {
    return /* @__PURE__ */ React9.createElement(PlanEndedBlockerPage, { contentRoute });
  }
  return children;
};

// src/components/disclaimer/disclaimer.components.tsx
import {
  Box as Box7,
  css as css3,
  Flex as Flex4,
  genesisStyled as genesisStyled3,
  QuietButton as QuietButton3,
  SubtleLink
} from "@leagueplatform/genesis-commons";
import React12, { useState as useState5 } from "react";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import { ParagraphText as ParagraphText2 } from "@leagueplatform/genesis-core";

// src/components/disclaimer/legal-modal.component.tsx
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import { BodyOne, Box as Box6, HeadingTwo } from "@leagueplatform/genesis-commons";
import React11 from "react";

// src/components/modal-wrapper/modal-wrapper.component.tsx
import * as React10 from "react";
import { Icon, ICONS, Modal as Modal2 } from "@leagueplatform/ui-kit";
import {
  Box as Box5,
  css as css2,
  genesisStyled as genesisStyled2,
  PrimaryButton,
  QuietButton as QuietButton2,
  VisuallyHidden as VisuallyHidden3
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
var StyledModalContainer = genesisStyled2(Modal2.Container)(
  css2({
    position: "relative",
    borderRadius: "medium",
    backgroundColor: "surface.background.primary",
    padding: "oneAndHalf",
    paddingTop: "four"
  })
);
var ModalWrapper = ({
  onClose,
  modalLabel,
  children,
  confirmButtonText,
  onConfirmClick = () => {
    onClose();
  },
  maxWidth = "380px"
}) => {
  const { formatMessage } = useIntl6();
  return /* @__PURE__ */ React10.createElement(Modal2.Wrapper, { options: {}, onClose }, /* @__PURE__ */ React10.createElement(StyledModalContainer, { maxWidth, "aria-label": modalLabel }, /* @__PURE__ */ React10.createElement(Box5, { position: "absolute", right: "0", top: "0" }, /* @__PURE__ */ React10.createElement(
    QuietButton2,
    {
      paddingY: "quarter",
      paddingX: "half",
      paddingTop: "none",
      margin: "half",
      onClick: onClose
    },
    /* @__PURE__ */ React10.createElement(VisuallyHidden3, null, formatMessage({ id: "CLOSE" })),
    /* @__PURE__ */ React10.createElement(Icon, { icon: ICONS.CLOSE, size: 16, "aria-hidden": "true" })
  )), /* @__PURE__ */ React10.createElement(Box5, null, children, confirmButtonText && /* @__PURE__ */ React10.createElement(PrimaryButton, { width: 1, onClick: onConfirmClick, marginTop: "five" }, confirmButtonText))));
};

// src/components/disclaimer/legal-modal.component.tsx
var LegalModal = ({ onClose, isOpen }) => {
  const { formatMessage } = useIntl7();
  if (!isOpen)
    return null;
  return /* @__PURE__ */ React11.createElement(
    ModalWrapper,
    {
      maxWidth: "882px",
      onClose,
      modalLabel: formatMessage({ id: "LEGAL_MODAL_TITLE" })
    },
    /* @__PURE__ */ React11.createElement(Box6, { marginX: "three" }, /* @__PURE__ */ React11.createElement(HeadingTwo, { id: "modalTitle", marginBottom: "oneAndHalf" }, formatMessage({ id: "LEGAL_MODAL_TITLE" })), /* @__PURE__ */ React11.createElement(BodyOne, { marginY: "oneAndHalf", textAlign: "left" }, formatMessage({ id: "LEGAL_MODAL_BODY_1" })), /* @__PURE__ */ React11.createElement(BodyOne, { marginY: "oneAndHalf", textAlign: "left" }, formatMessage({ id: "LEGAL_MODAL_BODY_2" })), /* @__PURE__ */ React11.createElement(BodyOne, { marginY: "oneAndHalf", textAlign: "left" }, formatMessage({ id: "LEGAL_MODAL_BODY_3" })), /* @__PURE__ */ React11.createElement(BodyOne, { marginY: "oneAndHalf", textAlign: "left" }, formatMessage({ id: "LEGAL_MODAL_BODY_4" })))
  );
};

// src/components/disclaimer/disclaimer.components.tsx
var DisclaimerContent = genesisStyled3(Box7)(
  css3({
    "&& > *": {
      marginBottom: "one"
    },
    "&& > :last-child": {
      marginBottom: "0"
    }
  })
);
var UnstyledLinkButton = ({
  onClick,
  children
}) => /* @__PURE__ */ React12.createElement(
  SubtleLink,
  {
    as: QuietButton3,
    hoverStyle: {
      backgroundColor: "transparent !important"
    },
    target: "_blank",
    border: "none",
    fontSize: "body2",
    color: "tertiary.text.default",
    onClick
  },
  children
);
var Disclaimer = ({
  disclaimer = "",
  hasLegalModal = false
}) => {
  const { formatMessage } = useIntl8();
  const [showLegalModal, setShowModal] = useState5(false);
  return /* @__PURE__ */ React12.createElement(Flex4, null, /* @__PURE__ */ React12.createElement(DisclaimerContent, null, disclaimer.split("\n").filter((text) => text !== "").map((text) => /* @__PURE__ */ React12.createElement(ParagraphText2, { size: "sm", key: text }, text)), hasLegalModal && /* @__PURE__ */ React12.createElement(UnstyledLinkButton, { onClick: () => setShowModal(true) }, formatMessage({ id: "READ_MORE" }))), hasLegalModal && /* @__PURE__ */ React12.createElement(
    LegalModal,
    {
      isOpen: showLegalModal,
      onClose: () => setShowModal(false)
    }
  ));
};

// src/components/footer/footer.component.tsx
import React16 from "react";

// src/components/asset-links/asset-link.component.tsx
import { Image as Image3, Link } from "@leagueplatform/genesis-commons";
import { EVENT_NAME as EVENT_NAME2, trackAnalyticsEvent as trackAnalyticsEvent2 } from "@leagueplatform/analytics";
import React13 from "react";
var AssetLink = ({ src, alt, url, styleProps }) => {
  const { isAuthenticated } = useIsAuthenticated();
  const trackAnalytics = (targetDetail) => {
    if (isAuthenticated) {
      trackAnalyticsEvent2(EVENT_NAME2.RESOURCE_CLICKED, {
        detail: targetDetail,
        sub_product_area: "footer"
      });
    }
  };
  return /* @__PURE__ */ React13.createElement(
    Link,
    __spreadValues({
      href: url,
      border: "none",
      hoverStyle: {
        backgroundColor: "transparent !important"
      },
      onClick: () => trackAnalytics(alt),
      target: "_blank"
    }, styleProps),
    /* @__PURE__ */ React13.createElement(Image3, { src, alt })
  );
};

// src/components/footer/footer.component.tsx
import { CONTENT_MAX_WIDTH } from "@leagueplatform/web-common-components";
import { StackLayout as StackLayout3 } from "@leagueplatform/genesis-core";

// src/components/footer/footer-items/footer-links-container.component.tsx
import React15 from "react";
import { StackLayout as StackLayout2 } from "@leagueplatform/genesis-core";

// src/components/footer/footer-items/footer-link-items.component.tsx
import { EVENT_NAME as EVENT_NAME3, trackAnalyticsEvent as trackAnalyticsEvent3 } from "@leagueplatform/analytics";
import { InternalOrExternalLink } from "@leagueplatform/web-common-components";
import React14 from "react";
var FooterLinkItems = ({
  linkItems,
  styleProps
}) => {
  const { isAuthenticated } = useIsAuthenticated();
  const trackAnalytics = (eventName, targetDetail) => {
    trackAnalyticsEvent3(eventName, {
      detail: targetDetail,
      sub_product_area: "footer"
    });
  };
  const handleClick = (event, item) => {
    if (isAuthenticated) {
      trackAnalytics(
        item.url ? EVENT_NAME3.RESOURCE_CLICKED : EVENT_NAME3.BUTTON_CLICKED,
        item.text
      );
    }
    if (item.onClick) {
      event.preventDefault();
      item.onClick();
    }
  };
  return /* @__PURE__ */ React14.createElement(React14.Fragment, null, linkItems.map((item) => /* @__PURE__ */ React14.createElement(
    InternalOrExternalLink,
    __spreadValues(__spreadValues({
      border: "none",
      marginX: "threeQuarters",
      fontSize: "body2",
      key: item.text,
      href: item.url,
      onClick: (event) => handleClick(event, item),
      hoverStyle: {
        backgroundColor: "transparent !important"
      },
      target: "_blank"
    }, item.linkProps), styleProps),
    item.text
  )));
};

// src/components/footer/footer-items/footer-links-container.component.tsx
var FooterLinksLayoutWrapper = ({ children }) => /* @__PURE__ */ React15.createElement(
  StackLayout2,
  {
    orientation: {
      "@initial": "vertical",
      "@laptop": "horizontal",
      "@desktop": "horizontal"
    },
    horizontalAlignment: "center",
    verticalAlignment: {
      "@initial": "top",
      "@laptop": "spaceBetween",
      "@desktop": "spaceBetween"
    },
    css: {
      marginBottom: "$half",
      flexWrap: "wrap",
      "@laptop": {
        flexWrap: "nowrap"
      },
      "@desktop": {
        flexWrap: "nowrap"
      }
    }
  },
  children
);
var FooterLinksAndIconsSection = ({
  footerLinks,
  footerIcons
}) => /* @__PURE__ */ React15.createElement(FooterLinksLayoutWrapper, null, /* @__PURE__ */ React15.createElement(
  StackLayout2,
  {
    orientation: {
      "@initial": "vertical",
      "@laptop": "horizontal",
      "@desktop": "horizontal"
    },
    horizontalAlignment: {
      "@initial": "center",
      "@laptop": "start",
      "@desktop": "start"
    },
    css: {
      marginBottom: "$one",
      flexWrap: "wrap",
      flexBasis: "auto"
    }
  },
  /* @__PURE__ */ React15.createElement(
    FooterLinkItems,
    {
      linkItems: footerLinks,
      styleProps: {
        display: "flex",
        marginRight: { _: "none", laptop: "oneAndHalf" },
        marginLeft: "none",
        marginBottom: { _: "one", laptop: "none" },
        justifyContent: { _: "center", laptop: "start" }
      }
    }
  )
), !!footerIcons && /* @__PURE__ */ React15.createElement(
  StackLayout2,
  {
    css: {
      flexWrap: "wrap",
      alignItems: "center",
      flexBasis: "auto",
      "@laptop": {
        flexWrap: "nowrap"
      },
      "@desktop": {
        flexWrap: "nowrap"
      }
    },
    orientation: "horizontal",
    horizontalAlignment: {
      "@initial": "center",
      "@laptop": "end",
      "@desktop": "end"
    }
  },
  footerIcons.map((item) => /* @__PURE__ */ React15.createElement(
    AssetLink,
    {
      key: item.url,
      src: item.src,
      alt: item.alt,
      url: item.url,
      styleProps: {
        marginBottom: "two",
        marginX: { _: "one", laptop: "half" },
        width: { _: "twoAndHalf", laptop: "oneAndHalf" }
      }
    }
  ))
));

// src/components/footer/footer.component.tsx
var FooterLayoutWrapper = ({ children }) => /* @__PURE__ */ React16.createElement(
  StackLayout3,
  {
    orientation: {
      "@initial": "vertical",
      "@laptop": "horizontal",
      "@desktop": "horizontal"
    },
    horizontalAlignment: "center",
    css: {
      padding: "$two $one",
      "@laptop": {
        padding: "$none $one"
      },
      "@desktop": {
        padding: "$none $four"
      },
      backgroundColor: "$surfaceBackgroundSecondary"
    }
  },
  children
);
var Footer = ({
  disclaimer,
  footerAppDownloadAssets,
  branding,
  footerLinks,
  footerIcons
}) => /* @__PURE__ */ React16.createElement(FooterLayoutWrapper, null, /* @__PURE__ */ React16.createElement(
  StackLayout3,
  {
    orientation: "vertical",
    horizontalAlignment: "center",
    spacing: "$one",
    css: {
      flexGrow: 0,
      margin: "$one",
      "@laptop": {
        margin: "$twoAndHalf"
      },
      "@desktop": {
        margin: "$twoAndHalf"
      }
    }
  },
  !!branding && branding,
  /* @__PURE__ */ React16.createElement(StackLayout3, { spacing: "$half" }, footerAppDownloadAssets.map((item) => /* @__PURE__ */ React16.createElement(
    AssetLink,
    {
      key: item.url,
      src: item.src,
      alt: item.alt,
      url: item.url,
      styleProps: {
        marginX: { _: "quarter", laptop: "threeQuarters" },
        width: "170px"
      }
    }
  )))
), /* @__PURE__ */ React16.createElement(
  StackLayout3,
  {
    orientation: "vertical",
    horizontalAlignment: {
      "@initial": "center",
      "@laptop": "stretch",
      "@desktop": "stretch"
    },
    css: {
      margin: "$one",
      maxWidth: CONTENT_MAX_WIDTH,
      "@laptop": {
        margin: "$twoAndHalf"
      },
      "@desktop": {
        margin: "$twoAndHalf"
      }
    }
  },
  /* @__PURE__ */ React16.createElement(
    FooterLinksAndIconsSection,
    {
      footerLinks,
      footerIcons
    }
  ),
  disclaimer
));

// src/components/spinner/full-page-loading-spinner.component.tsx
import React17 from "react";
var FullPageLoadingSpinner = () => /* @__PURE__ */ React17.createElement(FullScreenContainer, { backgroundColor: "surface.background.primary" }, /* @__PURE__ */ React17.createElement(LoadingSpinner, null));

// src/components/home/get-assistance-section/get-assistance-section.component.tsx
import { GetAssistanceNow } from "@leagueplatform/care-discovery";
import { SkeletonBox } from "@leagueplatform/web-common-components";
import React18 from "react";

// src/components/home/get-assistance-section/use-get-assistance.hook.tsx
import {
  getCareProviders
} from "@leagueplatform/care-discovery-api";
import { useQuery as useQuery5 } from "react-query";
var BENEFIT_IDS = /* @__PURE__ */ ((BENEFIT_IDS3) => {
  BENEFIT_IDS3["CALL_MEMBER_SERVICES"] = "771dad3f2bd2b5837ccede93df321240";
  BENEFIT_IDS3["AMWELL_WELL360"] = "4843416d77656c6c0000000000000000";
  return BENEFIT_IDS3;
})(BENEFIT_IDS || {});
var benefitIdEnabled = (item, targetBenefits) => {
  let enabled = false;
  targetBenefits.forEach((benefitId) => {
    var _a, _b;
    enabled = enabled || ((_b = (_a = item == null ? void 0 : item.attributes) == null ? void 0 : _a.url) == null ? void 0 : _b.includes(benefitId));
  });
  return enabled;
};
var useGetAssistance = (targetBenefits) => {
  const { data, isLoading, isError } = useQuery5(
    ["GET_CARE_PROVIDERS"],
    () => getCareProviders()
  );
  const memberServicesBenefit = (data == null ? void 0 : data.data) ? data.data.filter((item) => benefitIdEnabled(item, targetBenefits)) : [];
  return { data: memberServicesBenefit, isLoading, isError };
};

// src/components/home/get-assistance-section/get-assistance-section.component.tsx
var GetAssistanceSection = ({
  targetBenefits
}) => {
  const { data, isLoading, isError } = useGetAssistance(targetBenefits);
  if (isLoading) {
    return /* @__PURE__ */ React18.createElement(
      SkeletonBox,
      {
        height: "250px",
        backgroundColor: "surface.background.secondary"
      }
    );
  }
  if (isError || data.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React18.createElement(GetAssistanceNow, { careProviders: data });
};

// src/components/home/home-card/home-card.component.tsx
import React19 from "react";
import {
  BodyOne as BodyOne2,
  Box as Box8,
  HeadingThree,
  HeadingTwo as HeadingTwo2,
  PrimaryButton as PrimaryButton2,
  useTheme as useTheme2
} from "@leagueplatform/genesis-commons";
import { CardBanner, StackLayout as StackLayout4 } from "@leagueplatform/web-common-components";
var getCardBannerStyles = ({ breakpoints }) => ({
  imageContainer: {
    alignSelf: "center",
    minHeight: "128px",
    width: "128px",
    flexShrink: "0",
    margin: "two",
    marginBottom: "none",
    "&&": {
      [`@media screen and (min-width: ${breakpoints.phone})`]: {
        marginBottom: "two",
        height: "128px",
        maxWidth: "128px",
        borderLeftStyle: "none"
      }
    }
  }
});
var HomeCardComponent = ({
  heading,
  subheading,
  body,
  image = "",
  ctaText,
  onButtonClick
}) => {
  const theme = useTheme2();
  return /* @__PURE__ */ React19.createElement(Box8, null, /* @__PURE__ */ React19.createElement(HeadingTwo2, { marginBottom: "oneAndHalf" }, heading), /* @__PURE__ */ React19.createElement(CardBanner, { image: image || "", styles: getCardBannerStyles(theme) }, /* @__PURE__ */ React19.createElement(StackLayout4, { space: "$half" }, /* @__PURE__ */ React19.createElement(HeadingThree, null, subheading), /* @__PURE__ */ React19.createElement(BodyOne2, { color: "onSurface.text.subdued" }, body)), /* @__PURE__ */ React19.createElement(
    PrimaryButton2,
    {
      marginTop: "one",
      onClick: onButtonClick || void 0,
      alignSelf: "flex-start"
    },
    ctaText
  )));
};

// src/components/hsa-pending-banner/hsa-pending-banner.component.tsx
import React20 from "react";
import { ParagraphText as ParagraphText3, StatusBanner } from "@leagueplatform/genesis-core";
import { useIntl as useIntl9 } from "@leagueplatform/locales";

// src/hooks/use-get-hsa-registration-eligibility.hook.ts
import { useQuery as useQuery6 } from "react-query";

// src/api/get-hsa-eligibility.ts
var HSA_ELIGIBILITY_URL = "/v1/members/spending/hsa/eligible";
var HSA_ELIGIBILITY_STATUS = /* @__PURE__ */ ((HSA_ELIGIBILITY_STATUS2) => {
  HSA_ELIGIBILITY_STATUS2["ELIGIBLE"] = "Eligible";
  HSA_ELIGIBILITY_STATUS2["PENDING"] = "Pending";
  return HSA_ELIGIBILITY_STATUS2;
})(HSA_ELIGIBILITY_STATUS || {});
var getHsaEligibility = (partnerAccessToken) => __async(void 0, null, function* () {
  const response = yield highmarkFetch(HSA_ELIGIBILITY_URL, partnerAccessToken);
  return response.json();
});

// src/hooks/use-get-hsa-registration-eligibility.hook.ts
var QUERY_CACHE_AND_STALE_TIME4 = 5 * 1e3 * 60;
var useGetHsaRegistrationEligibility = () => {
  var _a;
  const { data: identityTokenData } = useGetIdentityPartnerToken(DEFAULT_PARTNER_ID);
  const { data, isLoading, isIdle } = useQuery6(
    ["GET_HSA_ELIGIBILITY" /* HSA_ELIGIBILITY_KEY */],
    () => getHsaEligibility(identityTokenData),
    {
      enabled: !!identityTokenData,
      staleTime: QUERY_CACHE_AND_STALE_TIME4,
      cacheTime: QUERY_CACHE_AND_STALE_TIME4
    }
  );
  const targetClient = ((_a = data == null ? void 0 : data.clients) == null ? void 0 : _a.length) === 1 ? data.clients[0] : null;
  const hsaRegistrationEligibility = targetClient ? {
    isHsaRegistrationEligible: targetClient.status === "Eligible" /* ELIGIBLE */ && !targetClient.isRegistered,
    status: targetClient.status,
    memberId: data == null ? void 0 : data.memberId,
    groupNumber: targetClient.groupNumber,
    clientNumber: targetClient.clientNumber
  } : { isHsaRegistrationEligible: false };
  return { data: hsaRegistrationEligibility, isLoading, isIdle };
};

// src/components/hsa-pending-banner/hsa-pending-banner.component.tsx
var HsaPendingBanner = () => {
  const { formatMessage } = useIntl9();
  const { data, isLoading } = useGetHsaRegistrationEligibility();
  const isHsaPending = !isLoading && data.status === "Pending";
  if (!isHsaPending) {
    return null;
  }
  return /* @__PURE__ */ React20.createElement(
    StatusBanner,
    {
      status: "info",
      title: formatMessage({ id: "HSA_PENDING_BANNER_TITLE" }),
      icon: "statusInformationCircleFill"
    },
    /* @__PURE__ */ React20.createElement(ParagraphText3, null, formatMessage({ id: "HSA_PENDING_BANNER_BODY" }))
  );
};

// src/components/hsa-pending-banner/hsa-pending-banner-widget.component.tsx
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import React22, { useEffect as useEffect6, useState as useState6 } from "react";

// src/components/widget/banner-widget.component.tsx
import { StackLayout as StackLayout5, UtilityText } from "@leagueplatform/genesis-core";
import { Image as Image4 } from "@leagueplatform/genesis-commons";
import React21 from "react";
var BannerWidget = ({
  heading,
  image,
  body,
  imageAltText
}) => /* @__PURE__ */ React21.createElement(
  StackLayout5,
  {
    orientation: "horizontal",
    verticalAlignment: "center",
    css: {
      boxShadow: "$card",
      borderStyle: "solid",
      padding: "$one"
    }
  },
  /* @__PURE__ */ React21.createElement(
    Image4,
    {
      src: image,
      width: "36px",
      height: "36px",
      marginRight: "one",
      alt: imageAltText
    }
  ),
  /* @__PURE__ */ React21.createElement(StackLayout5, { orientation: "vertical" }, /* @__PURE__ */ React21.createElement(
    UtilityText,
    {
      size: "sm",
      emphasis: "emphasized",
      css: { marginBottom: "$quarter" }
    },
    heading
  ), /* @__PURE__ */ React21.createElement(UtilityText, { size: "sm", emphasis: "subtle" }, body))
);

// src/components/hsa-pending-banner/hsa-pending-banner-widget.component.tsx
import piggyBank from "./assets/icons/saving-piggy-heart.svg";
var HsaPendingBannerWidget = () => {
  const { formatMessage } = useIntl10();
  const [showBanner, setShowBanner] = useState6(false);
  const { data, isLoading: isHsaRegisteredLoading } = useGetHsaRegistrationEligibility();
  useEffect6(() => {
    setShowBanner(!isHsaRegisteredLoading && (data == null ? void 0 : data.status) === "Pending");
  }, [isHsaRegisteredLoading, data == null ? void 0 : data.status]);
  return showBanner ? /* @__PURE__ */ React22.createElement(
    BannerWidget,
    {
      heading: formatMessage({ id: "HSA_PENDING_BANNER_TITLE" }),
      body: formatMessage({ id: "HSA_PENDING_BANNER_BODY" }),
      image: piggyBank,
      imageAltText: "piggybank"
    }
  ) : null;
};

// src/components/status-banner-masonry-widget/status-banner-masonry-widget.component.tsx
import React23 from "react";
import {
  useGetWidgetData
} from "@leagueplatform/masonry-api";
import { SkeletonBox as SkeletonBox2 } from "@leagueplatform/web-common-components";
import {
  ParagraphText as ParagraphText4,
  StatusBanner as StatusBanner2
} from "@leagueplatform/genesis-core";
var StatusBannerMasonryWidget = ({
  widget
}) => {
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData(widget, MASONRY.API_VERSION);
  if (isLoading) {
    return /* @__PURE__ */ React23.createElement(SkeletonBox2, { height: "60px" });
  }
  if (!widgetData || error) {
    return null;
  }
  return /* @__PURE__ */ React23.createElement(
    StatusBanner2,
    {
      title: widgetData.attributes.heading,
      status: widgetData.attributes.current_label
    },
    /* @__PURE__ */ React23.createElement(ParagraphText4, { size: "sm" }, widgetData.attributes.description)
  );
};

// src/components/home/hsa-section/hsa-section.component.tsx
import React24 from "react";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import {
  EVENT_NAME as EVENT_NAME4,
  SCREEN_NAMES,
  trackAnalyticsEvent as trackAnalyticsEvent4
} from "@leagueplatform/analytics";
import { useHistory as useHistory3 } from "@leagueplatform/routing";
import { SkeletonBox as SkeletonBox3 } from "@leagueplatform/web-common-components";
var HsaSection = ({ image }) => {
  const { formatMessage } = useIntl11();
  const history2 = useHistory3();
  const { data, isLoading } = useGetHsaRegistrationEligibility();
  const handleHsaHomeCardAction = () => {
    trackAnalyticsEvent4(EVENT_NAME4.BUTTON_CLICKED, {
      product_area: SCREEN_NAMES.HOME_SCREEN,
      screen_name: SCREEN_NAMES.HOME_SCREEN,
      detail: "HSA Home Page Card"
    });
    history2.push("/hsa");
  };
  return /* @__PURE__ */ React24.createElement(React24.Fragment, null, isLoading && /* @__PURE__ */ React24.createElement(
    SkeletonBox3,
    {
      height: "250px",
      backgroundColor: "surface.background.secondary"
    }
  ), !isLoading && (data == null ? void 0 : data.isHsaRegistrationEligible) && /* @__PURE__ */ React24.createElement(
    HomeCardComponent,
    {
      heading: formatMessage({ id: "HSA_HEADER" }),
      subheading: formatMessage({ id: "HSA_SUBHEADER" }),
      body: formatMessage({ id: "HSA_BODY" }),
      ctaText: formatMessage({ id: "HSA_CTA" }),
      onButtonClick: handleHsaHomeCardAction,
      image
    }
  ));
};

// src/components/mfa-enrollment/mfa-enrollment.component.tsx
import React26, { useState as useState8 } from "react";
import { useHistory as useHistory5 } from "@leagueplatform/routing";
import {
  BodyOne as BodyOne3,
  Flex as Flex5,
  HeadingTwo as HeadingTwo3,
  Image as Image5,
  PrimaryButton as PrimaryButton3,
  QuietButton as QuietButton4
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import { StackLayout as StackLayout6 } from "@leagueplatform/web-common-components";
import { handleStaticAsset } from "@leagueplatform/asset-config";

// src/components/mfa-enrollment/mfa-enrollment-modal.component.tsx
import React25, { useRef as useRef2 } from "react";
import { useIntl as useIntl12 } from "@leagueplatform/locales";

// src/hooks/use-mfa-modal.hook.tsx
import { useEffect as useEffect7, useState as useState7 } from "react";
import { useHistory as useHistory4 } from "@leagueplatform/routing";
var useMfaEnrollmentModal = (iframeRef, onEnrollSuccess) => {
  const mfaUrl = getAuthedWebviewUrl("MFA_ENROLLMENT" /* MFA_ENROLLMENT */);
  const { origin } = new URL(mfaUrl);
  const [isLoading, setLoading] = useState7(true);
  const [error, setError] = useState7(null);
  const history2 = useHistory4();
  const onError = (caughtError) => {
    setError(caughtError);
    captureAuthedWebviewError(caughtError, mfaUrl);
  };
  useEffect7(() => {
    if (iframeRef == null ? void 0 : iframeRef.current) {
      const messageHandler = (event) => __async(void 0, null, function* () {
        var _a, _b, _c;
        logger.log("Received message", event);
        try {
          const isAuthenticated = yield sendAuthTokenIfReady(
            event,
            origin,
            (_a = iframeRef == null ? void 0 : iframeRef.current) == null ? void 0 : _a.contentWindow
          );
          if (isAuthenticated) {
            setLoading(false);
          }
        } catch (err) {
          if (err instanceof Error) {
            onError(err instanceof Error ? err : new Error(err));
          }
          setLoading(false);
        }
        const status = (_b = event == null ? void 0 : event.data) == null ? void 0 : _b.status;
        if ((event == null ? void 0 : event.origin) !== origin || !status) {
          return;
        }
        switch (status) {
          case "complete":
            onEnrollSuccess();
            break;
          case "cancelled":
            history2.push("/sign-out");
            break;
          case "error":
            captureAuthedWebviewError(
              new Error(
                ((_c = event.data) == null ? void 0 : _c.description) || "An error message has been received"
              ),
              mfaUrl
            );
            break;
          default:
            captureAuthedWebviewError(
              new Error(
                `Unknown status received: ${status}: ${JSON.stringify(
                  event.data
                )}`
              ),
              mfaUrl
            );
        }
      });
      window.addEventListener("message", messageHandler);
      const loadingTimeout = setTimeout(() => {
        setLoading((loading) => {
          if (loading) {
            onError(
              new Error(
                "Could not send auth token, ready message not received from iframe."
              )
            );
          }
          return false;
        });
      }, SSO_READY_LISTENER_TIMEOUT);
      return () => {
        clearTimeout(loadingTimeout);
        window.removeEventListener("message", messageHandler);
      };
    }
    setLoading(true);
    return () => {
    };
  }, [iframeRef, onEnrollSuccess]);
  return {
    url: mfaUrl,
    isLoading,
    error
  };
};

// src/components/mfa-enrollment/mfa-enrollment-modal.component.tsx
var MfaEnrollmentModal = ({
  closeModal,
  onEnrollSuccess
}) => {
  const iframeRef = useRef2(null);
  const { url, error, isLoading } = useMfaEnrollmentModal(
    iframeRef,
    onEnrollSuccess
  );
  const { formatMessage } = useIntl12();
  const modalTitle = formatMessage({ id: "MFA_MODAL_TITLE" });
  return /* @__PURE__ */ React25.createElement(IframeModal, { title: modalTitle, onClose: closeModal }, error ? /* @__PURE__ */ React25.createElement(
    ErrorState,
    {
      errorType: "api_error" /* API_ERROR */,
      hideButton: true,
      styleProps: { height: "100%" }
    }
  ) : /* @__PURE__ */ React25.createElement(React25.Fragment, null, isLoading && /* @__PURE__ */ React25.createElement(LoadingSpinner, null), /* @__PURE__ */ React25.createElement(
    "iframe",
    {
      id: "mfaIframeModal",
      ref: iframeRef,
      height: "100%",
      width: "100%",
      title: modalTitle,
      src: url
    }
  )));
};

// src/components/mfa-enrollment/mfa-enrollment.component.tsx
var MfaEnrollment = ({
  onEnrollSuccess
}) => {
  const history2 = useHistory5();
  const [isOpen, setOpen] = useState8(false);
  const { formatMessage } = useIntl13();
  const privacyImage2 = handleStaticAsset(
    "HIGHMARK_PRIVACY_IMAGE" /* HIGHMARK_PRIVACY_IMAGE */
  );
  return /* @__PURE__ */ React26.createElement(FullScreenContainer, { backgroundColor: "surface.background.primary" }, /* @__PURE__ */ React26.createElement(
    StackLayout6,
    {
      space: "$two",
      css: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        margin: "auto",
        maxWidth: "327px"
      }
    },
    /* @__PURE__ */ React26.createElement(
      Image5,
      {
        display: "block",
        marginX: "auto",
        marginTop: "four",
        width: "160px",
        height: "160px",
        src: privacyImage2,
        alt: "privacy"
      }
    ),
    /* @__PURE__ */ React26.createElement(StackLayout6, { css: { textAlign: "center" } }, /* @__PURE__ */ React26.createElement(HeadingTwo3, null, formatMessage({ id: "MFA_TITLE" })), /* @__PURE__ */ React26.createElement(BodyOne3, null, formatMessage({ id: "MFA_DESCRIPTION" }))),
    /* @__PURE__ */ React26.createElement(Flex5, { justifyContent: "space-between" }, /* @__PURE__ */ React26.createElement(QuietButton4, { onClick: () => history2.push("/sign-out") }, formatMessage({ id: "SIGN_OUT" })), /* @__PURE__ */ React26.createElement(PrimaryButton3, { onClick: () => setOpen(true) }, formatMessage({ id: "SET_UP_NOW" })))
  ), isOpen && /* @__PURE__ */ React26.createElement(
    MfaEnrollmentModal,
    {
      closeModal: () => setOpen(false),
      onEnrollSuccess
    }
  ));
};

// src/components/header-nav/nav-link-wrapper.component.tsx
import React27 from "react";
import {
  AppBarLink,
  AppBarNavLink
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME5, trackAnalyticsEvent as trackAnalyticsEvent5 } from "@leagueplatform/analytics";
import { Link as Link2, useRouteMatch } from "@leagueplatform/routing";
import { Text } from "@leagueplatform/genesis-commons";
import {
  Box as Box9,
  Icon as Icon2,
  queryHelpers,
  useMediaQuery
} from "@leagueplatform/genesis-core";
var sendNavBarAnalyticsEvent = (action) => () => trackAnalyticsEvent5(EVENT_NAME5.NAVIGATION_TAB_CLICKED, {
  screen_name: "Navigation Bar",
  detail: action
});
var NavLinkWrapper = ({ navLink }) => {
  const { formatMessage } = useIntl14();
  const isMobile = useMediaQuery(queryHelpers.down("mobileLandscape"));
  const match = useRouteMatch({
    path: navLink.to,
    exact: false
  });
  const isActive = match !== null;
  const image = isActive ? navLink.iconSelected : navLink.icon;
  switch (navLink.type) {
    case "link" /* LINK */:
      return /* @__PURE__ */ React27.createElement(
        AppBarLink,
        {
          as: Link2,
          to: navLink.to,
          key: navLink.message_id,
          onClick: sendNavBarAnalyticsEvent(navLink.message_id),
          color: "onSurface.text.primary",
          hoverStyle: { color: "interactive.action.primary" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        formatMessage({ id: navLink.message_id })
      );
    case "navLink" /* NAV */:
      return /* @__PURE__ */ React27.createElement(
        AppBarNavLink,
        {
          to: navLink.to,
          key: navLink.message_id,
          onClick: sendNavBarAnalyticsEvent(navLink.message_id),
          color: "onSurface.text.primary",
          hoverStyle: { color: "interactive.action.primary" },
          decorativeBarColor: "interactive.action.primary",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          isMobile,
          listItemProps: {
            justifyContent: "center"
          }
        },
        isMobile ? /* @__PURE__ */ React27.createElement(
          Box9,
          {
            css: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              flex: 1,
              minWidth: "$four"
            }
          },
          /* @__PURE__ */ React27.createElement(Icon2, { icon: image, size: "$oneAndHalf" }),
          /* @__PURE__ */ React27.createElement(
            Text,
            {
              fontSize: "overline",
              fontWeight: "regular",
              paddingTop: "quarter"
            },
            formatMessage({ id: navLink.message_id })
          )
        ) : /* @__PURE__ */ React27.createElement(Box9, { css: { justifyContent: "center" } }, formatMessage({ id: navLink.message_id }))
      );
    default:
      throw new Error("invalid link type");
  }
};

// src/components/header-nav/responsive-user-dropdown.component.tsx
import React28 from "react";
import {
  UserDropdownComponent
} from "@leagueplatform/web-common-components";
import {
  EVENT_NAME as EVENT_NAME6,
  PRODUCT_AREA as PRODUCT_AREA2,
  SCREEN_NAMES as SCREEN_NAMES2
} from "@leagueplatform/analytics";
var ResponsiveUserDropdown = React28.memo(
  ({ userDropdownConfig }) => {
    const { data } = useUserDropdown(userDropdownConfig);
    const userDropdownAnalytics = {
      name: EVENT_NAME6.NAVIGATION_BAR_CLICKED,
      props: {
        product_area: PRODUCT_AREA2.HOME_SCREEN,
        screen_name: SCREEN_NAMES2.HOME_SCREEN,
        detail: "drop down menu"
      }
    };
    return /* @__PURE__ */ React28.createElement(
      UserDropdownComponent,
      {
        label: data.preferredFirstName.toUpperCase(),
        dropdownItemsConfig: data.menuItemsConfig,
        userBarAnalyticsProps: userDropdownAnalytics,
        enableMobileRedesign: true
      }
    );
  }
);

// src/components/auth-session-container/auth-session-container.tsx
import * as React29 from "react";
import { useEffect as useEffect8 } from "react";
import { useAuth } from "@leagueplatform/auth-utils";

// src/utils/clear-session-redirect.ts
var clearHighmarkSessionRedirect = (redirectPath = "") => window.location.assign(
  `${highmarkCommon.getConfig().highmarkSsoAppUrl}/logout?end_url=${window.location.origin}${redirectPath}`
);

// src/components/auth-session-container/auth-session-container.tsx
var AuthSessionContainer = ({
  children
}) => {
  const { isAuthenticated, error: authError } = useAuth({
    redirectToLogInWhenSignedOut: true
  });
  useEffect8(() => {
    if (authError) {
      captureAuthenticationError(authError);
      clearHighmarkSessionRedirect();
    }
  }, [authError]);
  if (!isAuthenticated)
    return /* @__PURE__ */ React29.createElement(LoadingSpinner, null);
  return children;
};

// src/components/home/app-walkthrough/walkthrough-layout.component.tsx
import {
  Box as Box12,
  Image as Image8,
  PrimaryButton as PrimaryButton5,
  SubtleButton
} from "@leagueplatform/genesis-commons";
import React34, { useEffect as useEffect9, useState as useState10 } from "react";
import modalX from "./assets/close.svg";
import rightArrow from "./assets/walkthrough-slides/walkthrough-right-arrow.png";
import leftArrow from "./assets/walkthrough-slides/walkthrough-left-arrow.png";
import { useIntl as useIntl18 } from "@leagueplatform/locales";

// src/components/home/app-walkthrough/walkthrough-slide-content.tsx
import React30 from "react";
import {
  BodyOne as BodyOne4,
  Caption,
  Flex as Flex6,
  HeadingOne,
  HeadingTwo as HeadingTwo4,
  Image as Image6
} from "@leagueplatform/genesis-commons";
import lineBreak from "./assets/walkthrough-slides/line-break.png";
import { useIntl as useIntl15 } from "@leagueplatform/locales";
var WalkthroughSlideContent = ({
  slideValue,
  slideData,
  logo
}) => {
  const { formatMessage } = useIntl15();
  return /* @__PURE__ */ React30.createElement(Flex6, { flexDirection: "column", alignItems: "center", width: "330px" }, /* @__PURE__ */ React30.createElement(
    Image6,
    {
      src: slideData.slideImages[slideValue],
      alt: "",
      width: "176px",
      height: "auto",
      marginBottom: "two"
    }
  ), slideValue === 0 && /* @__PURE__ */ React30.createElement(
    Image6,
    {
      src: lineBreak,
      alt: "",
      width: "56px",
      height: "auto",
      marginBottom: "twoAndHalf"
    }
  ), slideValue === 0 ? /* @__PURE__ */ React30.createElement(HeadingOne, { marginBottom: "three" }, slideData.slideHeadingContents[slideValue]) : /* @__PURE__ */ React30.createElement(HeadingTwo4, { marginBottom: "half" }, slideData.slideHeadingContents[slideValue]), slideData.slideBodyContents[slideValue] && /* @__PURE__ */ React30.createElement(BodyOne4, { textAlign: "center" }, slideData.slideBodyContents[slideValue]), slideValue === 0 && /* @__PURE__ */ React30.createElement(React30.Fragment, null, /* @__PURE__ */ React30.createElement(
    Caption,
    {
      color: "onSurface.text.subdued",
      marginTop: "twoAndHalf",
      marginBottom: "half"
    },
    formatMessage({ id: "PROVIDED_BY_WITH_COLON" })
  ), logo && /* @__PURE__ */ React30.createElement(
    Image6,
    {
      src: logo,
      alt: "Beneficity Logo",
      width: "100px",
      height: "auto"
    }
  )));
};

// src/components/home/app-walkthrough/user-setup-form.component.tsx
import React33, { useState as useState9 } from "react";
import {
  Box as Box11,
  Caption as Caption2,
  Flex as Flex7,
  genesisStyled as genesisStyled5,
  HeadingTwo as HeadingTwo5,
  Image as Image7,
  PrimaryButton as PrimaryButton4
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
import { Form, Formik } from "formik";

// src/hooks/use-accept-user-terms.ts
import { useMutation } from "react-query";

// src/api/accept-user-terms.ts
var ACCEPT_MEMBER_TERMS_TYPE = "accept_member_terms";
var MOCK_TERMS_VERSION = "2.0";
var acceptUserTerms = () => socketAsFetch({
  message_type: ACCEPT_MEMBER_TERMS_TYPE,
  info: {
    version: MOCK_TERMS_VERSION
  }
});

// src/hooks/use-accept-user-terms.ts
var useAcceptUserTerms = () => {
  const acceptTerms = useMutation(() => acceptUserTerms());
  const ERROR_TEXT = "error accepting terms";
  return () => __async(void 0, null, function* () {
    try {
      const response = yield acceptTerms.mutateAsync();
      return { success: Boolean(response.date_accepted) };
    } catch (error) {
      throw new Error(ERROR_TEXT);
    }
  });
};

// src/hooks/use-set-user-profile.ts
import { useMutation as useMutation2 } from "react-query";
import { setUserProfile } from "@leagueplatform/user-profile-api";
var useSetUserProfile = (data) => {
  const updateProfile = useMutation2(
    (profileData) => setUserProfile(profileData)
  );
  return () => __async(void 0, null, function* () {
    try {
      return yield updateProfile.mutateAsync(data);
    } catch (error) {
      throw new Error("error updating user profile");
    }
  });
};

// src/components/home/app-walkthrough/user-setup-form.component.tsx
import { TOAST_STATUS as TOAST_STATUS2, toastActions as toastActions2 } from "@leagueplatform/toast-messages";

// src/components/home/app-walkthrough/terms-links-content.component.tsx
import { genesisStyled as genesisStyled4, Link as Link3 } from "@leagueplatform/genesis-commons";
import React31 from "react";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
import { getInitializationConfig } from "@leagueplatform/core";
var TermsLinksContent = () => {
  const { formatMessage } = useIntl16();
  const handleExternalLink = getInitializationConfig().customMethods.handleLink;
  const handleClick = (event, url) => {
    event.preventDefault();
    handleExternalLink(url);
  };
  const AnchorLink = genesisStyled4(Link3)`
    background-color: inherit;
    border: none;
    font-weight: bold;
    text-decoration: underline;
`;
  const privacyUrl = getAuthedWebviewUrl(
    "PRIVACY_POLICY" /* PRIVACY_POLICY */
  );
  const termsUrl = getAuthedWebviewUrl("TERMS" /* TERMS */);
  return /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement("span", null, formatMessage({ id: "TERMS_AGREEMENT" })), /* @__PURE__ */ React31.createElement(
    AnchorLink,
    {
      href: privacyUrl,
      onClick: (event) => handleClick(event, privacyUrl)
    },
    formatMessage({ id: "PRIVACY_POLICY" })
  ), /* @__PURE__ */ React31.createElement("span", null, "\xA0", formatMessage({ id: "AND" }), "\xA0"), /* @__PURE__ */ React31.createElement(
    AnchorLink,
    {
      href: termsUrl,
      onClick: (event) => handleClick(event, termsUrl)
    },
    formatMessage({ id: "TERMS_SERVICE" })
  ), /* @__PURE__ */ React31.createElement("span", null, "."));
};

// src/components/form/formik-checkbox.component.tsx
import {
  Box as Box10,
  Checkbox,
  ChoiceText,
  Label
} from "@leagueplatform/genesis-commons";
import { Field } from "formik";
import React32 from "react";
var FormikCheckBox = ({
  fieldId,
  fieldName,
  fieldBody,
  formErrors,
  spaceProps
}) => /* @__PURE__ */ React32.createElement(
  Label,
  __spreadValues({
    htmlFor: fieldId,
    display: "flex",
    alignItems: "flex-start"
  }, spaceProps),
  /* @__PURE__ */ React32.createElement(Box10, null, /* @__PURE__ */ React32.createElement(
    Field,
    {
      id: fieldId,
      name: fieldName,
      as: Checkbox,
      type: "checkbox",
      marginRight: "half",
      error: formErrors[fieldName]
    }
  )),
  /* @__PURE__ */ React32.createElement(ChoiceText, null, fieldBody)
);

// src/components/home/app-walkthrough/user-setup-form.component.tsx
var NoWrapCaption = genesisStyled5(Caption2)`
    white-space: nowrap;
  `;
var handleKeyPress = (e, formProps) => {
  if (e.key === "Enter" && e.target.type === "checkbox") {
    e.preventDefault();
    const targetName = e.target.name;
    formProps.setFieldValue([targetName], !formProps.values[targetName]);
  }
};
var validateForm = (values, formatMessage) => {
  const errors = {};
  if (!values.areTermsAccepted) {
    errors.areTermsAccepted = formatMessage({ id: "ERROR_CAPTION_TERMS" });
  }
  return errors;
};
var UserSetupFormComponent = ({
  formImage,
  handleExit
}) => {
  const { formatMessage } = useIntl17();
  const acceptUserTerms2 = useAcceptUserTerms();
  const optInEmails = {
    opted_into_marketing_communications: true
  };
  const setOptInEmails = useSetUserProfile(optInEmails);
  const [loading, setLoading] = useState9(false);
  const handleSubmit = (formValues) => __async(void 0, null, function* () {
    setLoading(true);
    if (formValues.isEmailOptedIn) {
      try {
        yield setOptInEmails();
      } catch (e) {
        toastActions2.add({
          type: TOAST_STATUS2.ERROR,
          textId: "ERROR_CAPTION_PROFILE"
        });
      }
    }
    try {
      const termsApiCall = yield acceptUserTerms2();
      if (termsApiCall.success) {
        setLoading(false);
        handleExit();
      } else {
        setLoading(false);
        toastActions2.add({
          type: TOAST_STATUS2.ERROR,
          textId: "ERROR_CAPTION_SAVE"
        });
      }
    } catch (e) {
      setLoading(false);
      toastActions2.add({
        type: TOAST_STATUS2.ERROR,
        textId: "ERROR_CAPTION_SAVE"
      });
    }
  });
  return loading ? /* @__PURE__ */ React33.createElement(Flex7, { className: "spinner-container", height: "100vh", justifyContent: "center" }, /* @__PURE__ */ React33.createElement(LoadingSpinner, null)) : /* @__PURE__ */ React33.createElement(Flex7, { flexDirection: "column", alignItems: "center", width: "360px" }, formImage && /* @__PURE__ */ React33.createElement(
    Image7,
    {
      src: formImage,
      alt: "",
      width: "176px",
      height: "auto",
      marginBottom: "two"
    }
  ), /* @__PURE__ */ React33.createElement(HeadingTwo5, { marginBottom: "half" }, formatMessage({ id: "ACCOUNT_SETUP_FORM_HEADING" })), /* @__PURE__ */ React33.createElement(
    Formik,
    {
      initialValues: { areTermsAccepted: false, isEmailOptedIn: false },
      onSubmit: (formProps) => handleSubmit(formProps),
      validate: (values) => validateForm(values, formatMessage),
      validateOnBlur: false,
      validateOnChange: true
    },
    (formProps) => /* @__PURE__ */ React33.createElement(
      Form,
      {
        onKeyPress: (e) => handleKeyPress(e, formProps)
      },
      /* @__PURE__ */ React33.createElement(
        FormikCheckBox,
        {
          fieldId: "terms",
          fieldName: "areTermsAccepted",
          fieldBody: /* @__PURE__ */ React33.createElement(TermsLinksContent, null),
          formErrors: formProps.errors,
          spaceProps: {
            marginTop: "one",
            marginBottom: formProps.errors.areTermsAccepted ? "half" : "twoAndHalf"
          }
        }
      ),
      formProps.errors.areTermsAccepted && /* @__PURE__ */ React33.createElement(
        NoWrapCaption,
        {
          color: "onSurface.text.critical",
          marginLeft: "34px",
          marginBottom: "one"
        },
        formatMessage({ id: "ERROR_CAPTION_TERMS" })
      ),
      /* @__PURE__ */ React33.createElement(
        FormikCheckBox,
        {
          fieldId: "email",
          fieldName: "isEmailOptedIn",
          fieldBody: formatMessage({ id: "EMAIL_OPT_IN" }),
          formErrors: formProps.errors
        }
      ),
      /* @__PURE__ */ React33.createElement(Box11, { position: "absolute", right: "twoAndHalf", bottom: "quarter" }, /* @__PURE__ */ React33.createElement(PrimaryButton4, { flex: "0 1 auto", type: "submit", disabled: loading }, formatMessage({ id: "DONE" })))
    )
  ));
};

// src/components/home/app-walkthrough/walkthrough-layout.component.tsx
var WalkthroughLayout = ({
  slideData,
  numberOfSlides,
  logo = "",
  formImage = "",
  hasBrandSlide = false,
  onCompleteWalkthrough
}) => {
  const { formatMessage } = useIntl18();
  const minSlide = hasBrandSlide ? 0 : 1;
  const maxSlide = hasBrandSlide ? numberOfSlides - 1 : numberOfSlides;
  const [slideValue, setSlideValue] = useState10(minSlide);
  const handleExit = () => {
    onCompleteWalkthrough();
  };
  const getNewSlideValue = (curr, adjustValue) => {
    const resultingSlide = curr + adjustValue;
    if (resultingSlide < minSlide) {
      return minSlide;
    }
    if (resultingSlide > maxSlide) {
      return maxSlide;
    }
    return resultingSlide;
  };
  const changeSlides = (slideAdjustValue = 0) => {
    setSlideValue(
      (prevSlideValue) => getNewSlideValue(prevSlideValue, slideAdjustValue)
    );
  };
  const handleExitEntry = () => {
    if (slideValue !== maxSlide) {
      setSlideValue(maxSlide);
    }
  };
  useEffect9(() => {
    const handleWindowKeyPress = (e) => {
      if (e.key === "Escape") {
        handleExitEntry();
      }
      if (slideValue !== maxSlide && e.key === "Enter") {
        e.preventDefault();
        changeSlides(1);
      }
    };
    window.addEventListener("keydown", handleWindowKeyPress);
    return () => {
      window.removeEventListener("keydown", handleWindowKeyPress);
    };
  }, [slideValue]);
  const handleArrowKeyDown = (e, slideAdjustValue) => {
    if (e.key === "Enter") {
      e.stopPropagation();
      e.preventDefault();
      changeSlides(slideAdjustValue);
    }
  };
  const handleExitKeyDown = (e) => {
    if (e.key === "Enter") {
      e.stopPropagation();
      handleExitEntry();
    }
  };
  return /* @__PURE__ */ React34.createElement(React34.Fragment, null, slideValue === 0 && /* @__PURE__ */ React34.createElement(
    Image8,
    {
      src: modalX,
      alt: "close this view",
      cursor: "pointer",
      role: "button",
      width: "20px",
      height: "20px",
      position: "fixed",
      top: "35px",
      right: "35px",
      tabIndex: "0",
      onClick: handleExitEntry,
      onKeyDown: (e) => handleExitKeyDown(e)
    }
  ), slideValue > 0 && slideValue < maxSlide && /* @__PURE__ */ React34.createElement(Box12, { position: "fixed", top: "35px", right: "35px" }, /* @__PURE__ */ React34.createElement(
    SubtleButton,
    {
      tabIndex: 0,
      onClick: handleExitEntry,
      onKeyDown: (e) => handleExitKeyDown(e)
    },
    formatMessage({ id: "SKIP_TUTORIAL" })
  )), /* @__PURE__ */ React34.createElement(
    Box12,
    {
      position: "fixed",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      minHeight: "430px",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },
    /* @__PURE__ */ React34.createElement(Box12, { flex: "1" }, slideValue !== maxSlide ? /* @__PURE__ */ React34.createElement(
      WalkthroughSlideContent,
      {
        slideValue,
        slideData,
        logo
      }
    ) : /* @__PURE__ */ React34.createElement(
      UserSetupFormComponent,
      {
        formImage,
        handleExit
      }
    )),
    /* @__PURE__ */ React34.createElement(
      Box12,
      {
        display: "flex",
        flexDirection: "row",
        justifyContent: !hasBrandSlide && slideValue === minSlide ? "flex-end" : "space-between",
        alignItems: "center",
        width: slideValue > 0 && slideValue < maxSlide - 1 ? { _: "128px", tablet: "196px" } : { _: "280px" },
        marginTop: slideValue === 0 ? "five" : "oneAndHalf"
      },
      slideValue > minSlide && /* @__PURE__ */ React34.createElement(
        Image8,
        {
          src: leftArrow,
          alt: formatMessage({ id: "RETURN_TO_PREVIOUS" }),
          cursor: "pointer",
          role: "button",
          width: "56px",
          height: "56px",
          tabIndex: "0",
          onClick: () => changeSlides(-1),
          onKeyDown: (e) => handleArrowKeyDown(e, -1)
        }
      ),
      slideValue === 0 && /* @__PURE__ */ React34.createElement(
        PrimaryButton5,
        {
          autoFocus: true,
          flex: "1",
          onClick: () => changeSlides(1),
          onKeyDown: (e) => handleArrowKeyDown(e, 1)
        },
        formatMessage({ id: "CONTINUE" })
      ),
      slideValue > 0 && slideValue < maxSlide - 1 && /* @__PURE__ */ React34.createElement(
        Image8,
        {
          src: rightArrow,
          alt: formatMessage({ id: "ADVANCE_TO_NEXT" }),
          cursor: "pointer",
          role: "button",
          width: "56px",
          height: "56px",
          tabIndex: "0",
          onClick: () => changeSlides(1),
          onKeyDown: (e) => handleArrowKeyDown(e, 1)
        }
      ),
      slideValue === maxSlide - 1 && /* @__PURE__ */ React34.createElement(
        PrimaryButton5,
        {
          autoFocus: true,
          flex: "0 1 auto",
          onClick: () => changeSlides(1),
          onKeyDown: (e) => handleArrowKeyDown(e, 1)
        },
        formatMessage({ id: "GET_STARTED" })
      )
    )
  ));
};

// src/components/header-nav/nav-bar.component.tsx
import React37 from "react";
import { queryHelpers as queryHelpers2, useMediaQuery as useMediaQuery2 } from "@leagueplatform/genesis-core";

// src/components/header-nav/desktop-navbar.component.tsx
import * as React35 from "react";
import {
  AppBarComponent,
  AppBarItem
} from "@leagueplatform/web-common-components";
import { Image as Image9 } from "@leagueplatform/genesis-commons";
var DesktopNavbar = ({ userDropdownConfig, navLinks, brandingInfo }) => /* @__PURE__ */ React35.createElement(AppBarComponent, { navHeight: APP_NAV_DEFAULT_HEIGHT }, (brandingInfo == null ? void 0 : brandingInfo.brandingLogo) && /* @__PURE__ */ React35.createElement(AppBarItem, { margin: "auto" }, /* @__PURE__ */ React35.createElement(
  Image9,
  {
    height: "oneAndHalf",
    role: "presentation",
    alt: "provider-logo",
    src: brandingInfo.brandingLogo
  }
)), /* @__PURE__ */ React35.createElement(AppBarItem, { flexGrow: { _: 1, laptop: 2 }, "aria-hidden": "true" }), navLinks.map((navLink) => /* @__PURE__ */ React35.createElement(NavLinkWrapper, { key: navLink.message_id, navLink })), /* @__PURE__ */ React35.createElement(AppBarItem, { flexGrow: 30, "aria-hidden": "true" }), /* @__PURE__ */ React35.createElement(AppBarItem, null, /* @__PURE__ */ React35.createElement(ResponsiveUserDropdown, { userDropdownConfig })), /* @__PURE__ */ React35.createElement(AppBarItem, { flexGrow: { _: 1, laptop: 2 }, "aria-hidden": "true" }));

// src/components/header-nav/mobile-navbar.component.tsx
import * as React36 from "react";
import {
  AppBarComponent as AppBarComponent2,
  AppBarItem as AppBarItem2
} from "@leagueplatform/web-common-components";
import { Image as Image10 } from "@leagueplatform/genesis-commons";
import { Box as Box13 } from "@leagueplatform/genesis-core";
var MobileNavbar = ({ userDropdownConfig, navLinks, brandingInfo }) => /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(
  Box13,
  {
    css: {
      display: "flex",
      padding: "$threeQuarters",
      justifyContent: "end"
    }
  },
  (brandingInfo == null ? void 0 : brandingInfo.brandingLogo) && /* @__PURE__ */ React36.createElement(AppBarItem2, { margin: "auto" }, /* @__PURE__ */ React36.createElement(
    Image10,
    {
      height: "oneAndHalf",
      role: "presentation",
      alt: "provider-logo",
      src: brandingInfo.brandingLogo
    }
  )),
  /* @__PURE__ */ React36.createElement(ResponsiveUserDropdown, { userDropdownConfig })
), /* @__PURE__ */ React36.createElement(AppBarComponent2, { navHeight: APP_NAV_DEFAULT_HEIGHT }, navLinks.map((navLink) => /* @__PURE__ */ React36.createElement(NavLinkWrapper, { key: navLink.message_id, navLink }))));

// src/components/header-nav/nav-bar.component.tsx
var Navbar = ({ userDropdownConfig, brandingInfo }) => {
  const isMobile = useMediaQuery2(queryHelpers2.down("mobileLandscape"));
  const { navLinks } = useNavLinksList();
  return isMobile ? /* @__PURE__ */ React37.createElement(
    MobileNavbar,
    {
      userDropdownConfig,
      brandingInfo,
      navLinks
    }
  ) : /* @__PURE__ */ React37.createElement(
    DesktopNavbar,
    {
      userDropdownConfig,
      brandingInfo,
      navLinks
    }
  );
};

// src/components/query-param-modal/query-param-modal.component.tsx
import { useUrlParam as useUrlParam3 } from "@leagueplatform/web-common";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import { Box as Box14, HeadingText as HeadingText2, ParagraphText as ParagraphText5 } from "@leagueplatform/genesis-core";
import React38 from "react";

// src/hooks/use-query-modal-content.hook.ts
var VALID_MODAL_PARAMS = ["amwellunder18" /* AMWELL_UNDER_18 */];
var useQueryModalContent = (type) => {
  switch (type) {
    case "amwellunder18" /* AMWELL_UNDER_18 */:
      return {
        label: "AMWELL_DISCLAIMER",
        heading: "AMWELL_DISCLAIMER_HEADING",
        body: "AMWELL_DISCLAIMER_BODY_1",
        bodyTwo: "AMWELL_DISCLAIMER_BODY_2"
      };
    default:
      return {};
  }
};

// src/components/query-param-modal/query-param-modal.component.tsx
var QueryParamModal = () => {
  const { formatMessage } = useIntl19();
  const { removeParam, urlParam } = useUrlParam3(QUERY_PARAM_KEYS.modal);
  const { label, heading, body, bodyTwo } = useQueryModalContent(
    urlParam
  );
  if (!VALID_MODAL_PARAMS.includes(urlParam) || !label || !heading || !body) {
    if (urlParam !== WEBVIEW_MODAL_QUERY_PARAM_VALUE) {
      removeParam();
    }
    return null;
  }
  return /* @__PURE__ */ React38.createElement(
    ModalWrapper,
    {
      onClose: removeParam,
      modalLabel: formatMessage({ id: label }),
      maxWidth: "890px"
    },
    /* @__PURE__ */ React38.createElement(Box14, { css: { padding: "0 $two $two" } }, /* @__PURE__ */ React38.createElement(HeadingText2, { size: "xl", level: "1", css: { paddingBottom: "$oneAndHalf" } }, formatMessage({ id: heading })), /* @__PURE__ */ React38.createElement(ParagraphText5, { emphasis: "subtle", css: { paddingBottom: "$oneAndHalf" } }, formatMessage({ id: body })), bodyTwo && /* @__PURE__ */ React38.createElement(ParagraphText5, { emphasis: "subtle" }, formatMessage({ id: bodyTwo })))
  );
};

// src/components/customer-support/cs-auth-container.component.tsx
import React39, { useEffect as useEffect10 } from "react";
import { useAuth as useAuth2 } from "@leagueplatform/auth-utils";
var CSAuthSessionContainer = ({
  children
}) => {
  const { isAuthenticated, error: authError } = useAuth2({
    redirectToLogInWhenSignedOut: false
  });
  useEffect10(() => {
    if (authError) {
      captureAuthenticationError(authError);
    }
  }, [authError]);
  if (isAuthenticated === void 0) {
    return /* @__PURE__ */ React39.createElement(LoadingSpinner, null);
  }
  if (authError) {
    return /* @__PURE__ */ React39.createElement(
      ErrorState,
      {
        errorType: "api_error" /* API_ERROR */,
        isFullPage: true,
        headingString: authError.type,
        bodyString: authError.description || "",
        hideButton: true
      }
    );
  }
  if (!isAuthenticated) {
    return /* @__PURE__ */ React39.createElement(
      ErrorState,
      {
        errorType: "api_error" /* API_ERROR */,
        headingString: "Not Authenticated.",
        bodyString: "You are currently not logged in with an active session.",
        isFullPage: true,
        hideButton: true
      }
    );
  }
  return /* @__PURE__ */ React39.createElement("div", null, children);
};

// src/components/customer-support/cs-auth-sign-in.component.tsx
import React40, { useEffect as useEffect11, useState as useState11 } from "react";
import { useHistory as useHistory6, useLocation as useLocation2 } from "@leagueplatform/routing";
import { StandaloneAuth as StandaloneAuth2 } from "@leagueplatform/auth-standalone";
var getAuth0ErrorIfExists = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const hashParams = new URLSearchParams(location.hash.replace(/#/g, "?"));
  const type = searchParams.get("error") || hashParams.get("error");
  const description = searchParams.get("error_description") || hashParams.get("error_description");
  if (type) {
    return { type, description };
  }
  return null;
};
var CSAuthSignIn = () => {
  const location = useLocation2();
  const history2 = useHistory6();
  const [error, setError] = useState11("");
  useEffect11(() => {
    const connection = new URLSearchParams(location.search).get("connection") || CS_AUTH0_CLIENT_CONNECTION;
    const authError = getAuth0ErrorIfExists(location);
    if (authError) {
      setError(`${authError.type}: ${authError.description || ""}`);
      captureAuthenticationError(authError);
      return;
    }
    try {
      const options = {
        connection
      };
      StandaloneAuth2.client.loginWithRedirect(options);
    } catch (e) {
      logger.error(e);
      setError(e instanceof Error ? e.message : String(e));
    }
  }, [location, history2]);
  if (error) {
    return /* @__PURE__ */ React40.createElement(
      ErrorState,
      {
        isFullPage: true,
        errorType: "api_error" /* API_ERROR */,
        bodyString: error,
        hideButton: true
      }
    );
  }
  return /* @__PURE__ */ React40.createElement(LoadingSpinner, null);
};

// src/components/customer-support/cs-auth-sign-out.component.tsx
import React41, { useEffect as useEffect12 } from "react";
import { StandaloneAuth as StandaloneAuth3 } from "@leagueplatform/auth-standalone";
var CSAuthSignOut = () => {
  useEffect12(() => {
    StandaloneAuth3.client.logout({
      returnTo: window.location.origin
    });
  }, []);
  return /* @__PURE__ */ React41.createElement(LoadingSpinner, null);
};

// src/pages/about/about.page.tsx
import * as React42 from "react";
import { Image as Image11 } from "@leagueplatform/genesis-commons";
import {
  Box as Box15,
  Card,
  HeadingText as HeadingText3,
  StackItem,
  StackLayout as StackLayout7
} from "@leagueplatform/genesis-core";
import {
  MainPageContainer,
  PageHeaderBackground as PageHeaderBackground2
} from "@leagueplatform/web-common-components";
var AboutBodySection = ({
  image,
  body
}) => /* @__PURE__ */ React42.createElement(
  Card.Flat,
  {
    css: {
      borderColor: "$onSurfaceBorderSubdued",
      borderWidth: "thin",
      borderStyle: "solid"
    }
  },
  /* @__PURE__ */ React42.createElement(
    StackLayout7,
    {
      orientation: { "@initial": "horizontal", "@mobile": "vertical" },
      horizontalAlignment: "center",
      verticalAlignment: "top",
      spacing: "$two",
      css: { padding: "$two" }
    },
    !!image && /* @__PURE__ */ React42.createElement(
      Image11,
      {
        flexShrink: 0,
        width: "110px",
        src: image.src,
        alt: image.alt || ""
      }
    ),
    /* @__PURE__ */ React42.createElement(StackItem, null, body)
  )
);
var AboutPage = ({
  isLoading,
  heading,
  body,
  image
}) => /* @__PURE__ */ React42.createElement(MainPageContainer, null, /* @__PURE__ */ React42.createElement(PageHeaderBackground2, { height: "100%", pageHeaderBackgroundHeight: "172px" }, /* @__PURE__ */ React42.createElement(Box15, { css: { textAlign: "left" } }, /* @__PURE__ */ React42.createElement(
  HeadingText3,
  {
    level: "1",
    size: { "@initial": "xxl", "@mobile": "xl" },
    css: {
      marginTop: "$one",
      marginBottom: "$oneAndHalf",
      height: "$four",
      "@mobile": {
        marginTop: "$oneAndHalf",
        marginBottom: "$one"
      }
    }
  },
  heading
), isLoading ? /* @__PURE__ */ React42.createElement(LoadingSpinner, null) : /* @__PURE__ */ React42.createElement(AboutBodySection, { image, body }))));

// src/pages/auth/auth-sign-in.page.tsx
import React43, { useEffect as useEffect13 } from "react";
import { StandaloneAuth as StandaloneAuth4 } from "@leagueplatform/auth-standalone";
var AuthSignIn = () => {
  useEffect13(() => {
    StandaloneAuth4.client.loginWithRedirect();
  }, []);
  return /* @__PURE__ */ React43.createElement(LoadingSpinner, null);
};

// src/pages/auth/auth-sign-out.page.tsx
import React44, { useEffect as useEffect14 } from "react";
import { StandaloneAuth as StandaloneAuth5 } from "@leagueplatform/auth-standalone";
var AuthSignOut = () => {
  useEffect14(() => {
    StandaloneAuth5.client.logout({
      federated: true,
      returnTo: window.location.origin
    });
  }, []);
  return /* @__PURE__ */ React44.createElement(LoadingSpinner, null);
};

// src/pages/technical-assistance-and-all-languages.page.tsx
import * as React45 from "react";
import { useIntl as useIntl20 } from "@leagueplatform/locales";

// src/common/assistance-language-options-config.ts
var LANGUAGE_ASSISTANCE_TITLE_DESCRIPTIONS_CONFIG = [
  {
    id: 1,
    title: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
    description: "\u062A\u0646\u0628\u064A\u0647: \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u062A\u062D\u062F\u062B \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629\u060C \u0641\u0647\u0646\u0627\u0643 \u062E\u062F\u0645\u0627\u062A \u0627\u0644\u0645\u0639\u0627\u0648\u0646\u0629 \u0641\u064A \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u0645\u062C\u0627\u0646\u064A\u0629 \u0645\u062A\u0627\u062D\u0629 \u0644\u0643. \u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u0648\u062C\u0648\u062F \u062E\u0644\u0641 \u0628\u0637\u0627\u0642\u0629 \u0647\u0648\u064A\u062A\u0643 (\u062C\u0647\u0627\u0632 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u0630\u0648\u064A \u0635\u0639\u0648\u0628\u0627\u062A \u0627\u0644\u0633\u0645\u0639 \u0648\u0627\u0644\u0646\u0637\u0642: 711).",
    isRtlLanguage: true,
    languageCode: "arb"
  },
  {
    id: 2,
    title: "\u4E2D\u6587",
    description: "\u8BF7\u6CE8\u610F\uFF1A\u5982\u679C\u60A8\u8BF4\u4E2D\u6587\uFF0C\u53EF\u5411\u60A8\u63D0\u4F9B\u514D\u8D39\u8BED\u8A00\u534F\u52A9\u670D\u52A1\u3002\u8BF7\u62E8\u6253\u60A8\u7684\u8EAB\u4EFD\u80CC\u9762\u7684\u53F7\u7801\uFF08TTY\uFF1A711\uFF09\u3002",
    isRtlLanguage: false,
    languageCode: "zh"
  },
  {
    id: 3,
    title: "FRAN\xC7AIS",
    description: "ATTENTION: Si vous parlez fran\xE7ais, les services d'assistance linguistique, gratuitement, sont \xE0 votre disposition. Appelez le num\xE9ro au dos de votre carte d'identit\xE9 (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "fr"
  },
  {
    id: 4,
    title: "CREOLE FRAN\xC7AIS",
    description: "ATTENTION: Si c\u2019est cr\xE9ole que vous connaissez, il y a un certain service de langues qui est gratis et disponible pour vous-m\xEAme. Composez le num\xE9ro qui est au dos de votre carte d\u2019identit\xE9. (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "fr"
  },
  {
    id: 5,
    title: "DEUTSCH",
    description: "ACHTUNG: Wenn Sie Deutsch sprechen, steht Ihnen unsere fremdsprachliche Unterst\xFCtzung kostenlos zur Verf\xFCgung. Rufen Sie dazu die auf der R\xFCckseite Ihres Versicherungsausweises (TTY: 711) aufgef\xFChrte Nummer an.",
    isRtlLanguage: false,
    languageCode: "de"
  },
  {
    id: 6,
    title: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0",
    description: "\u0AA7\u0ACD\u0AAF\u0ABE\u0AA8 \u0A86\u0AAA\u0AB6\u0ACB\u0A83 \u0A9C\u0ACB \u0AA4\u0AAE\u0AC7 \u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0 \u0AAD\u0ABE\u0AB7\u0ABE \u0AAC\u0ACB\u0AB2\u0AA4\u0ABE \u0AB9\u0ACB, \u0AA4\u0ACB \u0AAD\u0ABE\u0AB7\u0ABE \u0AB8\u0AB9\u0ABE\u0AAF\u0AA4\u0ABE \u0AB8\u0AC7\u0AB5\u0ABE\u0A93, \u0AAE\u0AAB\u0AA4\u0AAE\u0ABE\u0A82 \u0AA4\u0AAE\u0AA8\u0AC7 \u0A89\u0AAA\u0AB2\u0AAC\u0ACD\u0AA7 \u0A9B\u0AC7. \u0AA4\u0AAE\u0ABE\u0AB0\u0ABE \u0A93\u0AB3\u0A96\u0AAA\u0AA4\u0ACD\u0AB0\u0AA8\u0ABE \u0AAA\u0ABE\u0A9B\u0AB3\u0AA8\u0ABE \u0AAD\u0ABE\u0A97\u0AC7 \u0A86\u0AB5\u0AC7\u0AB2\u0ABE \u0AA8\u0A82\u0AAC\u0AB0 \u0AAA\u0AB0 \u0AAB\u0ACB\u0AA8 \u0A95\u0AB0\u0ACB (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "guj"
  },
  {
    id: 7,
    title: "HMONG",
    description: "LUS NCO TSEG: Yog koj hais lus Hmoob, muaj kev pab txhais lus pub dawb rau koj. Hu rau tus xovtooj nyob sab tom qab ntawm koj daim npav ID (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "hmn"
  },
  {
    id: 8,
    title: "ITALIANO",
    description: "ATTENZIONE: se parla italiano, per lei sono disponibili servizi di assistenza linguistica a titolo gratuito. Contatti il numero riportato sul retro della sua carta d'identit\xE0 (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "it"
  },
  {
    id: 9,
    title: "\u65E5\u672C\u8A9E",
    description: "\u6CE8\uFF1A \u65E5\u672C\u8A9E\u304C\u6BCD\u56FD\u8A9E\u306E\u65B9\u306F\u8A00\u8A9E\u30A2\u30B7\u30B9\u30BF\u30F3\u30B9\u30FB\u30B5\u30FC\u30D3\u30B9\u3092\u7121\u6599\u3067\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002ID \u30AB\u30FC\u30C9\u306E\u88CF\u306B\u660E\u8A18\u3055\u308C\u3066\u3044\u308B\u756A\u53F7\u306B\u96FB\u8A71\u3092\u304A\u304B\u3051\u304F\u3060\u3055\u3044 (TTY: 711)\u3002",
    isRtlLanguage: false,
    languageCode: "ja"
  },
  {
    id: 10,
    title: "\u1781\u17D2\u1798\u17C2\u179A",
    description: "\u1794\u17D2\u179A\u1780\u17B6\u179A\u1785\u1784\u1785\u17B6\u17C6\u17D6 \u1794\u17BE\u179B\u17C4\u1780\u17A2\u17D2\u1793\u1780\u1793\u17B7\u1799\u17B6\u1799 \u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A \u17A0\u17BE\u1799\u178F\u17D2\u179A\u17BC\u179C\u1780\u17B6\u179A\u179F\u17C1\u179C\u17B6\u1780\u1798\u17D2\u1798\u1787\u17C6\u1793\u17BD\u1799\u1795\u17D2\u1793\u17C2\u1780\u1797\u17B6\u179F\u17B6\u178A\u17C2\u179B\u17A2\u17B6\u1785\u1795\u17D2\u178A\u179B\u17CB\u1787\u17BC\u1793\u179B\u17C4\u1780\u17A2\u17D2\u1793\u1780\u178A\u17C4\u1799\u17A5\u178F\u1782\u17B7\u178F\u1790\u17D2\u179B\u17C3\u17D4 \u179F\u17BC\u1798\u1791\u17BC\u179A\u179F\u17D0\u1796\u17D2\u1791\u1791\u17C5\u179B\u17C1\u1781\u178A\u17C2\u179B\u1798\u17B6\u1793\u1793\u17C5\u179B\u17BE\u1781\u17D2\u1793\u1784\u1780\u17B6\u178F\u179F\u1798\u17D2\u1782\u17B6\u179B\u17CB\u179A\u1794\u179F\u17CB\u179A\u1794\u179F\u17CB\u179B\u17C4\u1780\u17A2\u17D2\u1793\u1780 (TTY: 711)\u17D4",
    isRtlLanguage: false,
    languageCode: "km"
  },
  {
    id: 11,
    title: "\uD55C\uAD6D\uC5B4",
    description: "\uC54C\uB9BC: \uD55C\uAD6D\uC5B4\uB97C \uC0AC\uC6A9\uD558\uC2DC\uB294 \uBD84\uB4E4\uC744 \uC704\uD574 \uBB34\uB8CC \uD1B5\uC5ED\uC774 \uC81C\uACF5\uB429\uB2C8\uB2E4. ID \uCE74\uB4DC \uB4B7\uBA74\uC5D0 \uC788\uB294 \uBC88\uD638\uB85C \uC804\uD654\uD558\uC2ED\uC2DC\uC624 (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "ko"
  },
  {
    id: 12,
    title: "\u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7",
    description: "\u0EC0\u0E8A\u0EB5\u0E99\u0E8A\u0EB2\u0E9A: \u0E96\u0EC9\u0EB2\u0EAB\u0EB2\u0E81\u0EA7\u0EC8\u0EB2\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0EA7\u0EBB\u0EC9\u0EB2 \u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7, \u0E81\u0EB2\u0E99\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0E81\u0EB2\u0E99\u0E8A\u0EC8\u0EA7\u0E8D\u0EC0\u0EAB\u0EBC\u0EB7\u0EAD\u0E94\u0EC9\u0EB2\u0E99\u0E9E\u0EB2\u0EAA\u0EB2, \u0EC2\u0E94\u0E8D\u0E9A\u0ECD\u0EC8\u0EC0\u0EAA\u0E8D\u0E84\u0EC8\u0EB2, \u0EC1\u0EA1\u0EC8\u0E99\u0EA1\u0EB5\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99. \u0EC2\u0E97\u0EAB\u0EB2\u0EC0\u0E9A\u0EB5\u0EA2\u0EB9\u0EC8\u0E94\u0EC9\u0EB2\u0E99\u0EAB\u0EBC\u0EB1\u0E87\u0E82\u0EAD\u0E87\u0E9A\u0EB1\u0E94\u0EAA\u0EB0\u0EA1\u0EB2\u0E8A\u0EB4\u0E81 (ID) \u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99.",
    isRtlLanguage: false,
    languageCode: "lo"
  },
  {
    id: 13,
    title: "\u0928\u0947\u092A\u093E\u0932\u0940",
    description: "\u0927\u094D\u092F\u093E\u0928 \u0926\u093F\u0928\u0941\u0939\u094B\u0938\u094D: \u092F\u0926\u093F \u0924\u092A\u093E\u0908\u0902 \u0928\u0947\u092A\u093E\u0932\u0940 \u092D\u093E\u0937\u093E \u092C\u094B\u0932\u094D\u0928\u0941\u0939\u0941\u0928\u094D\u091B \u092D\u0928\u0947, \u0924\u092A\u093E\u0908\u0902\u0915\u093E \u0932\u093E\u0917\u093F \u092D\u093E\u0937\u093E \u0938\u0939\u093E\u092F\u0924\u093E \u0938\u0947\u0935\u093E\u0939\u0930\u0942 \u0928\u093F:\u0936\u0941\u0932\u094D\u0915 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0941\u0928\u094D\u091B\u0928\u094D\u0964 \u0924\u092A\u093E\u0908\u0902\u0915\u094B \u0906\u0907\u0921\u0940 \u0915\u093E\u0930\u094D\u0921\u0915\u094B \u092A\u091B\u093E\u0921\u093F \u092D\u093E\u0917\u092E\u093E \u0930\u0939\u0947\u0915\u094B \u0928\u092E\u094D\u092C\u0930 (TTY: 711) \u092E\u093E \u092B\u094B\u0928 \u0917\u0930\u094D\u0928\u0941\u0939\u094B\u0938\u094D\u0964",
    isRtlLanguage: false,
    languageCode: "ne"
  },
  {
    id: 14,
    title: "PENNSILFAANISCH DEITSCH",
    description: "Geb Acht: Wann du Deitsch schwetzscht, kannscht du en Dolmetscher griege, un iss die Hilf Koschdefrei. Kannscht du die Nummer an deinre ID Kard dahinner uffrufe (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "de"
  },
  {
    id: 15,
    title: "\u0641\u0627\u0631\u0633\u06CC",
    description: " \u062A\u0648\u062C\u0647: \u0627\u06AF\u0631 \u0634\u0645\u0627 \u0628\u0647 \u0632\u0628\u0627\u0646 \u0641\u0627\u0631\u0633\u06CC \u0635\u062D\u0628\u062A \u0645\u06CC \u06A9\u0646\u06CC\u062F\u060C \u062E\u062F\u0645\u0627\u062A \u06A9\u0645\u06A9 \u0632\u0628\u0627\u0646\u060C \u0628\u0647 \u0635\u0648\u0631\u062A \u0631\u0627\u06CC\u06AF\u0627\u0646\u060C \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0634\u0645\u0627\u0633\u062A. \u0628\u0627 \u0634\u0645\u0627\u0631\u0647 \u0648\u0627\u0642\u0639 \u062F\u0631 \u067E\u0634\u062A \u06A9\u0627\u0631\u062A \u0634\u0646\u0627\u0633\u0627\u06CC\u06CC \u062E\u0648\u062F ( TTY: 711) \u062A\u0645\u0627\u0633 \u0628\u06AF\u06CC\u0631\u06CC\u062F.",
    isRtlLanguage: true,
    languageCode: "fa"
  },
  {
    id: 16,
    title: "POLSZCZYZNA",
    description: "UWAGA: Dla os\xF3b m\xF3wi\u0105cych po polsku dost\u0119pna jest bezp\u0142atna pomoc j\u0119zykowa. Zadzwo\u0144 pod numer podany na odwrocie karty ubezpieczenia zdrowotnego (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "pl"
  },
  {
    id: 17,
    title: "PORTUGU\xCAS",
    description: "ATEN\xC7\xC3O: Se a sua l\xEDngua \xE9 o portugu\xEAs, temos atendimento gratuito para voc\xEA no seu idioma. Ligue para o n\xFAmero no verso da sua identidade (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "pt"
  },
  {
    id: 18,
    title: "\u0420\u0423\u0421\u0421\u041A\u0418\u0419",
    description: "\u0412\u041D\u0418\u041C\u0410\u041D\u0418\u0415: \u0415\u0441\u043B\u0438 \u0432\u044B \u0433\u043E\u0432\u043E\u0440\u0438\u0442\u0435 \u043F\u043E-\u0440\u0443\u0441\u0441\u043A\u0438, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u043C\u0438 \u0443\u0441\u043B\u0443\u0433\u0430\u043C\u0438 \u044F\u0437\u044B\u043A\u043E\u0432\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438. \u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043F\u043E \u043D\u043E\u043C\u0435\u0440\u0443, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u043C\u0443 \u043D\u0430 \u043E\u0431\u043E\u0440\u043E\u0442\u0435 \u0432\u0430\u0448\u0435\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B (\u043D\u043E\u043C\u0435\u0440 \u0434\u043B\u044F \u0442\u0435\u043A\u0441\u0442-\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432 (TTY): 711).",
    isRtlLanguage: false,
    languageCode: "ru"
  },
  {
    id: 19,
    title: "ESPA\xD1OL",
    description: "ATENCI\xD3N: Si usted habla espa\xF1ol, servicios de asistencia ling\xFC\xEDstica, de forma gratuita, est\xE1n disponibles para usted. Llame al n\xFAmero en la parte posterior de su tarjeta de identificaci\xF3n (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "es"
  },
  {
    id: 20,
    title: "TAGALOG",
    description: "ATENSYON: Kung nagsasalita ka ng Tagalog, may makukuha kang mga libreng serbisyong tulong sa wika. Tawagan ang numero sa likod ng iyong ID card (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "tl"
  },
  {
    id: 21,
    title: "\u0E44\u0E17\u0E22",
    description: "\u0E42\u0E1B\u0E23\u0E14\u0E17\u0E23\u0E32\u0E1A: \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E1E\u0E39\u0E14 \u0E44\u0E17\u0E22, \u0E21\u0E35\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E14\u0E49\u0E32\u0E19\u0E20\u0E32\u0E29\u0E32\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E48\u0E32\u0E43\u0E0A\u0E49\u0E08\u0E48\u0E32\u0E22 \u0E42\u0E17\u0E23\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E14\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E1A\u0E31\u0E15\u0E23\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E15\u0E31\u0E27\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E0A\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 (TTY: 711)",
    isRtlLanguage: false,
    languageCode: "th"
  },
  {
    id: 22,
    title: "\u0627\u0631\u062F\u0648",
    description: "\u062A\u0648\u062C\u06C1 \u0641\u0631\u0645\u0627\u0626\u06CC\u06BA: \u0627\u06AF\u0631 \u0622\u067E \u0627\u0631\u062F\u0648 \u0628\u0648\u0644\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u0632\u0628\u0627\u0646 \u0645\u0639\u0627\u0648\u0646\u062A \u0633\u0631\u0648\u0633\u060C \u0645\u0641\u062A \u0645\u06CC\u06BA \u0622\u067E \u06A9\u06D2 \u0644\u06CC\u06D2 \u062F\u0633\u062A\u06CC\u0627\u0628 \u06C1\u06D2\u06D4 \u0627\u067E\u0646\u06D2 \u0634\u0646\u0627\u062E\u062A\u06CC \u06A9\u0627\u0631\u0688 \u06A9\u06CC \u067E\u0634\u062A \u067E\u0631 \u062F\u0631\u062C \u0634\u062F\u06C1 \u0646\u0645\u0628\u0631 \u067E\u0631 \u06A9\u0627\u0644 \u06A9\u0631\u06CC\u06BA (TTY: 711)\u06D4",
    isRtlLanguage: true,
    languageCode: "ur"
  },
  {
    id: 23,
    title: "TI\u1EBENG VI\u1EC6T",
    description: "CH\xDA \xDD: N\u1EBFu qu\xFD v\u1ECB n\xF3i ti\u1EBFng Vi\u1EC7t, ch\xFAng t\xF4i cung c\u1EA5p d\u1ECBch v\u1EE5 h\u1ED7 tr\u1EE3 ng\xF4n ng\u1EEF mi\u1EC5n ph\xED cho qu\xFD v\u1ECB. Xin g\u1ECDi s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u1EDF m\u1EB7t sau th\u1EBB ID c\u1EE7a qu\xFD v\u1ECB (TTY: 711).",
    isRtlLanguage: false,
    languageCode: "vi"
  }
];

// src/pages/technical-assistance-and-all-languages.page.tsx
import { useHistory as useHistory7 } from "@leagueplatform/routing";
import {
  Box as Box16,
  HeadingText as HeadingText4,
  ParagraphText as ParagraphText6,
  StackLayout as StackLayout8,
  queryHelpers as queryHelpers3,
  useMediaQuery as useMediaQuery3,
  TextAction as TextAction2
} from "@leagueplatform/genesis-core";
import {
  PageHeaderBackground as PageHeaderBackground3,
  BackButtonArrow,
  MainPageContainer as MainPageContainer2
} from "@leagueplatform/web-common-components";
var AvailableLanguagesAndDescriptions = () => /* @__PURE__ */ React45.createElement(Box16, null, LANGUAGE_ASSISTANCE_TITLE_DESCRIPTIONS_CONFIG.map(
  ({ title, description, isRtlLanguage, id, languageCode }) => /* @__PURE__ */ React45.createElement(
    Box16,
    {
      key: id,
      dir: isRtlLanguage ? "rtl" : void 0,
      lang: languageCode
    },
    /* @__PURE__ */ React45.createElement(
      HeadingText4,
      {
        size: "sm",
        level: "3",
        css: {
          lineHeight: "$subtitleTwo",
          fontWeight: "bold",
          color: "$onSurfaceTextSubdued",
          marginTop: "$two"
        }
      },
      title
    ),
    /* @__PURE__ */ React45.createElement(
      ParagraphText6,
      {
        css: {
          color: "$onSurfaceTextSubdued"
        }
      },
      description
    )
  )
));
var BackButtonArrowCheck = ({ isPostAuth }) => {
  const history2 = useHistory7();
  const isMobile = useMediaQuery3(queryHelpers3.down("mobileLandscape"));
  if (!isPostAuth && !isMobile) {
    return /* @__PURE__ */ React45.createElement(
      BackButtonArrow,
      {
        onClick: () => history2.goBack(),
        marginRight: "two",
        marginTop: "quarter"
      }
    );
  }
  if (!isPostAuth && isMobile)
    return null;
  if (isPostAuth && !isMobile)
    return null;
  if (isPostAuth && isMobile) {
    return /* @__PURE__ */ React45.createElement(
      TextAction2,
      {
        onClick: () => history2.goBack(),
        as: "button",
        icon: "interfaceChevronLeft",
        css: {
          color: "$onSurfaceIconPrimary",
          marginBottom: "$half"
        }
      }
    );
  }
  return /* @__PURE__ */ React45.createElement(
    BackButtonArrow,
    {
      onClick: () => history2.goBack(),
      marginRight: "two",
      marginTop: "quarter"
    }
  );
};
var AssistanceAndLanguagePage = () => {
  const { formatMessage } = useIntl20();
  const { isAuthenticated } = useIsAuthenticated();
  const { eligibilityInfo } = useGetAppInitDetails({
    enabled: !!isAuthenticated
  });
  const isPostAuth = isAuthenticated && (eligibilityInfo == null ? void 0 : eligibilityInfo.eligible);
  return /* @__PURE__ */ React45.createElement(MainPageContainer2, null, /* @__PURE__ */ React45.createElement(PageHeaderBackground3, { pageHeaderBackgroundHeight: "184px" }, /* @__PURE__ */ React45.createElement(
    Box16,
    {
      css: {
        display: "flex",
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "$three",
        "@mobile": {
          display: "block"
        }
      }
    },
    /* @__PURE__ */ React45.createElement(BackButtonArrowCheck, { isPostAuth }),
    /* @__PURE__ */ React45.createElement(HeadingText4, { size: "xxl", level: "1" }, isPostAuth ? formatMessage({
      id: "ALL_LANGUAGES"
    }) : formatMessage({
      id: "TECHNICAL_ASSISTANCE_AND_ALL_LANGUAGES_TITLE"
    }))
  )), /* @__PURE__ */ React45.createElement(
    StackLayout8,
    {
      css: {
        marginTop: "60px",
        width: "100%"
      }
    },
    !isPostAuth && /* @__PURE__ */ React45.createElement(Box16, null, /* @__PURE__ */ React45.createElement(HeadingText4, { size: "lg", level: "2" }, formatMessage({ id: "TECHNICAL_SUPPORT" })), /* @__PURE__ */ React45.createElement(ParagraphText6, { css: { marginTop: "$one" } }, formatMessage({ id: "TECHNICAL_SUPPORT_DESCRIPTION" }))),
    /* @__PURE__ */ React45.createElement(HeadingText4, { size: "lg", level: "2", css: { marginY: "$two" } }, formatMessage({ id: "FOR_ASSISTANCE_WITH_LANGUAGES" })),
    /* @__PURE__ */ React45.createElement(Box16, null, /* @__PURE__ */ React45.createElement(AvailableLanguagesAndDescriptions, null))
  ));
};

// src/pages/hsa-page.component.tsx
import React49, { useEffect as useEffect15, useState as useState12 } from "react";
import {
  Box as Box20,
  Flex as Flex10,
  Image as Image14,
  PrimaryButton as PrimaryButton7,
  QuietButton as QuietButton5
} from "@leagueplatform/genesis-commons";
import { EVENT_NAME as EVENT_NAME7, trackAnalyticsEvent as trackAnalyticsEvent6 } from "@leagueplatform/analytics";
import { MainPageContainer as MainPageContainer3 } from "@leagueplatform/web-common-components";
import { useHistory as useHistory10 } from "@leagueplatform/routing";
import { useIntl as useIntl24 } from "@leagueplatform/locales";

// src/components/hsa/hsa-header.component.tsx
import * as React46 from "react";
import {
  Box as Box17,
  css as css4,
  Flex as Flex8,
  genesisStyled as genesisStyled6,
  HeadingOne as HeadingOne2,
  Link as Link4
} from "@leagueplatform/genesis-commons";
import { BackButtonArrow as BackButtonArrow2 } from "@leagueplatform/web-common-components";
import { useHistory as useHistory8 } from "@leagueplatform/routing";
import { useIntl as useIntl21 } from "@leagueplatform/locales";
import { queryHelpers as queryHelpers4, useMediaQuery as useMediaQuery4 } from "@leagueplatform/genesis-core";
var StyledTitleContainer = genesisStyled6(Box17)(
  css4({
    "&&": {
      borderBottomColor: "onSurface.border.subdued",
      borderBottomStyle: "solid",
      borderBottomWidth: "thick",
      flex: "1"
    }
  })
);
var HsaHeader = () => {
  const history2 = useHistory8();
  const { formatMessage } = useIntl21();
  const isMobile = useMediaQuery4(queryHelpers4.down("mobileLandscape"));
  if (isMobile) {
    return /* @__PURE__ */ React46.createElement(Box17, { marginTop: "one" }, /* @__PURE__ */ React46.createElement(
      BackButtonArrow2,
      {
        "data-testid": "back-button",
        onClick: () => history2.push("/home"),
        as: Link4
      }
    ), /* @__PURE__ */ React46.createElement(HeadingOne2, { marginY: "oneAndHalf" }, formatMessage({ id: "HSA_SUBHEADER" })));
  }
  return /* @__PURE__ */ React46.createElement(Flex8, { marginTop: "oneAndHalf", marginBottom: "three", width: "100%" }, /* @__PURE__ */ React46.createElement(
    BackButtonArrow2,
    {
      "data-testid": "back-button",
      onClick: () => history2.push("/home"),
      as: Link4,
      marginY: "quarter",
      marginRight: "one"
    }
  ), /* @__PURE__ */ React46.createElement(StyledTitleContainer, null, /* @__PURE__ */ React46.createElement(HeadingOne2, { marginBottom: "two" }, formatMessage({ id: "HSA_SUBHEADER" }))));
};

// src/components/hsa/hsa-body.component.tsx
import { BodyOne as BodyOne5, Box as Box18, Flex as Flex9, Image as Image12 } from "@leagueplatform/genesis-commons";
import * as React47 from "react";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
import SavingPiggyIcon from "./assets/icons/saving-piggy-dollars.svg";
import MedicalInstrumentIcon from "./assets/icons/medical-instrument-stethoscope.svg";
import BaggageIcon from "./assets/icons/baggage.svg";
var HsaBody = () => {
  const { formatMessage } = useIntl22();
  const hsaAdvantages = [
    {
      icon: /* @__PURE__ */ React47.createElement(
        Image12,
        {
          src: MedicalInstrumentIcon,
          width: "oneAndHalf",
          alt: formatMessage({ id: "MEDICAL_INSTRUMENT_ICON" })
        }
      ),
      contentId: "HSA_PAGE_ADVANTAGE_1"
    },
    {
      icon: /* @__PURE__ */ React47.createElement(
        Image12,
        {
          src: SavingPiggyIcon,
          alt: formatMessage({ id: "SAVING_PIGGY_ICON" }),
          width: "oneAndHalf"
        }
      ),
      contentId: "HSA_PAGE_ADVANTAGE_2"
    },
    {
      icon: /* @__PURE__ */ React47.createElement(
        Image12,
        {
          src: BaggageIcon,
          alt: formatMessage({ id: "BAGGAGE_ICON" }),
          width: "oneAndHalf"
        }
      ),
      contentId: "HSA_PAGE_ADVANTAGE_3"
    }
  ];
  return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(BodyOne5, null, formatMessage({ id: "HSA_PAGE_CONTENT_1" })), /* @__PURE__ */ React47.createElement(Box18, { marginY: "one" }, /* @__PURE__ */ React47.createElement(BodyOne5, { fontWeight: "bold", marginY: "half" }, formatMessage({ id: "HSA_PAGE_ADVANTAGE_HEADER" })), /* @__PURE__ */ React47.createElement(Box18, null, hsaAdvantages.map((advantage) => /* @__PURE__ */ React47.createElement(Flex9, { key: advantage.contentId, marginBottom: "one" }, /* @__PURE__ */ React47.createElement("span", null, advantage.icon), /* @__PURE__ */ React47.createElement(BodyOne5, { marginLeft: "one" }, formatMessage({ id: advantage.contentId })))))), /* @__PURE__ */ React47.createElement(BodyOne5, null, formatMessage({ id: "HSA_BODY" })));
};

// src/components/hsa/hsa-success-modal.component.tsx
import * as React48 from "react";
import {
  BodyOne as BodyOne6,
  Box as Box19,
  HeadingThree as HeadingThree2,
  Image as Image13,
  PrimaryButton as PrimaryButton6
} from "@leagueplatform/genesis-commons";
import { useHistory as useHistory9 } from "@leagueplatform/routing";
import { useIntl as useIntl23 } from "@leagueplatform/locales";
var HsaSuccessModal = ({ onClose, isOpen, image }) => {
  const history2 = useHistory9();
  const { formatMessage } = useIntl23();
  if (!isOpen)
    return null;
  return /* @__PURE__ */ React48.createElement(
    ModalWrapper,
    {
      onClose,
      modalLabel: formatMessage({ id: "HSA_MODAL_LABEL" })
    },
    /* @__PURE__ */ React48.createElement(Box19, { textAlign: "center" }, /* @__PURE__ */ React48.createElement(HeadingThree2, { id: "modalTitle", marginBottom: "oneAndHalf" }, formatMessage({ id: "HSA_MODAL_HEADER" })), /* @__PURE__ */ React48.createElement(Box19, null, /* @__PURE__ */ React48.createElement(
      Image13,
      {
        src: image,
        alt: formatMessage({ id: "HSA_ACCOUNT_CREATED" })
      }
    )), /* @__PURE__ */ React48.createElement(BodyOne6, { marginY: "oneAndHalf", textAlign: "left" }, formatMessage({ id: "HSA_MODAL_BODY" })), /* @__PURE__ */ React48.createElement(
      PrimaryButton6,
      {
        width: "100%",
        onClick: () => history2.push("/home"),
        "data-testid": "modal-okay-button"
      },
      formatMessage({ id: "OKAY" })
    ))
  );
};

// src/pages/hsa-page.component.tsx
import { TOAST_STATUS as TOAST_STATUS3, toastActions as toastActions3 } from "@leagueplatform/toast-messages";

// src/hooks/use-open-hsa-account.ts
import { useMutation as useMutation3, useQueryClient } from "react-query";

// src/api/post-hsa-enrollment.ts
var HSA_ENROLLMENT_API = "/v1/members/spending/hsa/enroll";
var postHsaEnrollment = (partnerAccessToken, hsaEligibility) => __async(void 0, null, function* () {
  const payload = {
    memberId: hsaEligibility.memberId,
    groupNumber: hsaEligibility.groupNumber,
    clientNumber: hsaEligibility.clientNumber
  };
  const response = yield highmarkFetch(HSA_ENROLLMENT_API, partnerAccessToken, {
    method: "POST",
    body: JSON.stringify(payload)
  });
  return response.json();
});

// src/hooks/use-open-hsa-account.ts
var useOpenHsaAccount = () => {
  const { data: identityTokenData } = useGetIdentityPartnerToken(DEFAULT_PARTNER_ID);
  const queryClient = useQueryClient();
  const { isSuccess, isLoading, isError, data, mutateAsync } = useMutation3(
    ["home", "hsa"],
    (hsaEligibility) => postHsaEnrollment(identityTokenData, hsaEligibility),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["GET_HSA_ELIGIBILITY" /* HSA_ELIGIBILITY_KEY */]
        });
      }
    }
  );
  const isValidSuccessResponse = (data == null ? void 0 : data.response) === "success" || (data == null ? void 0 : data.message) === "HSA-ENROLLINPROG";
  const isSuccessResponse = isSuccess && isValidSuccessResponse;
  const isErrorResponse = isError || isSuccess && !isValidSuccessResponse;
  return {
    isLoading,
    isError: isErrorResponse,
    isSuccess: isSuccessResponse,
    mutateAsync
  };
};

// src/pages/hsa-page.component.tsx
import { queryHelpers as queryHelpers5, useMediaQuery as useMediaQuery5 } from "@leagueplatform/genesis-core";
var HsaPage = ({
  openHsaImage,
  hsaAccountCreatedImage
}) => {
  const { formatMessage } = useIntl24();
  const history2 = useHistory10();
  const [showSuccessModal, setShowSuccessModal] = useState12(false);
  const {
    data: hsaEligibility,
    isLoading: isHsaLoading,
    isIdle: isHsaIdle
  } = useGetHsaRegistrationEligibility();
  const {
    isLoading: isRegistrationLoading,
    isError,
    isSuccess,
    mutateAsync
  } = useOpenHsaAccount();
  const isLargeScreen = useMediaQuery5(queryHelpers5.up("tablet"));
  useEffect15(() => {
    if (isSuccess) {
      setShowSuccessModal(true);
    }
    if (isError) {
      toastActions3.add({
        type: TOAST_STATUS3.ERROR,
        textId: "ERROR_DESCRIPTION_GENERIC"
      });
    }
  }, [isSuccess, isError]);
  if (!isHsaIdle && !isHsaLoading && !(hsaEligibility == null ? void 0 : hsaEligibility.isHsaRegistrationEligible)) {
    history2.push("/home");
    return null;
  }
  const handleRegisterHsaAction = () => {
    trackAnalyticsEvent6(EVENT_NAME7.BUTTON_CLICKED, {
      screen_name: "Open your HSA page",
      detail: "HSA Submit Enrollment"
    });
    mutateAsync(hsaEligibility);
  };
  return /* @__PURE__ */ React49.createElement(MainPageContainer3, { padding: { _: "one", tablet: "oneAndHalf" } }, /* @__PURE__ */ React49.createElement(HsaHeader, null), /* @__PURE__ */ React49.createElement(Flex10, { marginLeft: { _: "0", laptop: "three" } }, isLargeScreen && /* @__PURE__ */ React49.createElement(
    Image14,
    {
      src: openHsaImage,
      alt: "person holding piggy bank",
      height: "225px",
      width: "225px",
      marginRight: "three"
    }
  ), /* @__PURE__ */ React49.createElement(Box20, { marginLeft: { _: "none", tablet: "one" } }, /* @__PURE__ */ React49.createElement(HsaBody, null), /* @__PURE__ */ React49.createElement(
    Flex10,
    {
      justifyContent: "space-evenly",
      alignItems: "center",
      marginY: { _: "two", laptop: "five" },
      flexWrap: "wrap-reverse"
    },
    /* @__PURE__ */ React49.createElement(QuietButton5, { onClick: () => history2.push("/home") }, formatMessage({ id: "HSA_PAGE_CTA_SECONDARY" })),
    /* @__PURE__ */ React49.createElement(
      PrimaryButton7,
      {
        disabled: isHsaLoading || isHsaIdle || isRegistrationLoading,
        onClick: handleRegisterHsaAction,
        width: "328px"
      },
      formatMessage({ id: "HSA_CTA" })
    )
  ))), /* @__PURE__ */ React49.createElement(
    HsaSuccessModal,
    {
      onClose: () => {
        setShowSuccessModal(false);
        history2.push("/home");
      },
      isOpen: showSuccessModal,
      image: hsaAccountCreatedImage
    }
  ));
};

// src/pages/landing.page.tsx
import * as React50 from "react";
import { useEffect as useEffect16 } from "react";
import { useHistory as useHistory11 } from "@leagueplatform/routing";
import {
  BackgroundImage,
  Box as Box21,
  Flex as Flex11,
  Image as Image15,
  PrimaryButton as PrimaryButton8,
  Text as Text2
} from "@leagueplatform/genesis-commons";
import { useAuth as useAuth3 } from "@leagueplatform/auth-utils";
import landingPageImage from "./assets/landing-page-image.jpg";
var LandingImageBox = () => /* @__PURE__ */ React50.createElement(Box21, { flexDirection: "column", flex: { _: "0", tablet: "1" } }, /* @__PURE__ */ React50.createElement(
  BackgroundImage,
  {
    alt: "",
    src: landingPageImage,
    role: "presentation",
    "data-testid": "background-image",
    objectFit: "cover",
    height: { _: "40vh", tablet: "100vh" },
    backgroundPosition: { _: "50% 10%", tablet: "0 top" }
  }
));
var LandingPage = ({
  logo,
  landingGreeting,
  buttonText,
  authErrorText,
  footer
}) => {
  const history2 = useHistory11();
  const { isAuthenticated, error, appState } = useAuth3();
  useEffect16(() => {
    if (isAuthenticated) {
      if (appState == null ? void 0 : appState.redirectPath) {
        const [path, ...search] = appState.redirectPath.split("?");
        history2.push({
          pathname: path,
          search: search.join("?")
        });
      } else {
        history2.push({
          pathname: "/home"
        });
      }
    }
  }, [history2, isAuthenticated, appState]);
  useEffect16(() => {
    if (error) {
      captureAuthenticationError(error);
    }
  }, [error]);
  return /* @__PURE__ */ React50.createElement(
    Box21,
    {
      as: "main",
      position: "relative",
      flex: "1",
      textAlign: "center",
      minHeight: "100vh"
    },
    isAuthenticated === void 0 ? /* @__PURE__ */ React50.createElement(LoadingSpinner, null) : /* @__PURE__ */ React50.createElement(Flex11, { height: "100vh", flexDirection: { _: "column", tablet: "row" } }, /* @__PURE__ */ React50.createElement(LandingImageBox, null), /* @__PURE__ */ React50.createElement(
      Flex11,
      {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flex: "1"
      },
      /* @__PURE__ */ React50.createElement(
        Flex11,
        {
          maxWidth: "350px",
          alignSelf: "center",
          flexDirection: "column",
          margin: "1rem auto",
          flex: "1",
          justifyContent: "center"
        },
        /* @__PURE__ */ React50.createElement(
          Image15,
          {
            src: logo,
            alt: "logo",
            maxHeight: { _: "100px", phone: "120px" }
          }
        ),
        /* @__PURE__ */ React50.createElement(Text2, { fontSize: "body1", marginY: "twoAndHalf", paddingX: "35px" }, landingGreeting),
        isAuthenticated === false && /* @__PURE__ */ React50.createElement(
          PrimaryButton8,
          {
            maxWidth: "327px",
            width: "100%",
            alignSelf: "center",
            onClick: () => clearHighmarkSessionRedirect("/sign-in")
          },
          buttonText
        ),
        error && /* @__PURE__ */ React50.createElement(Text2, { color: "onSurface.text.critical" }, authErrorText)
      ),
      /* @__PURE__ */ React50.createElement(
        Box21,
        {
          paddingBottom: { _: "two", tablet: "three", desktop: "four" },
          width: "100%",
          margin: "0 auto"
        },
        footer
      )
    ))
  );
};

// src/pages/masonry/masonry-container.page.tsx
import React51 from "react";
import { MainPageContainer as MainPageContainer4 } from "@leagueplatform/web-common-components";
var MasonryPageContainer = ({
  children
}) => /* @__PURE__ */ React51.createElement(
  MainPageContainer4,
  {
    padding: "none",
    paddingX: { _: "oneAndHalf", phone: "two" },
    paddingBottom: { _: "oneAndHalf", phone: "two" }
  },
  children
);

// src/pages/masonry/support/support.page.tsx
import Masonry from "@leagueplatform/masonry";
import { SCREEN_NAMES as SCREEN_NAMES3, usePageViewAnalytics } from "@leagueplatform/analytics";
import React52 from "react";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { useIntl as useIntl25 } from "@leagueplatform/locales";
var SupportPageMasonry = Masonry.init({
  appId: MASONRY.APP_ID_SUPPORT_PAGE,
  analytics: {
    productArea: SCREEN_NAMES3.SUPPORT,
    screenName: SCREEN_NAMES3.SUPPORT
  },
  uiConfig: {
    CustomLoader: () => /* @__PURE__ */ React52.createElement(LoadingSpinner, null)
  },
  apiVersion: MASONRY.API_VERSION
});
var SupportPage = () => {
  usePageViewAnalytics({ screen_name: SCREEN_NAMES3.SUPPORT });
  const { formatMessage } = useIntl25();
  useDocumentTitle(formatMessage({ id: "SUPPORT_PAGE" }));
  return /* @__PURE__ */ React52.createElement(MasonryPageContainer, null, /* @__PURE__ */ React52.createElement(SupportPageMasonry.Provider, null));
};

// src/pages/legal/legal.page.tsx
import React56 from "react";
import {
  StackLayout as StackLayout12,
  queryHelpers as queryHelpers9,
  useMediaQuery as useMediaQuery9
} from "@leagueplatform/genesis-core";
import { Route, Switch, useRouteMatch as useRouteMatch3 } from "@leagueplatform/routing";

// src/pages/legal/legal-sidebar/legal-sidebar.component.tsx
import React53, { useEffect as useEffect17 } from "react";
import {
  Box as Box22,
  queryHelpers as queryHelpers6,
  StackLayout as StackLayout9,
  TextAction as TextAction3,
  useMediaQuery as useMediaQuery6
} from "@leagueplatform/genesis-core";
import {
  InternalOrExternalLink as InternalOrExternalLink2,
  LoadingIndicator
} from "@leagueplatform/web-common-components";
import {
  useHistory as useHistory12,
  useLocation as useLocation3,
  useRouteMatch as useRouteMatch2
} from "@leagueplatform/routing";
import { isAbsoluteUrl as isAbsoluteUrl2 } from "@leagueplatform/web-common";
import Masonry2 from "@leagueplatform/masonry";
import {
  useGetWidgetData as useGetWidgetData2
} from "@leagueplatform/masonry-api";
var LegalLink = ({ widget }) => {
  var _a, _b, _c, _d, _e, _f;
  const { data, isLoading, error } = useGetWidgetData2(
    widget,
    MASONRY.API_VERSION
  );
  const { path } = useRouteMatch2();
  const location = useLocation3();
  const history2 = useHistory12();
  const isMobile = useMediaQuery6(queryHelpers6.down("tablet"));
  useEffect17(() => {
    var _a2, _b2, _c2;
    const searchParams = new URLSearchParams(location.search);
    if (!isMobile && ((_a2 = data == null ? void 0 : data.attributes) == null ? void 0 : _a2.link_url) && ((_b2 = data == null ? void 0 : data.attributes) == null ? void 0 : _b2.focused) && !searchParams.get(LEGAL_DETAILS_QUERY_PARAM_KEY)) {
      history2.push((_c2 = data == null ? void 0 : data.attributes) == null ? void 0 : _c2.link_url);
    }
  }, [location, history2, isMobile, path, data]);
  if (isLoading || error || !((_a = data == null ? void 0 : data.attributes) == null ? void 0 : _a.link_url)) {
    return null;
  }
  const isActive = location.pathname.includes(APP_MANAGED_ROUTES.LEGAL_DETAILS_SUBPATH) && location.search.includes(LEGAL_DETAILS_QUERY_PARAM_KEY) && ((_c = (_b = data == null ? void 0 : data.attributes) == null ? void 0 : _b.link_url) == null ? void 0 : _c.includes(location.search)) && !isMobile;
  return /* @__PURE__ */ React53.createElement(Box22, null, /* @__PURE__ */ React53.createElement(InternalOrExternalLink2, { href: (_d = data == null ? void 0 : data.attributes) == null ? void 0 : _d.link_url }, /* @__PURE__ */ React53.createElement(
    TextAction3,
    {
      as: "span",
      indicator: isAbsoluteUrl2((_e = data == null ? void 0 : data.attributes) == null ? void 0 : _e.link_url) && "externalLink",
      css: {
        padding: isMobile ? "$half none" : "$half $one",
        color: isActive ? "$onSurfaceTextPrimary" : "$interactiveActionPrimary",
        borderLeft: isActive ? "medium solid $interactiveActionPrimary" : "none"
      }
    },
    (_f = data == null ? void 0 : data.attributes) == null ? void 0 : _f.heading
  )));
};
var LegalMasonry = Masonry2.init({
  apiVersion: MASONRY.API_VERSION,
  appId: "hm_legal",
  analytics: {
    productArea: "legal screen",
    screenName: "legal screen"
  },
  uiConfig: {
    CustomLoader: () => /* @__PURE__ */ React53.createElement(StackLayout9, { css: { position: "relative" } }, /* @__PURE__ */ React53.createElement(LoadingIndicator, null))
  },
  customWidgetModules: [
    {
      moduleKey: MASONRY.MODULE_KEY_CUSTOM_WIDGETS,
      customWidgetsUI: [
        {
          type: "hm_legal_link",
          widget: ({ widget }) => /* @__PURE__ */ React53.createElement(LegalLink, { widget })
        }
      ]
    }
  ]
});
var LegalSidebar = () => /* @__PURE__ */ React53.createElement(
  Box22,
  {
    css: {
      minWidth: "320px",
      " > div": {
        gap: "$threeQuarters"
      }
    }
  },
  /* @__PURE__ */ React53.createElement(LegalMasonry.Provider, null)
);

// src/pages/legal/legal-content-container/legal-content.component.tsx
import React55 from "react";
import {
  HeadingText as HeadingText6,
  StackItem as StackItem3,
  StackLayout as StackLayout11,
  queryHelpers as queryHelpers8,
  useMediaQuery as useMediaQuery8
} from "@leagueplatform/genesis-core";

// src/components/page-header-mobile/page-header-mobile.component.tsx
import React54, { useRef as useRef3, useState as useState13, useEffect as useEffect18, useLayoutEffect } from "react";
import {
  Box as Box23,
  HeadingText as HeadingText5,
  StackItem as StackItem2,
  StackLayout as StackLayout10,
  TextAction as TextAction4,
  queryHelpers as queryHelpers7,
  useMediaQuery as useMediaQuery7
} from "@leagueplatform/genesis-core";
import { PageHeaderBackground as PageHeaderBackground4 } from "@leagueplatform/web-common-components";
import { useHistory as useHistory13 } from "@leagueplatform/routing";
import { useIntl as useIntl26 } from "@leagueplatform/locales";
var PageHeaderMobile = ({
  headingId,
  headingText,
  showBackButton = true
}) => {
  const history2 = useHistory13();
  const { formatMessage } = useIntl26();
  const contentRef = useRef3(null);
  const [contentHeight, setContentHeight] = useState13(100);
  const isLaptopDown = useMediaQuery7(queryHelpers7.down("laptop"));
  const pageHeaderBackgroundHeightPadding = isLaptopDown ? 60 : 112;
  useLayoutEffect(() => {
    const reportWindowSize = () => {
      var _a, _b;
      setContentHeight((_b = (_a = contentRef == null ? void 0 : contentRef.current) == null ? void 0 : _a.clientHeight) != null ? _b : contentHeight);
    };
    if (contentHeight !== void 0)
      window.addEventListener("resize", reportWindowSize);
    return () => window.removeEventListener("resize", reportWindowSize);
  }, [contentHeight]);
  useEffect18(() => {
    var _a;
    if ((_a = contentRef == null ? void 0 : contentRef.current) == null ? void 0 : _a.clientHeight)
      setContentHeight(contentRef.current.clientHeight);
  }, []);
  return /* @__PURE__ */ React54.createElement(
    Box23,
    {
      css: {
        marginTop: "$two",
        marginBottom: "$two",
        "@laptop": {
          marginTop: "56px",
          marginBottom: "56px"
        },
        "@desktop": {
          marginTop: "56px",
          marginBottom: "56px"
        }
      }
    },
    /* @__PURE__ */ React54.createElement(
      PageHeaderBackground4,
      {
        height: `${contentHeight + pageHeaderBackgroundHeightPadding / 2}px`,
        pageHeaderBackgroundHeight: `${contentHeight + pageHeaderBackgroundHeightPadding}px`
      },
      /* @__PURE__ */ React54.createElement(StackLayout10, null, /* @__PURE__ */ React54.createElement(
        StackItem2,
        {
          horizontalAlignment: "start",
          verticalAlignment: "top",
          ref: contentRef
        },
        showBackButton && /* @__PURE__ */ React54.createElement(
          TextAction4,
          {
            onClick: () => history2.goBack(),
            as: "button",
            icon: "interfaceChevronLeft",
            css: {
              color: "$onSurfaceIconPrimary",
              marginBottom: "$half"
            }
          }
        ),
        headingText || headingId ? /* @__PURE__ */ React54.createElement(
          HeadingText5,
          {
            level: "1",
            size: {
              "@initial": "xl",
              "@laptop": "xxl",
              "@desktop": "xxl"
            }
          },
          headingText || (headingId ? formatMessage({ id: headingId }) : "")
        ) : /* @__PURE__ */ React54.createElement(Box23, { css: { height: "$three" } })
      ))
    )
  );
};

// src/pages/legal/legal-content-container/legal-content.component.tsx
import {
  ErrorState as ErrorState2,
  LoadingIndicator as LoadingIndicator2
} from "@leagueplatform/web-common-components";
import { HtmlToReact } from "@leagueplatform/web-common";

// src/pages/legal/legal-content-container/use-legal-content.hook.tsx
import { useUrlParam as useUrlParam4 } from "@leagueplatform/web-common";

// src/api/get-content-mapping.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
import { deserialise } from "kitsu-core";
var CONTENT_MAPPING_PATH = "/v1/content-mapping";
var getContentMapping = (contentId) => __async(void 0, null, function* () {
  const response = yield leagueFetch(`${CONTENT_MAPPING_PATH}/${contentId}`);
  if (!(response == null ? void 0 : response.ok)) {
    throw new Error(
      `Error Response Code ${response == null ? void 0 : response.status}: ${yield response.text()}`
    );
  }
  return deserialise(yield response.json());
});

// src/pages/legal/legal-content-container/use-legal-content.hook.tsx
import { useQuery as useQuery7 } from "react-query";
var GET_LEGAL_DETAILS_QUERY_KEY = "get_legal_details_query_key";
var useLegalContent = () => {
  const { urlParam } = useUrlParam4("id");
  return useQuery7(
    [GET_LEGAL_DETAILS_QUERY_KEY, urlParam],
    () => urlParam ? getContentMapping(urlParam) : null,
    {
      enabled: !!urlParam,
      select: (data) => {
        var _a, _b, _c, _d;
        return {
          title: (_b = (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.content) == null ? void 0 : _b.name,
          body: (_d = (_c = data == null ? void 0 : data.data) == null ? void 0 : _c.content) == null ? void 0 : _d.richText
        };
      }
    }
  );
};

// src/pages/legal/legal-content-container/legal-content.component.tsx
var LegalContent = () => {
  const isMobile = useMediaQuery8(queryHelpers8.down("tablet"));
  const { data, isLoading, isError } = useLegalContent();
  if (isLoading || isError) {
    return /* @__PURE__ */ React55.createElement(StackLayout11, null, /* @__PURE__ */ React55.createElement(PageHeaderMobile, { showBackButton: isMobile }), /* @__PURE__ */ React55.createElement(
      StackLayout11,
      {
        horizontalAlignment: "center",
        css: { minHeight: "50vh", width: "100%", position: "relative" }
      },
      isLoading && /* @__PURE__ */ React55.createElement(LoadingIndicator2, null),
      isError && /* @__PURE__ */ React55.createElement(ErrorState2, null)
    ));
  }
  if (isMobile) {
    return /* @__PURE__ */ React55.createElement(StackLayout11, null, /* @__PURE__ */ React55.createElement(PageHeaderMobile, { headingText: data == null ? void 0 : data.title }), /* @__PURE__ */ React55.createElement(StackItem3, { css: { marginTop: "$two" } }, /* @__PURE__ */ React55.createElement(HtmlToReact, { htmlString: data == null ? void 0 : data.body })));
  }
  return /* @__PURE__ */ React55.createElement(StackLayout11, null, /* @__PURE__ */ React55.createElement(PageHeaderMobile, { showBackButton: false }), /* @__PURE__ */ React55.createElement(
    StackLayout11,
    {
      spacing: "$one",
      css: {
        "@desktop": {
          marginTop: "$half"
        }
      }
    },
    /* @__PURE__ */ React55.createElement(HeadingText6, { level: "1", size: { "@initial": "xxl", "@mobile": "xl" } }, data == null ? void 0 : data.title),
    /* @__PURE__ */ React55.createElement(
      StackItem3,
      {
        css: {
          marginY: "$one",
          "@desktop": {
            paddingRight: "$two"
          }
        }
      },
      /* @__PURE__ */ React55.createElement(HtmlToReact, { htmlString: data == null ? void 0 : data.body })
    )
  ));
};

// src/pages/legal/legal.page.tsx
var LegalPage = () => {
  const isMobile = useMediaQuery9(queryHelpers9.down("tablet"));
  const { path } = useRouteMatch3();
  if (isMobile) {
    return /* @__PURE__ */ React56.createElement(MasonryPageContainer, null, /* @__PURE__ */ React56.createElement(Switch, null, /* @__PURE__ */ React56.createElement(Route, { path, exact: true }, /* @__PURE__ */ React56.createElement(LegalSidebar, null)), /* @__PURE__ */ React56.createElement(Route, { path: `${path}${APP_MANAGED_ROUTES.LEGAL_DETAILS_SUBPATH}` }, /* @__PURE__ */ React56.createElement(LegalContent, null))));
  }
  return /* @__PURE__ */ React56.createElement(MasonryPageContainer, null, /* @__PURE__ */ React56.createElement(
    StackLayout12,
    {
      orientation: "horizontal",
      spacing: { "@desktop": "$two" },
      horizontalAlignment: "spaceBetween"
    },
    /* @__PURE__ */ React56.createElement(LegalSidebar, null),
    /* @__PURE__ */ React56.createElement(Route, { path: `${path}${APP_MANAGED_ROUTES.LEGAL_DETAILS_SUBPATH}` }, /* @__PURE__ */ React56.createElement(LegalContent, null))
  ));
};

// src/utils/init-firebase-remote-config.ts
import { getRemoteConfig } from "firebase/remote-config";
var initFirebaseRemoteConfig = ({
  firebaseApp,
  defaultValues,
  minimumFetchIntervalMillis
}) => {
  const remoteConfig = getRemoteConfig(firebaseApp);
  remoteConfig.defaultConfig = defaultValues;
  if (minimumFetchIntervalMillis) {
    remoteConfig.settings.minimumFetchIntervalMillis = minimumFetchIntervalMillis;
  }
  return remoteConfig;
};

// src/utils/inject-cobrowse-initiator.ts
var injectCobrowseInitiator = () => {
  const gliaVisitorTriggerElement = document.createElement("sm-visitor-code");
  document.body.appendChild(gliaVisitorTriggerElement);
};

// src/index.ts
initModule();
export {
  APP_MANAGED_ROUTES,
  APP_NAV_DEFAULT_HEIGHT,
  APP_NAV_MOBILE_HEIGHT,
  AUTH0_CLIENT_CONNECTION,
  AUTHED_WEBVIEW_URL_NAMES,
  AboutPage,
  AssistanceAndLanguagePage,
  AuthSessionContainer,
  AuthSignIn,
  AuthSignOut,
  AuthedWebviewModal,
  BENEFIT_IDS,
  BasePathRedirect,
  CONTENT_ROUTES,
  CSAuthSessionContainer,
  CSAuthSignIn,
  CSAuthSignOut,
  CS_AUTH0_CLIENT_CONNECTION,
  DEFAULT_PARTNER_ID,
  Disclaimer,
  ERROR_TYPES,
  ErrorState,
  FEATURE_FLAGS,
  Footer,
  FooterLinkItems,
  FullPageLoadingSpinner,
  FullScreenContainer,
  GarbageBin,
  GetAssistanceSection,
  HSA_ELIGIBILITY_STATUS,
  HomeCardComponent,
  HsaPage,
  HsaPendingBanner,
  HsaPendingBannerWidget,
  HsaSection,
  INELIGIBLE_CODES,
  IframeModal,
  JourneyHeaderBackground,
  LINK_TYPES,
  LandingPage,
  LegalPage,
  LinkHandler,
  LinkHandlerClass,
  LinkType,
  LoadingSpinner,
  MASONRY,
  MasonryPageContainer,
  MfaEnrollment,
  ModalWrapper,
  NavIds,
  NavLinkWrapper,
  Navbar,
  PageBlockerContainer,
  PageEligibilityContext,
  QUERY_KEYS,
  QUERY_PARAM_KEYS,
  QueryParamModal,
  ResponsiveUserDropdown,
  SSO_READY_LISTENER_TIMEOUT,
  SSO_URL_NAMES,
  StatusBannerMasonryWidget,
  SupportPage,
  WEBVIEW_MODAL_QUERY_PARAM_VALUE,
  WalkthroughLayout,
  buildSsoUrl,
  clearHighmarkSessionRedirect,
  createLiveChatClient,
  getAuthedWebviewUrl,
  getSsoUrl,
  getTestConfigFlags,
  getTrustedTargetSsoOrigins,
  highmarkCommon,
  highmarkFetch,
  initFirebaseRemoteConfig,
  injectCobrowseInitiator,
  sendPartnerAuthToken,
  useHighmarkAnalyticsIdentify as useAnalyticsIdentify,
  useAuthedWebviewModal,
  useErrorMessage,
  useFetchAndActivate,
  useGetAppInitDetails,
  useGetEBillEligibility,
  useGetFeatureFlag,
  useGetIdentityPartnerToken,
  useGetHighmarkUserProfile as useGetUserProfile,
  useInjectCobrowseScript,
  useIsAuthenticated,
  useMobileAppDownloadLinks,
  useNamedGreeting,
  useNavLinksList,
  usePreferredFirstName,
  usePrivateRoutesContainer,
  useSsoDeepLink,
  useTestConfigFlags,
  useUserDropdown
};
//# sourceMappingURL=index.js.map